import LoadingComponent from "common/LoadingComponent";
import BoltSealLogList from "components/Account/BoltSealLog";
import AddOrUpdateBoltSealLog from "components/Account/BoltSealLog/AddOrUpdateBoltSealLog";
import CommercialPackingRequirement from "components/Account/CommercialPackingRequirement";
import CommercialPackingRequirementUpdate from "components/Account/CommercialPackingRequirement/update";
import CommercialPackingRequirementView from "components/Account/CommercialPackingRequirement/view";
import DriverInformation from "components/Account/DriverInformation";
import ImportVehicleInformation from "components/Account/ImportVehicleInformation";
import ImportVehicleInformationForm from "components/Account/ImportVehicleInformation/ImportVehicleInformationForm";
import VehicleInformation from "components/Account/VehicleInformation";
import Accounts from "components/Accounts";
import AppDashboard from "components/AppDashboard";
import AppDashboardLine from "components/AppDashboard/AppDashboardLine";
import CategoryWiseDefect from "components/AppDashboard/CategoryWiseDefect";
import CategoryWiseHourlyDefect from "components/AppDashboard/CategoryWiseHourlyDefect";
import DefectTracker from "components/AppDashboard/DefectTracker";
import OperatorWiseDefect from "components/AppDashboard/OperatorWiseDefect";
import ProductionSummary from "components/AppDashboard/ProductionSummary";
import ProductionTracker from "components/AppDashboard/ProductionTracker";
import RecommendationAgainstDefects from "components/AppDashboard/RecommendationAgainstDefects";
import ResponsibleForDefects from "components/AppDashboard/ResponsibleForDefects";
import AuditDate from "components/AuditDate";
import Banks from "components/Banks";
import Branches from "components/Branches";
import SpecialProcess from "components/BuyerInquiry/SpecialProcess";
import BuyerInspectionDate from "components/BuyerInspectionDate";
import BuyerVisitDate from "components/BuyerVisitDate";
import CapacityBookingSpecialProcess from "components/CapacityBooking/SpecialProcess";
import CapacityBookings from "components/CapacityBookings";
import CapacityBookingsReport from "components/CapacityBookingsReport";
import CapacityOfSampleTeam from "components/CapacityOfSampleTeam";
import GarmentsPartsConfig from "components/Configuration/GarmentsPartsConfig";
import StockLotConfigs from "components/Configuration/StockLotConfigs";
import BuyerWiseChecklist from "components/Digitalization/BuyerWiseChecklist";
import BuyerWiseChecklistView from "components/Digitalization/BuyerWiseChecklist/view";
import ChecklistQuestionsList from "components/Digitalization/Checklist/ChecklistQuestions";
import ChecklistQuestionsAdd from "components/Digitalization/Checklist/ChecklistQuestions/Add";
import ChecklistQuestionsEdit from "components/Digitalization/Checklist/ChecklistQuestions/Edit";
import DailyFinishingLinePlan from "components/Digitalization/DailyFinishingLinePlan";
import DailyFinishingLinePlanAdd from "components/Digitalization/DailyFinishingLinePlan/Add";
import DailyFinishingLinePlanEdit from "components/Digitalization/DailyFinishingLinePlan/Edit";
import DailyLinePlanList from "components/Digitalization/DailyLinePlan";
import DailyLinePlanAdd from "components/Digitalization/DailyLinePlan/Add";
import DailyLinePlanEdit from "components/Digitalization/DailyLinePlan/Edit";
import HourlyIron from "components/Digitalization/Finishing/hourly-iron";
import UpdateFinishingHourlyIron from "components/Digitalization/Finishing/hourly-iron/UpdateFinishingHourlyIron";
import SewingToFolding from "components/Digitalization/Finishing/sewing-to-folding";
import UpdateSewingToFolding from "components/Digitalization/Finishing/sewing-to-folding/UpdateSewingToFolding";
import FinishingLine from "components/Digitalization/FinishingLine";
import FinishingLineMapping from "components/Digitalization/FinishingLineMapping";
import GarmentsTracking from "components/Digitalization/GarmentsTracking";
import UpdateGarmentsTracking from "components/Digitalization/GarmentsTracking/UpdateGarmentsTracking";
import HourPage from "components/Digitalization/Hour";
import HourlyProductionRecordHourPage from "components/Digitalization/HourlyProductionRecordHours";
import LineWiseDefectsDHU from "components/Digitalization/LineWiseDefectsDHU";
import MachineIssues from "components/Digitalization/MachineIssues";
import MachineConfigForm from "components/Digitalization/MachineMaintenace/Configurations/ConfigForm";
import MaintenaceConfig from "components/Digitalization/MachineMaintenace/Configurations/MachineMaintenaceConfig";
import MachineInformation from "components/Digitalization/MachineMaintenace/MachineInformation";
import MachineInformationForm from "components/Digitalization/MachineMaintenace/MachineInformation/MachineInformationForm";
import MechanicUser from "components/Digitalization/MachineMaintenace/MechanicUser";
import FailedItems from "components/Digitalization/OfflineSyncLogs/FailedItems";
import FailedItemsView from "components/Digitalization/OfflineSyncLogs/FailedItems/view";
import OperationHourlyProduction from "components/Digitalization/OperationHourlyProduction/Index";
import OperatorAbsenteeism from "components/Digitalization/OperatorAbsenteeism";
import OperatorAbsenteeismView from "components/Digitalization/OperatorAbsenteeism/view";
import OperatorEfficiency from "components/Digitalization/OperatorEfficiency/Index";
import AuditReport from "components/Digitalization/AuditReport";
import AuditReportView from "components/Digitalization/AuditReport/view";
import QcValidationReport from "components/Digitalization/QcValidationReport";
import QcValidationReportView from "components/Digitalization/QcValidationReport/view";
import SewingLineDefect from "components/Digitalization/SewingLineDefect";
import SewingLineDefectMonthly from "components/Digitalization/SewingLineDefectMonthly";
import OperatorHourlyProduction from "components/Digitalization/OperatorHourlyProduction/Index";
import RemedyLogs from "components/Digitalization/ProblemRemedy/Remedy Logs";
import ProductionDefect from "components/Digitalization/ProductionDefect";
import ProductionDefectView from "components/Digitalization/ProductionDefect/view";
import SamJustification from "components/Digitalization/SamJustification";
import SupervisorChecklist from "components/Digitalization/SupervisorChecklist";
import SupervisorChecklistView from "components/Digitalization/SupervisorChecklist/view";
import User from "components/Digitalization/User";
import FoldingToPacking from "components/Digitalization/packing/folding-to-packing";
import UpdateFoldingToPacking from "components/Digitalization/packing/folding-to-packing/UpdateFoldingToPacking";
import PackingAssignmentList from "components/Digitalization/packing/packing-assignment";
import AddOrUpdatePackingAssignment from "components/Digitalization/packing/packing-assignment/AddOrUpdate";
import ERPUsageDashboard from "components/ERPUsage/Dashboard";
import ERPUsageIssue from "components/ERPUsage/Issue";
import ERPUsageModule from "components/ERPUsage/Module";
import ERPUsageModuleUi from "components/ERPUsage/ModuleUi";
import FabricLoadingCapacityOfStore from "components/FabricLoadingCapacityOfStore";
import ExportAndSummary from "components/ImportExportExpenseTracking/ExportAndSummary";
import ExportInvoiceExpense from "components/ImportExportExpenseTracking/ExportInvoiceExpense";
import ExportInvoiceExpenseCreate from "components/ImportExportExpenseTracking/ExportInvoiceExpense/Create";
import ExportInvoiceExpenseUpdate from "components/ImportExportExpenseTracking/ExportInvoiceExpense/Update";
import ExportInvoiceExpenseView from "components/ImportExportExpenseTracking/ExportInvoiceExpense/View";
import ImportDetailsReport from "components/ImportExportExpenseTracking/ImportDetails";
import ImportInvoiceExpense from "components/ImportExportExpenseTracking/ImportInvoiceExpense";
import ImportInvoiceExpenseCreate from "components/ImportExportExpenseTracking/ImportInvoiceExpense/Create";
import ImportInvoiceExpenseUpdate from "components/ImportExportExpenseTracking/ImportInvoiceExpense/Update";
import ImportInvoiceExpenseView from "components/ImportExportExpenseTracking/ImportInvoiceExpense/View";
import ImportLcExpense from "components/ImportExportExpenseTracking/ImportLcExpense";
import ImportLcExpenseCreate from "components/ImportExportExpenseTracking/ImportLcExpense/Create";
import ImportLcExpenseUpdate from "components/ImportExportExpenseTracking/ImportLcExpense/Update";
import ImportLcExpenseView from "components/ImportExportExpenseTracking/ImportLcExpense/View";
import SalesContractExpense from "components/ImportExportExpenseTracking/SalesContractExpense";
import SalesContractExpenseCreate from "components/ImportExportExpenseTracking/SalesContractExpense/Create";
import SalesContractExpenseUpdate from "components/ImportExportExpenseTracking/SalesContractExpense/Update";
import SalesContractExpenseView from "components/ImportExportExpenseTracking/SalesContractExpense/View";
import CreateTrimsInventory from "components/InventoryTrims/CreateTrimsInventory";
import ItemType from "components/ItemType";
import InitialSAMEntry from "components/Merchandising/InitialSAMEntry";
import OTSignal from "components/OTSignal";
import OperationBulletinShow from "components/OperationBulletin/Show";
import OvertimeReasons from "components/OvertimeReasons";
import OvertimeSignals from "components/OvertimeSignals";
import CPM from "components/PNLReport/CPM";
import DailyProfitLossSummary from "components/PNLReport/DailyProfitLossSummary";
import Efficiency from "components/PNLReport/Efficiency";
import HROTExpenseData from "components/PNLReport/HROTExpenseData";
import IPRMMD from "components/PNLReport/IPRMMD";
import PerformanceFolding from "components/PNLReport/PerformanceFolding";
import ProfitLossAccount from "components/PNLReport/ProfitLossAccount";
import SewingProfitLoss from "components/PNLReport/SewingProfitLoss";
import TargetVsAchievement from "components/PNLReport/TargetVsAchievement";
import POWiseBreakdown from "components/POWiseBreakdown";
import UpdatePOWiseBreakdown from "components/POWiseBreakdown/AddOrUpdateStyle/Update";
import ViewPOWiseBreakdown from "components/POWiseBreakdown/AddOrUpdateStyle/View";
import AddPOWiseBreakdown from "components/POWiseBreakdown/AddOrUpdateStyle/create";
import Assignment from "components/Production/Assignment";
import AssignmentEntry from "components/Production/Assignment/CreateForm";
import Cutting from "components/Production/Cutting";
import CreateCuttingEntry from "components/Production/Cutting/CreateForm";
import UpdateCutting from "components/Production/Cutting/UpdateForm";
import CreateCuttingItemEntry from "components/Production/CuttingItem/CreateForm";
import DailyLineTarget from "components/Production/DailyLineTarget";
import FabricAccessoriesAutoReconciliation from "components/Production/FabricAccessoriesAutoReconciliation";
import Folding from "components/Production/Folding";
import CreateFoldingEntry from "components/Production/Folding/CreateForm";
import UpdateFolding from "components/Production/Folding/UpdateForm";
import CreatePackingEntry from "components/Production/Packing/CreateForm";
import PackingConfirmation from "components/Production/Packing/PackingConfirmation";
import PackingReqList from "components/Production/PackingReq/PackingReqList";
import ViewPackingReq from "components/Production/PackingReq/ViewPackingReq";
import PostCuttingProcess from "components/Production/PostCuttingProcess";
import PostCuttingProcessEntry from "components/Production/PostCuttingProcess/CreateForm";
import UpdatePostCutting from "components/Production/PostCuttingProcess/UpdateForm";
import StoreRequisition from "components/Production/StoreRequisition";
import StoreRequisitionEntry from "components/Production/StoreRequisition/CreateForm";
import StoreRequisitionUpdate from "components/Production/StoreRequisition/UpdateForm";
import StoreRequisitionView from "components/Production/StoreRequisition/ViewForm";
import PostSewingProcess from "components/Production/PostSewingProcess";
import PostSewingProcessEntry from "components/Production/PostSewingProcess/CreateForm";
import UpdatePostSewing from "components/Production/PostSewingProcess/UpdateForm";
import { default as Sewing, default as SewingNew } from "components/Production/Sewing";
import { default as AddSewing, default as SewingCreate } from "components/Production/Sewing/SewingCreate";
import SewingUpdate from "components/Production/Sewing/SewingUpdate";
import ProductionPlanning from "components/ProductionPlanning";
import ProductionPlanningDashboard2 from "components/ProductionPlanning/Dashboard2";
import PPAnalysisReport from "components/ProductionPlanning/PPAnalysisReport";
import ProductionPlanningList from "components/ProductionPlanning/ProductionPlanningList";
import PlanningReport from "components/ProductionPlanning/PlanningReport";
import BoltSealReport from "components/Report/BoltSealReport";
import BuyerPackingReport from "components/Report/BuyerPackingReport";
import OSRReport from "components/Report/OSRReport";
import PostCostingReport from "components/Report/PostCostingReport";
import SalesContractPOS from "components/Report/SalesContractPOS";
import SwingvsFolding from "components/Report/SwingvsFoldingReport";
import AbsenteeismReport from "components/Report/AbsenteeismReport";
import AbsenteeismInformedReasonReport from "components/Report/AbsenteeismInformedReasonReport";
import SampleRequisitions from "components/SampleRequisitions";
import ViewNotificationSetting from "components/Settings/NotificationSettings/Details";
import Permission from "components/Settings/Permission";
import RemedyMap from "components/Settings/RemedyMap";
import SubSalesContract from "components/SubSalesContract";
import UpdateSubSalesContact from "components/SubSalesContract/AddOrUpdateSalesContact/Update";
import ViewSubSalesContact from "components/SubSalesContract/AddOrUpdateSalesContact/View";
import AddSubSalesContact from "components/SubSalesContract/AddOrUpdateSalesContact/create";
import Department from "components/TAndA/Department";
import AddDepartment from "components/TAndA/Department/AddDepertment/AddDepartment";
import UpdateDepartment from "components/TAndA/Department/UpdateDepartment/UpdateDepartment";
import Process from "components/TAndA/Process";
import AddProcess from "components/TAndA/Process/AddProcess/AddProcess";
import UpdateProcess from "components/TAndA/Process/UpdateProcess/UpdateProcess";
import ProgressGraph from "components/TAndA/Summary/Progress/Progress";
import SummaryList from "components/TAndA/Summary/SummaryList";
import SummaryView from "components/TAndA/Summary/SummaryView";
import NewSummaryList from "components/TAndA/NewSummary/NewSummaryList";
import NewSummaryView from "components/TAndA/NewSummary/NewSummaryView";
import NewSummaryProgress from "components/TAndA/NewSummary/NewSummaryProgress";
import TNAPlan from "components/TAndA/TNAPlan";
import AddTNAPlan from "components/TAndA/TNAPlan/AddTNAPlan";
import TNATemplate from "components/TAndA/TNATemplate";
import AddOrUpdateTNATemplate from "components/TAndA/TNATemplate/AddTNATemplate";
import NewTNATemplate from "components/TAndA/NewTNATemplate";
import AddOrUpdateNewTNATemplate from "components/TAndA/NewTNATemplate/AddNewTNATemplate";
import TNAByStyles from "components/TAndA/TNAByStyles";
import AddOrUpdateTNAByStyle from "components/TAndA/TNAByStyles/AddTNAByStyle";
import Task from "components/TAndA/Task";
import AddTask from "components/TAndA/Task/AddTask/AddTask";
import UpdateTask from "components/TAndA/Task/UpdateTask/UpdateTask";
import NewTask from "components/TAndA/NewTask";
import AddNewTask from "components/TAndA/NewTask/AddNewTask/AddNewTask";
import UpdateNewTask from "components/TAndA/NewTask/UpdateNewTask/UpdateNewTask";
import TodoList from "components/TAndA/Todo";
import NewTodoList from "components/TAndA/NewTodoList";
import TAndAInvoices from "components/TAndAInvoices";
import UnitsPrice from "components/UnitsPrice";
import UpdateUnitsPrice from "components/UnitsPrice/AddOrUpdateStyle/Update";
import AddUnitsPrice from "components/UnitsPrice/AddOrUpdateStyle/create";
import AssignmentContextProvider from "context/AssignmentContext/AssignmentContextProvider";
import CuttingContextProvider from "context/CuttingContext/CuttingContextProvider";
import DailyFinishingLinePlanContextProvider from "context/DailyFinishingLinePlanContext";
import DailyLinePlanContextProvider from "context/DailyLinePlanContext";
import FabricAutoContextProvider from "context/FabricAutoContext/FabricAutoContextProvider";
import FoldingContextProvider from "context/FoldingContext/FoldingContextProvider";
import PostCuttingProcessContextProvider from "context/PostCuttingProcessContext/PostCuttingProcessContextProvider";
import StoreRequisitionContextProvider from "context/StoreRequisitionContext/StoreRequisitionContextProvider";
import PostSewingProcessContextProvider from "context/PostSewingProcessContext/PostSewingProcessContextProvider";
import ProductionPlanningContextProvider from "context/ProductionPlanningContext";
import { lazy, Suspense } from "react";
import { v4 as uuidv4 } from "uuid";
import BudgetPi from "../components/Account/BudgetPi";
import CostEstimate from "../components/Account/CostEstimate";
import AddOrUpdateCostEstimate from "../components/Account/CostEstimate/AddOrUpdateCostEstimate";
import CmDefaultData from "../components/Account/CostOfMaking/DefaultData";
import CmExpenseCalculation from "../components/Account/CostOfMaking/ExpenseCalculation";
import CostOfMakingReport from "../components/Account/CostOfMaking/Report";
import ExportDetails from "../components/Account/ExportDetails";
import AddExportDetails from "../components/Account/ExportDetails/AddOrUpdateExportDetails/create";
import EditExportDetails from "../components/Account/ExportDetails/AddOrUpdateExportDetails/update";
import ExportSalesContract from "../components/Account/ExportSalesContract";
import EditExportSalesContract from "../components/Account/ExportSalesContract/AddOrUpdateExportSalesContract/Edit";
import AddExportSalesContract from "../components/Account/ExportSalesContract/AddOrUpdateExportSalesContract/create";
import GoodsDelivery from "../components/Account/GoodsDelivery";
import GoodsDeliveryForm from "../components/Account/GoodsDelivery/GoodsDeliveryForm";
import ImportAcceptanceDetails from "../components/Account/ImportAcceptanceDetails";
import AcceptanceDetails from "../components/Account/ImportAcceptanceDetails/AcceptanceDetails";
import ImportB2bLc from "../components/Account/ImportB2bLc";
import EditB2bLc from "../components/Account/ImportB2bLc/AddOrUpdateB2bLc/Edit";
import AddB2bLc from "../components/Account/ImportB2bLc/AddOrUpdateB2bLc/create";
import ImportDetails from "../components/Account/ImportDetails";
import EditDetails from "../components/Account/ImportDetails/AddOrUpdateDetails/Edit";
import AddDetails from "../components/Account/ImportDetails/AddOrUpdateDetails/create";
import ImportPi from "../components/Account/ImportPi";
import EditPi from "../components/Account/ImportPi/AddOrUpdatePi/Edit";
import ViewPi from "../components/Account/ImportPi/AddOrUpdatePi/View";
import AddPi from "../components/Account/ImportPi/AddOrUpdatePi/create";
import ImportVehicleAssignment from "../components/Account/ImportVehicleAssignment";
import ImportVehicleAssignmentForm from "../components/Account/ImportVehicleAssignment/ImportVehicleAssignmentForm";
import LocalShipment from "../components/Account/LocalShipment";
import LocalShipmentForm from "../components/Account/LocalShipment/LocalShipmentForm";
import Noting from "../components/Account/Noting";
import AddNoting from "../components/Account/Noting/AddOrUpdateNoting/create";
import EditNoting from "../components/Account/Noting/AddOrUpdateNoting/update";
import AddSecurityBolt from "../components/Account/SecurityBolt/AddOrUpdateSecurityBolt/create";
import EditSecurityBolt from "../components/Account/SecurityBolt/AddOrUpdateSecurityBolt/update";
import ShipmentOver from "../components/Account/ShipmentOver";
import AddShipmentOver from "../components/Account/ShipmentOver/AddOrUpdateShipmentOver/create";
import EditShipmentOver from "../components/Account/ShipmentOver/AddOrUpdateShipmentOver/update";
import SubmissionRealization from "../components/Account/SubmissionRealization";
import AddSubmissionRealization from "../components/Account/SubmissionRealization/AddOrUpdateSubmissionRealization/create";
import EditSubmissionRealization from "../components/Account/SubmissionRealization/AddOrUpdateSubmissionRealization/update";
import ActivityLog from "../components/ActivityLog";
import BOM from "../components/BOM";
import PreviewBOM from "../components/BOM/AddOrUpdateStyle/PreviewBom";
import UpdateBOM from "../components/BOM/AddOrUpdateStyle/Update";
import ViewBOM from "../components/BOM/AddOrUpdateStyle/View";
import AddBOM from "../components/BOM/AddOrUpdateStyle/create";
import Buyer from "../components/Buyer";
import CreateOrEditBuyer from "../components/Buyer/CreateOrEditBuyer";
import BuyerInquiry from "../components/BuyerInquiry";
import AddBuyerInquiry from "../components/BuyerInquiry/AddOrUpdateBuyerInquiry/create";
import UpdateBuyerInquiry from "../components/BuyerInquiry/AddOrUpdateBuyerInquiry/update";
import BuyerInquiryApproval from "../components/BuyerInquiry/AddOrUpdateBuyerInquiry/approval";
import BuyingOffice from "../components/BuyingOffice";
import CreateOrEditBuyingOffice from "../components/BuyingOffice/CreateOrEditBuyingOffice";
import BinConfig from "../components/Configuration/BinConfig";
import ChallanConfig from "../components/Configuration/ChallanConfig";
import ColorConfig from "../components/Configuration/ColorConfig";
import GarmentCategoryConfig from "../components/Configuration/GarmentCategoryConfig";
import GarmentTypeConfig from "../components/Configuration/GarmentTypeConfig";
import AirHoleTypeConfig from "../components/Configuration/AirHoleTypeConfig";
import AuFormulaConfig from "../components/Configuration/AuFormulaConfig";
import CartonTypeConfig from "../components/Configuration/CartonTypeConfig";
import GussetTypeConfig from "../components/Configuration/GussetTypeConfig";
import PlyConfig from "../components/Configuration/PlyConfig";
import PolyTypeConfig from "../components/Configuration/PolyTypeConfig";
import SupportingMaterialTypeConfig from "../components/Configuration/SupportingMaterialTypeConfig";
import InquiryReasonsConfig from "../components/Configuration/InquiryReasonsConfig";
import InquiryRemarksConfig from "../components/Configuration/InquiryRemarksConfig";
import OBMachineConfig from "../components/Configuration/OBMachineConfig";
import OBSamBankConfig from "../components/Configuration/OBSAMBankConfig";
import OBSectionConfig from "../components/Configuration/OBSectionConfig";
import OBTemplate from "../components/Configuration/OBTemplate";
import OBTemplateForm from "../components/Configuration/OBTemplate/OBTemplateForm";
import RackConfig from "../components/Configuration/RackConfig";
import SizeConfig from "../components/Configuration/SizeConfig";
import SupplierConfig from "../components/Configuration/SupplierConfig";
import UnitConfig from "../components/Configuration/UnitConfig";
import UnitConvertionConfig from "../components/Configuration/UnitConvertionConfig";
import WarehouseConfig from "../components/Configuration/WarehouseConfig";
import CartonWarehouseConfig from "../components/Configuration/CartonWarehouseConfig";
import CartonFloorConfig from "../components/Configuration/CartonFloorConfig";
import CartonPartitionConfig from "../components/Configuration/CartonPartitionConfig";
import FabricDefectCategoryConfig from "../components/Configuration/FabricDefectCategoryConfig";
import FabricInspection from "../components/FabricInspection";
import FinalInspection from "../components/FinalInspection";
import FinalInspectionForm from "../components/FinalInspection/FinalInspectionForm";
import Dashboard from "../components/Dashboard";
import ImportFiles from "../components/ImportFiles";
import CreateFabricInventory from "../components/InventoryFabric/CreateFabricInventory";
import FabricStoreEntryList from "../components/InventoryFabric/FabricStoreEntryList";
import FinishGood from "../components/InventoryFabric/FinishGood";
import LocalPurchaseReconciliation from "../components/InventoryFabric/LocalPurchaseReconciliation";
import AddLocalPurchaseReconciliation from "../components/InventoryFabric/LocalPurchaseReconciliation/AddOrUpdateLocalPurchaseReconciliation/Create";
import UpdateLocalPurchaseReconciliation from "../components/InventoryFabric/LocalPurchaseReconciliation/AddOrUpdateLocalPurchaseReconciliation/Edit";
import TrimsStoreEntryList from "../components/InventoryTrims/TrimsStoreEntryList";
import CartonInventoryList from "../components/InventoryCarton/CartonInventoryList";
import CreateCartonInventory from "../components/InventoryCarton/CreateCartonInventory";
import Item from "../components/Item";
import ItemCategory from "../components/ItemCategory";
import ItemCategorySequence from "../components/ItemCategory/ItemCategorySequence";
import ItemOCR from "../components/ItemOCR";
import LearningCure from "../components/LearningCurve";
import AddOrUpdateLearningCure from "../components/LearningCurve/AddOrUpdate";
import Notifications from "../components/Notifications";
import OTSignalSection from "../components/OTSignalSection";
import OperationBulletin from "../components/OperationBulletin";
import OBEntry from "../components/OperationBulletin/OBEntry";
import Organization from "../components/Organization";
import CreateOrganization from "../components/Organization/CreateOrganization";
import DailySewingPerformance from "../components/PNLReport/DailySewingPerformance";
import PPMeetingDate from "../components/PPMeetingDate";
import PackingList from "../components/Production/Packing/PackingList";
import CreatePackingReq from "../components/Production/PackingReq/CreatePackingReq";
import UpdatePackingReq from "../components/Production/PackingReq/UpdatePackingReq";
import BookingQty from "../components/ProductionPlanning/BookingQty";
import Exceptions from "../components/ProductionPlanning/Exceptions";
import AddOrUpdateException from "../components/ProductionPlanning/Exceptions/AddOrUpdateException";
import Holidays from "../components/ProductionPlanning/Holidays";
import AddOrUpdateHoliday from "../components/ProductionPlanning/Holidays/AddOrUpdateHoliday";
import PlanningRequests from "../components/ProductionPlanning/PlanningRequests";
import AddOrUpdatePlanningRequest from "../components/ProductionPlanning/PlanningRequests/AddOrUpdatePlanningRequest";
import Weekends from "../components/ProductionPlanning/Weekends";
import AddOrUpdateWeekend from "../components/ProductionPlanning/Weekends/AddOrUpdateWeekend";
import PurchaseOrder from "../components/PurchaseOrder";
import UpdatePurchaseOrder from "../components/PurchaseOrder/AddOrUpdateStyle/Update";
import { default as ViewPO, default as ViewUnitsPrice } from "../components/PurchaseOrder/AddOrUpdateStyle/View";
import AddPurchaseOrder from "../components/PurchaseOrder/AddOrUpdateStyle/create";
import PurchaseOrderNew from "../components/PurchaseOrderNew";
import UpdatePurchaseOrderNew from "../components/PurchaseOrderNew/AddOrUpdateStyle/Update";
import ViewPONew from "../components/PurchaseOrderNew/AddOrUpdateStyle/View";
import AddPurchaseOrderNew from "../components/PurchaseOrderNew/AddOrUpdateStyle/create";
import CostSheet from "../components/Report/CostSheet";
import FabricReconcil from "../components/Report/FabricReconcil";
import HourlyProduction from "../components/Report/HourlyProduction";
import HourlyProductionDetailReport from "../components/Report/HourlyProductionDetailReport";
import InventoryDetails from "../components/Report/InventoryDetails";
import InventoryMRR from "../components/Report/InventoryMRR";
import PackingReport from "../components/Report/PackingReport";
import PIReport from "../components/Report/PIReport";
import ProductionDetails from "../components/Report/ProductionDetails";
import ProductionTracking from "../components/Report/ProductionTracking";
import SalesContact from "../components/SalesContract";
import SizeSpecs from "../components/SalesContract/AddOrUpdateSalesContact/SizeSpecs";
import UpdateSalesContact from "../components/SalesContract/AddOrUpdateSalesContact/Update";
import ViewSalesContact from "../components/SalesContract/AddOrUpdateSalesContact/View";
import AddSalesContact from "../components/SalesContract/AddOrUpdateSalesContact/create";
import NotificationSettings from "../components/Settings/NotificationSettings";
import AddOrUpdateNotificationSetting from "../components/Settings/NotificationSettings/AddOrUpdateNotificationSetting";
import NotificationSlugs from "../components/Settings/NotificationSlugs";
import AddOrUpdateNotificationSlug from "../components/Settings/NotificationSlugs/AddOrUpdateNotificationSlug";
import PermissionSettings from "../components/Settings/PermissionSettings";
import CreateUser from "../components/Settings/User/CreateForm";
import UserList from "../components/Settings/User/UserList";
import UserRole from "../components/Settings/UserRole";
import CreateUserRole from "../components/Settings/UserRole/CreateForm";
import SewingLine from "../components/SewingLine";
import ShipmentEntry from "../components/Shipment/CreateForm";
import ShipmentInformation from "../components/Shipment/ShipmentList";
import Style from "../components/Style";
import AddStyleFromInquiry from "../components/Style/AddOrUpdateStyle/AddStyleFromInquiry";
import AddCopiedStyle from "../components/Style/AddOrUpdateStyle/CopyStyle";
import UpdateStyle from "../components/Style/AddOrUpdateStyle/Update";
import ViewStyle from "../components/Style/AddOrUpdateStyle/View";
import AddStyle from "../components/Style/AddOrUpdateStyle/create";
import {
  ABSINTHIUM_REPORT_GENERATE_PERMISSION,
  ABSENTEEISM_INFORMED_REASON_REPORT_GENERATE_PERMISSION,
  ACTIVITY_LOG_VIEW_PERMISSION,
  AIR_HOLE_TYPE_CREATE_PERMISSION,
  AIR_HOLE_TYPE_DELETE_PERMISSION,
  AIR_HOLE_TYPE_EDIT_PERMISSION,
  AIR_HOLE_TYPE_VIEW_PERMISSION,
  APP_DASHBOARD_VIEW_PERMISSION,
  ASSIGNMENT_CREATE_PERMISSION,
  ASSIGNMENT_DELETE_PERMISSION,
  ASSIGNMENT_EDIT_PERMISSION,
  ASSIGNMENT_VIEW_PERMISSION,
  AU_FORMULA_CREATE_PERMISSION,
  AU_FORMULA_DELETE_PERMISSION,
  AU_FORMULA_EDIT_PERMISSION,
  AU_FORMULA_VIEW_PERMISSION,
  B2BLC_CREATE_PERMISSION,
  B2BLC_DELETE_PERMISSION,
  B2BLC_EDIT_PERMISSION,
  B2BLC_VIEW_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_CREATE_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_EDIT_PERMISSION,
  B2B_LC_ACCEPTANCE_COMMISSION_VIEW_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_CREATE_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_EDIT_PERMISSION,
  B2B_LC_AMENDMENT_OPENING_COST_VIEW_PERMISSION,
  B2B_LC_OPENING_COST_CREATE_PERMISSION,
  B2B_LC_OPENING_COST_EDIT_PERMISSION,
  B2B_LC_OPENING_COST_VIEW_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_CREATE_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_EDIT_PERMISSION,
  B2B_LC_SHIPPING_GUARANTEE_COST_VIEW_PERMISSION,
  BGMEA_UD_AMENDMENT_CREATE_PERMISSION,
  BGMEA_UD_AMENDMENT_DELETE_PERMISSION,
  BGMEA_UD_AMENDMENT_EDIT_PERMISSION,
  BGMEA_UD_AMENDMENT_VIEW_PERMISSION,
  BGMEA_UD_COST_CREATE_PERMISSION,
  BGMEA_UD_COST_DELETE_PERMISSION,
  BGMEA_UD_COST_EDIT_PERMISSION,
  BGMEA_UD_COST_VIEW_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_CREATE_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_DELETE_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_PERMISSION,
  BGMEA_UD_EXPORT_PERMISSION_COST_VIEW_PERMISSION,
  BIN_CREATE_PERMISSION,
  BIN_DELETE_PERMISSION,
  BIN_EDIT_PERMISSION,
  BIN_VIEW_PERMISSION,
  BOLT_SEAL_LOG_CREATE_PERMISSION,
  BOLT_SEAL_LOG_DELETE_PERMISSION,
  BOLT_SEAL_LOG_EDIT_PERMISSION,
  BOLT_SEAL_LOG_REPORT_PERMISSION,
  BOLT_SEAL_LOG_VIEW_PERMISSION,
  BOM_CREATE_PERMISSION,
  BOM_DELETE_PERMISSION,
  BOM_EDIT_PERMISSION,
  BOM_EXPORT_PERMISSION,
  BOM_VIEW_PERMISSION,
  BOOKING_QTY_CREATE_PERMISSION,
  BOOKING_QTY_DELETE_PERMISSION,
  BOOKING_QTY_EDIT_PERMISSION,
  BOOKING_QTY_VIEW_PERMISSION,
  BUYER_CREATE_PERMISSION,
  BUYER_DELETE_PERMISSION,
  BUYER_EDIT_PERMISSION,
  BUYER_VIEW_PERMISSION,
  BUYER_INQUIRY_CREATE_PERMISSION,
  BUYER_INQUIRY_DELETE_PERMISSION,
  BUYER_INQUIRY_EDIT_PERMISSION,
  BUYER_INQUIRY_VIEW_PERMISSION,
  CM_VALUE_APPROVE_PERMISSION,
  BUYER_PO_PO_WISE_CREATE_PERMISSION,
  BUYER_PO_PO_WISE_DELETE_PERMISSION,
  BUYER_PO_PO_WISE_EDIT_PERMISSION,
  BUYER_PO_PO_WISE_VIEW_PERMISSION,
  BUYING_OFFICE_CREATE_PERMISSION,
  BUYING_OFFICE_DELETE_PERMISSION,
  BUYING_OFFICE_EDIT_PERMISSION,
  BUYING_OFFICE_VIEW_PERMISSION,
  CAPACITY_BOOKING_CREATE_PERMISSION,
  CAPACITY_BOOKING_DELETE_PERMISSION,
  CAPACITY_BOOKING_EDIT_PERMISSION,
  CAPACITY_BOOKING_MENU_VIEW_PERMISSION,
  CAPACITY_BOOKING_VIEW_PERMISSION,
  CARTON_TYPE_CREATE_PERMISSION,
  CARTON_TYPE_DELETE_PERMISSION,
  CARTON_TYPE_EDIT_PERMISSION,
  CARTON_TYPE_VIEW_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_CREATE_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_DELETE_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_EDIT_PERMISSION,
  CERTIFICATE_OF_ORIGIN_FEE_VIEW_PERMISSION,
  CHALLAN_CREATE_PERMISSION,
  CHALLAN_DELETE_PERMISSION,
  CHALLAN_EDIT_PERMISSION,
  CHALLAN_VIEW_PERMISSION,
  CHECKLIST_MENU_VIEW_PERMISSION,
  COLOR_CREATE_PERMISSION,
  COLOR_DELETE_PERMISSION,
  COLOR_EDIT_PERMISSION,
  COLOR_VIEW_PERMISSION,
  COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION,
  COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION,
  COST_ESTIMATE_CREATE_PERMISSION,
  COST_ESTIMATE_DELETE_PERMISSION,
  COST_ESTIMATE_EDIT_PERMISSION,
  COST_ESTIMATE_VIEW_PERMISSION,
  COST_OF_MAKING_CREATE,
  COST_OF_MAKING_DELETE,
  COST_OF_MAKING_DETAILS,
  COST_OF_MAKING_EDIT,
  COST_OF_MAKING_LIST,
  COST_SHEET_REPORT_DELETE_PERMISSION,
  COST_SHEET_REPORT_GENERATE_PERMISSION,
  COST_SHEET_REPORT_VIEW_PERMISSION,
  CUTTING_CREATE_PERMISSION,
  CUTTING_DELETE_PERMISSION,
  CUTTING_EDIT_PERMISSION,
  CUTTING_VIEW_PERMISSION,
  DAILY_IMPORT_POSITION_CREATE_PERMISSION,
  DAILY_IMPORT_POSITION_DELETE_PERMISSION,
  DAILY_IMPORT_POSITION_EDIT_PERMISSION,
  DAILY_IMPORT_POSITION_VIEW_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION,
  DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION,
  DAILY_LINE_PLAN_VIEW_PERMISSION,
  DAILY_LINE_TARGET_CREATE_PERMISSION,
  DAILY_LINE_TARGET_DELETE_PERMISSION,
  DAILY_LINE_TARGET_EDIT_PERMISSION,
  DAILY_LINE_TARGET_VIEW_PERMISSION,
  DAILY_SEWING_PERFORMANCE_VIEW_PERMISSION,
  DELETE_MRR_REPORT_VIEW_PERMISSION,
  DIGITALIZATION_ABSENTEEISM_VIEW_PERMISSION,
  DIGITALIZATION_CHECKLIST_VIEW_PERMISSION,
  DIGITALIZATION_DEFECT_VIEW_PERMISSION,
  DIGITALIZATION_MENU_VIEW_PERMISSION,
  DIGITALIZATION_ROLE_CHECK_PREMISSION,
  DIGITALIZATION_SETTINGS_VIEW_PERMISSION,
  DRIVER_VEHICLE_INFO_CREATE_PERMISSION,
  DRIVER_VEHICLE_INFO_DELETE_PERMISSION,
  DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION,
  DRIVER_VEHICLE_INFO_EDIT_PERMISSION,
  DRIVER_VEHICLE_INFO_VIEW_PERMISSION,
  EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION,
  EPB_ATTRIBUTE_CREATE_PERMISSION,
  EPB_ATTRIBUTE_DELETE_PERMISSION,
  EPB_ATTRIBUTE_EDIT_PERMISSION,
  EPB_ATTRIBUTE_VIEW_PERMISSION,
  EPB_TYPE_CREATE_PERMISSION,
  EPB_TYPE_DELETE_PERMISSION,
  EPB_TYPE_EDIT_PERMISSION,
  EPB_TYPE_VIEW_PERMISSION,
  ERP_USAGE_ISSUE_VIEW_PERMISSION,
  ERP_USAGE_MODULE_VIEW_PERMISSION,
  EXIM_CONFIGURE_CREATE_PERMISSION,
  EXIM_CONFIGURE_DELETE_PERMISSION,
  EXIM_CONFIGURE_EDIT_PERMISSION,
  EXIM_CONFIGURE_VIEW_PERMISSION,
  EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
  EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
  EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
  EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
  EXPORT_DETAILS_CREATE_PERMISSION,
  EXPORT_DETAILS_DELETE_PERMISSION,
  EXPORT_DETAILS_EDIT_PERMISSION,
  EXPORT_DETAILS_VIEW_PERMISSION,
  EXPORT_DOC_FEE_CREATE_PERMISSION,
  EXPORT_DOC_FEE_DELETE_PERMISSION,
  EXPORT_DOC_FEE_EDIT_PERMISSION,
  EXPORT_DOC_FEE_VIEW_PERMISSION,
  EXPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION,
  EXPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION,
  EXPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION,
  EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_CREATE_PERMISSION,
  EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_EDIT_PERMISSION,
  EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_VIEW_PERMISSION,
  FABRIC_ACCESSORIES_AUTO_RECONCILIATION_VIEW_PERMISSION,
  FABRIC_REPORT_DELETE_PERMISSION,
  FABRIC_REPORT_GENERATE_PERMISSION,
  FABRIC_REPORT_VIEW_PERMISSION,
  FINISH_GARMENT_CREATE_PERMISSION,
  FINISH_GARMENT_DELETE_PERMISSION,
  FINISH_GARMENT_EDIT_PERMISSION,
  FINISH_GARMENT_VIEW_PERMISSION,
  CARTON_INVENTORY_CREATE_PERMISSION,
  CARTON_INVENTORY_DELETE_PERMISSION,
  CARTON_INVENTORY_EDIT_PERMISSION,
  CARTON_INVENTORY_VIEW_PERMISSION,
  FINISHING_GARMENT_RECEIVED_CREATE_PERMISSION,
  FINISHING_GARMENT_RECEIVED_UPDATE_PERMISSION,
  FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION,
  FINISHING_LINE_CREATE_PERMISSION,
  FINISHING_LINE_DELETE_PERMISSION,
  FINISHING_LINE_EDIT_PERMISSION,
  FINISHING_LINE_MAPPING_CREATE_PERMISSION,
  FINISHING_LINE_MAPPING_VIEW_PERMISSION,
  FINISHING_LINE_VIEW_PERMISSION,
  FOLDING_CREATE_PERMISSION,
  FOLDING_DELETE_PERMISSION,
  FOLDING_EDIT_PERMISSION,
  FOLDING_VIEW_PERMISSION,
  GARMENT_CATEGORY_CREATE_PERMISSION,
  GARMENT_CATEGORY_DELETE_PERMISSION,
  GARMENT_CATEGORY_EDIT_PERMISSION,
  GARMENT_CATEGORY_VIEW_PERMISSION,
  GARMENT_RECEIVED_CREATE_PERMISSION,
  GARMENT_RECEIVED_UPDATE_PERMISSION,
  GARMENT_RECEIVED_VIEW_PERMISSION,
  GARMENT_TYPE_CREATE_PERMISSION,
  GARMENT_TYPE_DELETE_PERMISSION,
  GARMENT_TYPE_EDIT_PERMISSION,
  GARMENT_TYPE_VIEW_PERMISSION,
  GARMENTS_PARTS_CREATE_PERMISSION,
  GARMENTS_PARTS_DELETE_PERMISSION,
  GARMENTS_PARTS_EDIT_PERMISSION,
  GARMENTS_PARTS_VIEW_PERMISSION,
  GARMENTS_TRACKING_VIEW_PERMISSION,
  GENERATE_MRR_REPORT_VIEW_PERMISSION,
  GOODS_DELIVERY_CREATE_PERMISSION,
  GOODS_DELIVERY_DELETE_PERMISSION,
  GOODS_DELIVERY_EDIT_PERMISSION,
  GOODS_DELIVERY_VIEW_PERMISSION,
  HOURLY_FOLD_CREATE_PERMISSION,
  HOURLY_FOLD_EDIT_PERMISSION,
  HOURLY_FOLD_VIEW_PERMISSION,
  HOURLY_IRON_CREATE_PERMISSION,
  HOURLY_IRON_EDIT_PERMISSION,
  HOURLY_IRON_VIEW_PERMISSION,
  HOURLY_OPERATION_TRACKING_CREATE_PERMISSION,
  HOURLY_OPERATION_TRACKING_EDIT_PERMISSION,
  HOURLY_OPERATION_TRACKING_VIEW_PERMISSION,
  HOURLY_POLY_CREATE_PERMISSION,
  HOURLY_POLY_EDIT_PERMISSION,
  HOURLY_POLY_VIEW_PERMISSION,
  HOURLY_PRODUCTION_VIEW_PERMISSION,
  HOUR_CONFIGURATION_CREATE_PERMISSION,
  HR_OT_EXPENSE_DATA_IMPORT_PERMISSION,
  INVENTORY_CREATE_PERMISSION,
  INVENTORY_DELETE_PERMISSION,
  INVENTORY_EDIT_PERMISSION,
  INVENTORY_VIEW_PERMISSION,
  ITEM_CREATE_PERMISSION,
  ITEM_DELETE_PERMISSION,
  ITEM_EDIT_PERMISSION,
  ITEM_VIEW_PERMISSION,
  MACHINE_INFORMATION_VIEW_PERMISSION,
  NOTIFICATION_SETTING_VIEW_PERMISSION,
  ORGANIZATION_VIEW_PERMISSION,
  PACKING_CREATE_PERMISSION,
  PACKING_DELETE_PERMISSION,
  PACKING_EDIT_PERMISSION,
  PACKING_VIEW_PERMISSION,
  PERMISSION_CREATE_PERMISSION,
  PERMISSION_DELETE_PERMISSION,
  PERMISSION_EDIT_PERMISSION,
  PERMISSION_VIEW_PERMISSION,
  PI_CREATE_PERMISSION,
  PI_DELETE_PERMISSION,
  PI_EDIT_PERMISSION,
  PI_VIEW_PERMISSION,
  PLAN_CREATE_PERMISSION,
  PLAN_DASHBOARD_VIEW_PERMISSION,
  PURCHASE_ORDER_CREATE_PERMISSION,
  PURCHASE_ORDER_DELETE_PERMISSION,
  PURCHASE_ORDER_EDIT_PERMISSION,
  PURCHASE_ORDER_VIEW_PERMISSION,
  ROLE_CREATE_PERMISSION,
  ROLE_DELETE_PERMISSION,
  ROLE_EDIT_PERMISSION,
  ROLE_VIEW_PERMISSION,
  SALES_CONTRACT_CREATE_PERMISSION,
  SALES_CONTRACT_DELETE_PERMISSION,
  SALES_CONTRACT_EDIT_PERMISSION,
  SALES_CONTRACT_VIEW_PERMISSION,
  SEWING_CREATE_PERMISSION,
  SEWING_DELETE_PERMISSION,
  SEWING_EDIT_PERMISSION,
  SEWING_VIEW_PERMISSION,
  STORE_REQUISITION_CREATE_PERMISSION,
  STORE_REQUISITION_DELETE_PERMISSION,
  STORE_REQUISITION_EDIT_PERMISSION,
  STORE_REQUISITION_VIEW_PERMISSION,
  SIZE_CREATE_PERMISSION,
  SIZE_DELETE_PERMISSION,
  SIZE_EDIT_PERMISSION,
  SIZE_VIEW_PERMISSION,
  STOCK_LOT_CREATE_PERMISSION,
  STOCK_LOT_DELETE_PERMISSION,
  STOCK_LOT_EDIT_PERMISSION,
  STOCK_LOT_VIEW_PERMISSION,
  STYLE_CREATE_PERMISSION,
  STYLE_DELETE_PERMISSION,
  STYLE_EDIT_PERMISSION,
  STYLE_VIEW_PERMISSION,
  SUPPLIER_CREATE_PERMISSION,
  SUPPLIER_DELETE_PERMISSION,
  SUPPLIER_EDIT_PERMISSION,
  SUPPLIER_VIEW_PERMISSION,
  UNIT_CREATE_PERMISSION,
  UNIT_DELETE_PERMISSION,
  UNIT_EDIT_PERMISSION,
  UNIT_VIEW_PERMISSION,
  USER_CREATE_PERMISSION,
  USER_DELETE_PERMISSION,
  USER_EDIT_PERMISSION,
  USER_VIEW_PERMISSION,
  WAREHOUSE_CREATE_PERMISSION,
  WAREHOUSE_DELETE_PERMISSION,
  WAREHOUSE_EDIT_PERMISSION,
  WAREHOUSE_VIEW_PERMISSION,
  WASHING_SNAP_BUTTON_VIEW_PERMISSION,
  NO_PERMISSION_REQUIRED,
  ORGANIZATION_CREATE_PERMISSION,
  ORGANIZATION_EDIT_PERMISSION,
  ORGANIZATION_DELETE_PERMISSION,
  SHIPPING_VIEW_PERMISSION,
  SHIPPING_CREATE_PERMISSION,
  SHIPPING_EDIT_PERMISSION,
  SHIPPING_DELETE_PERMISSION,
  SEWING_LINE_VIEW_PERMISSION,
  SEWING_LINE_CREATE_PERMISSION,
  SEWING_LINE_EDIT_PERMISSION,
  SEWING_LINE_DELETE_PERMISSION,
  ITEM_TYPES_VIEW_PERMISSION,
  ITEM_TYPES_CREATE_PERMISSION,
  ITEM_TYPES_EDIT_PERMISSION,
  ITEM_TYPES_DELETE_PERMISSION,
  ITEM_CATEGORY_VIEW_PERMISSION,
  ITEM_CATEGORY_CREATE_PERMISSION,
  ITEM_CATEGORY_EDIT_PERMISSION,
  ITEM_CATEGORY_DELETE_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_VIEW_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_CREATE_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_EDIT_PERMISSION,
  SALES_CONTRACT_COMMERCIAL_DELETE_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_VIEW_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_CREATE_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_EDIT_PERMISSION,
  IMPORT_ACCEPTANCE_DETAIL_DELETE_PERMISSION,
  RACK_VIEW_PERMISSION,
  RACK_CREATE_PERMISSION,
  RACK_EDIT_PERMISSION,
  RACK_DELETE_PERMISSION,
  PI_BUDGET_VIEW_PERMISSION,
  SUBMISSION_REALIZATION_VIEW_PERMISSION,
  SUBMISSION_REALIZATION_CREATE_PERMISSION,
  SUBMISSION_REALIZATION_EDIT_PERMISSION,
  SUBMISSION_REALIZATION_DELETE_PERMISSION,
  NOTING_ASSESSMENT_VIEW_PERMISSION,
  NOTING_ASSESSMENT_CREATE_PERMISSION,
  NOTING_ASSESSMENT_EDIT_PERMISSION,
  NOTING_ASSESSMENT_DELETE_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
  IMPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
  EXPORT_SHIPMENT_VIEW_PERMISSION,
  EXPORT_SHIPMENT_CREATE_PERMISSION,
  EXPORT_SHIPMENT_EDIT_PERMISSION,
  EXPORT_SHIPMENT_DELETE_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
  EXPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_VIEW_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_VIEW_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
  PRODUCT_TRACK_REPORT_VIEW_PERMISSION,
  PRODUCT_TRACK_REPORT_GENERATE_PERMISSION,
  PRODUCT_TRACK_REPORT_DELETE_PERMISSION,
  PRODUCT_DETAIL_REPORT_GENERATE_PERMISSION,
  PRODUCT_DETAIL_REPORT_DELETE_PERMISSION,
  SUPPLIER_WISE_ITEM_PRICE_REPORT_VIEW_PERMISSION,
  PI_REPORT_VIEW_PERMISSION,
  SALES_CONTRACT_COSTING_REPORT,
  UPLOAD_BUYER_PERMISSION,
  UPLOAD_BRAND_PERMISSION,
  UPLOAD_BUYING_OFFICE_PERMISSION,
  UPLOAD_BANK_PERMISSION,
  UPLOAD_BRANCH_PERMISSION,
  UPLOAD_MERCHANDISER_PERMISSION,
  UPLOAD_STYLE_PERMISSION,
  UPLOAD_SUBSTYLE_PERMISSION,
  UPLOAD_SALES_CONTRACT_PERMISSION,
  UPLOAD_SUPPLIER_PERMISSION,
  UPLOAD_COLOR_PERMISSION,
  UPLOAD_SIZE_PERMISSION,
  UPLOAD_BOM_PERMISSION,
  UPLOAD_PO_PERMISSION,
  SECURITY_BOLT_CREATE_PERMISSION,
  SECURITY_BOLT_EDIT_PERMISSION,
  PACKING_REPORT_TEMPLATE_VIEW_PERMISSION,
  PACKING_REPORT_TEMPLATE_STORE_PERMISSION,
  PACKING_REPORT_TEMPLATE_UPDATE_PERMISSION,
  SHIPMENT_HANDOVER_VIEW_PERMISSION,
  SHIPMENT_HANDOVER_CREATE_PERMISSION,
  SHIPMENT_HANDOVER_EDIT_PERMISSION,
  SHIPMENT_HANDOVER_DELETE_PERMISSION,
  INVENTORY_DETAIL_REPORT_VIEW_PERMISSION,
  INVENTORY_DETAIL_REPORT_GENERATE_PERMISSION,
  INVENTORY_DETAIL_REPORT_DELETE_PERMISSION,
  POST_COSTING_REPORT_GENERATE_PERMISSION,
  INVENTORY_MRR_REPORT_VIEW_PERMISSION,
  PACKING_LIST_REPORT_VIEW_PERMISSION,
  OB_MACHINE_VIEW_PERMISSION,
  OB_MACHINE_CREATE_PERMISSION,
  OB_MACHINE_EDIT_PERMISSION,
  OB_MACHINE_DELETE_PERMISSION,
  OB_SECTION_VIEW_PERMISSION,
  OB_SECTION_CREATE_PERMISSION,
  OB_SECTION_EDIT_PERMISSION,
  OB_SECTION_DELETE_PERMISSION,
  OB_SAM_DATA_BANK_VIEW_PERMISSION,
  OB_SAM_DATA_BANK_CREATE_PERMISSION,
  OB_SAM_DATA_BANK_EDIT_PERMISSION,
  OB_SAM_DATA_BANK_DELETE_PERMISSION,
  OB_VIEW_PERMISSION,
  OB_CREATE_PERMISSION,
  OB_EDIT_PERMISSION,
  OB_DELETE_PERMISSION,
  OB_TEMPLATE_VIEW_PERMISSION,
  OB_TEMPLATE_CREATE_PERMISSION,
  OB_TEMPLATE_EDIT_PERMISSION,
  OB_TEMPLATE_DELETE_PERMISSION,
  NOTIFICATION_SLUG_VIEW_PERMISSION,
  NOTIFICATION_SLUG_CREATE_PERMISSION,
  NOTIFICATION_SLUG_EDIT_PERMISSION,
  NOTIFICATION_SLUG_DELETE_PERMISSION,
  NOTIFICATION_SETTING_CREATE_PERMISSION,
  NOTIFICATION_SETTING_EDIT_PERMISSION,
  NOTIFICATION_SETTING_DELETE_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_VIEW_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_CREATE_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_EDIT_PERMISSION,
  LOCAL_PURCHASE_RECONCILIATION_DELETE_PERMISSION,
  GUSSET_TYPE_VIEW_PERMISSION,
  GUSSET_TYPE_CREATE_PERMISSION,
  GUSSET_TYPE_EDIT_PERMISSION,
  GUSSET_TYPE_DELETE_PERMISSION,
  PLY_VIEW_PERMISSION,
  PLY_CREATE_PERMISSION,
  PLY_EDIT_PERMISSION,
  PLY_DELETE_PERMISSION,
  POLY_TYPE_VIEW_PERMISSION,
  POLY_TYPE_CREATE_PERMISSION,
  POLY_TYPE_EDIT_PERMISSION,
  POLY_TYPE_DELETE_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_VIEW_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_CREATE_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_EDIT_PERMISSION,
  SUPPORTING_MATERIAL_TYPE_DELETE_PERMISSION,
  INQUIRY_REASONS_CREATE_PERMISSION,
  INQUIRY_REASONS_EDIT_PERMISSION,
  INQUIRY_REASONS_VIEW_PERMISSION,
  INQUIRY_REASONS_DELETE_PERMISSION,
  INQUIRY_REMARKS_CREATE_PERMISSION,
  INQUIRY_REMARKS_EDIT_PERMISSION,
  INQUIRY_REMARKS_VIEW_PERMISSION,
  INQUIRY_REMARKS_DELETE_PERMISSION,
  LEARNING_CURVE_VIEW_PERMISSION,
  LEARNING_CURVE_CREATE_PERMISSION,
  LEARNING_CURVE_EDIT_PERMISSION,
  LEARNING_CURVE_DELETE_PERMISSION,
  TNA_PROCESS_VIEW_PERMISSION,
  TNA_PROCESS_CREATE_PERMISSION,
  TNA_PROCESS_EDIT_PERMISSION,
  TNA_DEPARTMENT_VIEW_PERMISSION,
  TNA_DEPARTMENT_CREATE_PERMISSION,
  TNA_DEPARTMENT_EDIT_PERMISSION,
  TNA_TASK_VIEW_PERMISSION,
  TNA_TASK_CREATE_PERMISSION,
  TNA_TASK_EDIT_PERMISSION,
  TNA_TEMPLATE_VIEW_PERMISSION,
  TNA_TEMPLATE_CREATE_PERMISSION,
  TNA_TEMPLATE_EDIT_PERMISSION,
  TNA_BY_STYLE_VIEW_PERMISSION,
  TNA_BY_STYLE_CREATE_PERMISSION,
  TNA_BY_STYLE_EDIT_PERMISSION,
  TNA_PLAN_VIEW_PERMISSION,
  TNA_PLAN_CREATE_PERMISSION,
  TNA_PLAN_EDIT_PERMISSION,
  TNA_TO_DO_LIST_VIEW_PERMISSION,
  TNA_SUMMARY_VIEW_PERMISSION,
  TNA_PLAN_SUMMARY_DETAILS_PERMISSION,
  TNA_PLAN_SUMMARY_GRAPH_PERMISSION,
  ITEM_OCR_UPLOAD_PERMISSION,
  PP_WEEKEND_VIEW_PERMISSION,
  PP_WEEKEND_CREATE_PERMISSION,
  PP_WEEKEND_EDIT_PERMISSION,
  PP_WEEKEND_DELETE_PERMISSION,
  PP_HOLIDAY_VIEW_PERMISSION,
  PP_HOLIDAY_CREATE_PERMISSION,
  PP_HOLIDAY_EDIT_PERMISSION,
  PP_HOLIDAY_DELETE_PERMISSION,
  PP_EXCEPTION_VIEW_PERMISSION,
  PP_EXCEPTION_CREATE_PERMISSION,
  PP_EXCEPTION_EDIT_PERMISSION,
  PP_EXCEPTION_DELETE_PERMISSION,
  PP_PLANNING_REQUEST_VIEW_PERMISSION,
  PP_PLANNING_REQUEST_CREATE_PERMISSION,
  PP_PLANNING_REQUEST_EDIT_PERMISSION,
  PP_PLANNING_REQUEST_DELETE_PERMISSION,
  SALES_CONTRACT_360_VIEW_PERMISSION,
  SUBCONTRACT_FACTORY_VIEW_PERMISSION,
  OT_SIGNAL_SECTION_VIEW_PERMISSION,
  OT_SIGNAL_SECTION_CREATE_PERMISSION,
  OT_SIGNAL_SECTION_EDIT_PERMISSION,
  OT_SIGNAL_SECTION_DELETE_PERMISSION,
  OT_SIGNAL_VIEW_PERMISSION,
  OT_SIGNAL_CREATE_PERMISSION,
  OT_SIGNAL_EDIT_PERMISSION,
  OT_SIGNAL_DELETE_PERMISSION,
  PACKING_LINE_CREATE_PERMISSION,
  PACKING_LINE_EDIT_PERMISSION,
  PACKING_LINE_VIEW_PERMISSION,
  PACKING_LINE_DELETE_PERMISSION,
  PACKING_TABLE_CREATE_PERMISSION,
  PACKING_TABLE_EDIT_PERMISSION,
  PACKING_TABLE_VIEW_PERMISSION,
  PACKING_TABLE_DELETE_PERMISSION,
  PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
  PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
  PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
  PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
  OSR_REPORT_GENERATE_PERMISSION,
  SEWING_FOLDING_REPORT_GENERATE_PERMISSION,
  VIEW_ALL_ACTIVE_POS_PERMISSION,
  LINE_WISE_SEWING_REPORT_VIEW_PERMISSION,
  IPR_REPORT_VIEW_PERMISSION,
  INITIAL_SAM_MENU_PERMISSION,
  INITIAL_SAM_STORE_PERMISSION,
  IMPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION,
  IMPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION,
  IMPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION,
  IMPORT_LC_EXPENSE_TRACKER_VIEW_PERMISSION,
  IMPORT_LC_EXPENSE_TRACKER_CREATE_PERMISSION,
  IMPORT_LC_EXPENSE_TRACKER_EDIT_PERMISSION,
  PROBLEM_REMEDY_MAP_VIEW_PERMISSION,
  PROBLEM_REMEDY_LOG_VIEW_PERMISSION,
  CGL_AUDIT_REPORT_LIST_VIEW_PERMISSION,
  LINE_WISE_CATEGORY_DEFECT_REPORT_VIEW_PERMISSION,
  SEWING_LINE_DEFECT_REPORT_VIEW_PERMISSION,
  SEWING_LINE_DEFECT_MONTHLY_REPORT_VIEW_PERMISSION,
  QC_VALIDATION_REPORT_VIEW_PERMISSION,
  MACHINE_INFORMATION_STORE_PERMISSION,
  MACHINE_INFORMATION_UPDATE_PERMISSION,
  MACHINE_INFORMATION_DELETE_PERMISSION,
  MACHINE_INFORMATION_IMPORT_PERMISSION,
  MACHINE_BRAND_VIEW_PERMISSION,
  MACHINE_BRAND_STORE_PERMISSION,
  MACHINE_BRAND_UPDATE_PERMISSION,
  MACHINE_BRAND_DELETE_PERMISSION,
  MACHINE_COMPANY_VIEW_PERMISSION,
  MACHINE_COMPANY_STORE_PERMISSION,
  MACHINE_COMPANY_UPDATE_PERMISSION,
  MACHINE_COMPANY_DELETE_PERMISSION,
  MACHINE_MODEL_VIEW_PERMISSION,
  MACHINE_MODEL_STORE_PERMISSION,
  MACHINE_MODEL_UPDATE_PERMISSION,
  MACHINE_MODEL_DELETE_PERMISSION,
  MACHINE_LOCATION_VIEW_PERMISSION,
  MACHINE_LOCATION_STORE_PERMISSION,
  MACHINE_LOCATION_UPDATE_PERMISSION,
  MACHINE_LOCATION_DELETE_PERMISSION,
  MACHINE_MACHINE_LINE_VIEW_PERMISSION,
  MACHINE_MACHINE_LINE_STORE_PERMISSION,
  MACHINE_MACHINE_LINE_UPDATE_PERMISSION,
  MACHINE_MACHINE_LINE_DELETE_PERMISSION,
  MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
  MACHINE_ORIGIN_COUNTRY_STORE_PERMISSION,
  MACHINE_ORIGIN_COUNTRY_UPDATE_PERMISSION,
  MACHINE_ORIGIN_COUNTRY_DELETE_PERMISSION,
  MACHINE_ACTION_TYPE_VIEW_PERMISSION,
  MACHINE_ACTION_TYPE_STORE_PERMISSION,
  MACHINE_ACTION_TYPE_UPDATE_PERMISSION,
  MACHINE_ACTION_TYPE_DELETE_PERMISSION,
  MACHINE_FAULT_TYPE_VIEW_PERMISSION,
  MACHINE_FAULT_TYPE_STORE_PERMISSION,
  MACHINE_FAULT_TYPE_UPDATE_PERMISSION,
  MACHINE_FAULT_TYPE_DELETE_PERMISSION,
  MACHINE_LINE_ISSUES_VIEW_PERMISSION,
  SALES_CONTRACT_LIEN_COST_VIEW_PERMISSION,
  SALES_CONTRACT_LIEN_COST_CREATE_PERMISSION,
  SALES_CONTRACT_LIEN_COST_EDIT_PERMISSION,
  SALES_CONTRACT_LIEN_COST_DELETE_PERMISSION,
  EB_COLLECTION_CHARGE_VIEW_PERMISSION,
  EB_COLLECTION_CHARGE_CREATE_PERMISSION,
  EB_COLLECTION_CHARGE_EDIT_PERMISSION,
  EB_COLLECTION_CHARGE_DELETE_PERMISSION,
  EB_COLLECTION_CHARGE_PRINT_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_VIEW_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_CREATE_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_EDIT_PERMISSION,
  SALES_CONTRACT_AMENDMENT_LIEN_COST_DELETE_PERMISSION,
  MARINA_COVER_NOTE_BILL_VIEW_PERMISSION,
  MARINA_COVER_NOTE_BILL_CREATE_PERMISSION,
  MARINA_COVER_NOTE_BILL_EDIT_PERMISSION,
  MARINA_COVER_NOTE_BILL_DELETE_PERMISSION,
  IOU_VIEW_PERMISSION,
  IOU_CREATE_PERMISSION,
  IOU_EDIT_PERMISSION,
  IOU_DISBURSE_PERMISSION,
  SALES_CONTRACT_IOU_COST_CREATE_PERMISSION,
  IMPORT_BILL_RETIREMENT_VIEW_PERMISSION,
  IMPORT_BILL_RETIREMENT_CREATE_PERMISSION,
  IMPORT_BILL_RETIREMENT_EDIT_PERMISSION,
  IOU_EXPENDITURE_FOR_EXPORT,
  IOU_EXPENDITURE_FOR_IMPORT,
  IOU_ADJUSTMENT_IMPORT_VIEW_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_CREATE_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_EDIT_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_DELETE_PERMISSION,
  IOU_ADJUSTMENT_IMPORT_APPROVE_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_VIEW_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_CREATE_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_EDIT_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_DELETE_PERMISSION,
  IOU_ADJUSTMENT_EXPORT_APPROVE_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_VIEW_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_CREATE_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_EDIT_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_DELETE_PERMISSION,
  IOU_ADJUSTMENT_GENERAL_APPROVE_PERMISSION,
  CARTON_WAREHOUSE_VIEW_PERMISSION,
  CARTON_WAREHOUSE_CREATE_PERMISSION,
  CARTON_WAREHOUSE_EDIT_PERMISSION,
  CARTON_WAREHOUSE_DELETE_PERMISSION,
  CARTON_FLOOR_VIEW_PERMISSION,
  CARTON_FLOOR_CREATE_PERMISSION,
  CARTON_FLOOR_EDIT_PERMISSION,
  CARTON_FLOOR_DELETE_PERMISSION,
  CARTON_PARTITION_VIEW_PERMISSION,
  CARTON_PARTITION_CREATE_PERMISSION,
  CARTON_PARTITION_EDIT_PERMISSION,
  CARTON_PARTITION_DELETE_PERMISSION,
  FABRIC_DEFECT_CATEGORY_VIEW_PERMISSION,
  FABRIC_DEFECT_CATEGORY_CREATE_PERMISSION,
  FABRIC_DEFECT_CATEGORY_EDIT_PERMISSION,
  FABRIC_DEFECT_CATEGORY_DELETE_PERMISSION,
  FABRIC_INSPECTION_VIEW_PERMISSION,
  FABRIC_INSPECTION_CREATE_PERMISSION,
  FABRIC_INSPECTION_EDIT_PERMISSION,
  FABRIC_INSPECTION_DELETE_PERMISSION,
  FINAL_PRODUCT_INSPECTION_VIEW_PERMISSION,
  FINAL_PRODUCT_INSPECTION_CREATE_PERMISSION,
  FINAL_PRODUCT_INSPECTION_EDIT_PERMISSION,
  FINAL_PRODUCT_INSPECTION_DELETE_PERMISSION,
  TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
  TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
  TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
  TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
  TRANSPORTATION_COST_ENTRY_CREATE_PERMISSION,
  TRANSPORTATION_COST_ENTRY_DELETE_PERMISSION,
  TRANSPORTATION_COST_ENTRY_EDIT_PERMISSION,
  TRANSPORTATION_COST_ENTRY_PRINT_PERMISSION,
  TRANSPORTATION_COST_ENTRY_VIEW_PERMISSION,
  PRODUCTION_PLANNING_LIST_VIEW_PERMISSION,
  CAPACITY_BOOKING_REPORT_VIEW_PERMISSION,
  BOOKING_CARTON_VIEW_PERMISSION,
  BOOKING_CARTON_CREATE_PERMISSION,
  BOOKING_CARTON_EDIT_PERMISSION,
  BOOKING_CARTON_DELETE_PERMISSION,
  NOTIFICATION_VIEW_PERMISSION,
  SAMPLE_REQUISITION_VIEW_PERMISSION,
  SAMPLE_REQUISITION_CREATE_PERMISSION,
  SAMPLE_REQUISITION_EDIT_PERMISSION,
  SAMPLE_REQUISITION_DELETE_PERMISSION,
  SAMPLE_TYPE_VIEW_PERMISSION,
  SAMPLE_TYPE_CREATE_PERMISSION,
  SAMPLE_TYPE_EDIT_PERMISSION,
  SAMPLE_TYPE_DELETE_PERMISSION,
} from "./permissions";

// import UpdateSewingToFolding from "components/Digitalization/Finishing/sewing-to-folding/UpdateSewingToFolding";
// import UpdateFinishingHourlyIron from "components/Digitalization/Finishing/hourly-iron/UpdateFinishingHourlyIron";
// import FoldingToPacking from "components/Digitalization/packing/folding-to-packing";
// import UpdateFoldingToPacking from "components/Digitalization/packing/folding-to-packing/UpdateFoldingToPacking";
// import MachineInformation from "components/Digitalization/MachineMaintenace/MachineInformation";
// import MachineInformationForm from "components/Digitalization/MachineMaintenace/MachineInformation/MachineInformationForm";
// import MaintenaceConfig from "components/Digitalization/MachineMaintenace/Configurations/MachineMaintenaceConfig";
// import MachineConfigForm from "components/Digitalization/MachineMaintenace/Configurations/ConfigForm";
import MismatchReport from "components/Digitalization/Finishing/mismatch-report";

// import EditPackingReportTemplate from "components/Account/PackingReportTemplate/AddOrUpdatePackingReportTemplate/Edit";
// import ViewPackingReportTemplate from "components/Account/PackingReportTemplate/AddOrUpdatePackingReportTemplate/View";
// import AddPackingReportTemplate from "components/Account/PackingReportTemplate/AddOrUpdatePackingReportTemplate/create";
import CapacityBooking from "components/CapacityBooking";
import AddCapacityBooking from "components/CapacityBooking/AddOrUpdateBuyerInquiry/create";
import UpdateCapacityBooking from "components/CapacityBooking/AddOrUpdateBuyerInquiry/update";
import AmendmentLienCost from "components/ImportCustomsClearance/AmendmentLienCost";
import AddAmendmentLienCost from "components/ImportCustomsClearance/AmendmentLienCost/Add";
import UpdateAmendmentLienCost from "components/ImportCustomsClearance/AmendmentLienCost/Update";
import ViewAmendmentLienCost from "components/ImportCustomsClearance/AmendmentLienCost/View";
import BgmeaUdAmendment from "components/ImportCustomsClearance/BgmeaUdAmendment";
import AddBgmeaUdAmendment from "components/ImportCustomsClearance/BgmeaUdAmendment/Add";
import UpdateBgmeaUdAmendment from "components/ImportCustomsClearance/BgmeaUdAmendment/Update";
import ViewBgmeaUdAmendment from "components/ImportCustomsClearance/BgmeaUdAmendment/View";
import BgmeaUdCost from "components/ImportCustomsClearance/BgmeaUdCost";
import AddBgmeaUdCost from "components/ImportCustomsClearance/BgmeaUdCost/Add";
import UpdateBgmeaUdCost from "components/ImportCustomsClearance/BgmeaUdCost/Update";
import ViewBgmeaUdCost from "components/ImportCustomsClearance/BgmeaUdCost/View";
import BgmeaUdExportPermissionCost from "components/ImportCustomsClearance/BgmeaUdExportPermissionCost";
import AddBgmeaUdExportPermissionCost from "components/ImportCustomsClearance/BgmeaUdExportPermissionCost/Add";
import UpdateBgmeaUdExportPermissionCost from "components/ImportCustomsClearance/BgmeaUdExportPermissionCost/Update";
import ViewBgmeaUdExportPermissionCost from "components/ImportCustomsClearance/BgmeaUdExportPermissionCost/View";
import CertificateOfOriginFee from "components/ImportCustomsClearance/CertificateOfOriginFee";
import AddCertificateOfOriginFee from "components/ImportCustomsClearance/CertificateOfOriginFee/AddCertificateOfOriginFee/AddCertificateOfOriginFee";
import UpdateCertificateOfOriginFee from "components/ImportCustomsClearance/CertificateOfOriginFee/UpdateCertificateOfOriginFee/UpdateCertificateOfOriginFee";
import ViewCertificateOfOriginFee from "components/ImportCustomsClearance/CertificateOfOriginFee/ViewCertificateOfOriginFee/ViewCertificateOfOriginFee";
import Charges from "components/ImportCustomsClearance/Configure/Charges";
import {
  ExportCnfExpenditure,
  ImportCnfExpenditure,
} from "components/ImportCustomsClearance/Configure/CnfExpenditureSettings";
import AddExportCnfBill from "components/ImportCustomsClearance/ExternalCnfBills/ExportCnfBill/Add";
import UpdateExportCnfBill from "components/ImportCustomsClearance/ExternalCnfBills/ExportCnfBill/Update";
import ViewExportCnfBill from "components/ImportCustomsClearance/ExternalCnfBills/ExportCnfBill/View";
import ExportCnfBillList from "components/ImportCustomsClearance/ExternalCnfBills/ExportCnfBill";
import PrepareBillingList from "components/ImportCustomsClearance/ExternalCnfBills/PrepareBilling";
import AddPrepareBilling from "components/ImportCustomsClearance/ExternalCnfBills/PrepareBilling/AddPrepareBilling";
import UpdatePrepareBilling from "components/ImportCustomsClearance/ExternalCnfBills/PrepareBilling/UpdatePrepareBilling";
import ViewPrepareBilling from "components/ImportCustomsClearance/ExternalCnfBills/PrepareBilling/ViewPrepareBilling";
import AddImportCnfBill from "components/ImportCustomsClearance/ExternalCnfBills/ImportCnfBill/Add";
import UpdateImportCnfBill from "components/ImportCustomsClearance/ExternalCnfBills/ImportCnfBill/Update";
import ViewImportCnfBill from "components/ImportCustomsClearance/ExternalCnfBills/ImportCnfBill/View";
import ImportCnfBillList from "components/ImportCustomsClearance/ExternalCnfBills/ImportCnfBill";
import CostHead from "components/ImportCustomsClearance/Configure/CostHead";
import CostType from "components/ImportCustomsClearance/Configure/CostType";
import EPBAttribute from "components/ImportCustomsClearance/Configure/EPBAttribute";
import EPBType from "components/ImportCustomsClearance/Configure/EPBType";
import EximAccounts from "components/ImportCustomsClearance/Configure/EximAccounts";
import ExportDocumentationFee from "components/ImportCustomsClearance/ExportDocumentationFee";
import AddExportDocumentationFee from "components/ImportCustomsClearance/ExportDocumentationFee/AddExportDocumentationFee/AddExportDocumentationFee";
import UpdateExportDocumentationFee from "components/ImportCustomsClearance/ExportDocumentationFee/UpdateExportDocumentationFee/UpdateExportDocumentationFee";
import ViewExportDocumentationFee from "components/ImportCustomsClearance/ExportDocumentationFee/ViewExportDocumentationFee/ViewExportDocumentationFee";
import IOUCost from "components/ImportCustomsClearance/IOUCost";
import AddIOUCost from "components/ImportCustomsClearance/IOUCost/AddIOUCost/AddIOUCost";
import UpdateIOUCost from "components/ImportCustomsClearance/IOUCost/UpdateIOUCost/UpdateIOUCost";
import ViewIOUCost from "components/ImportCustomsClearance/IOUCost/ViewIOUCost/ViewIOUCost";
// import IOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement";
// import AddIOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement/AddIOUDisbursement/AddIOUDisbursement";
// import UpdateIOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement/UpdateIOUDisbursement/UpdateIOUDisbursement";
// import ViewIOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement/ViewIOUDisbursement/ViewIOUDisbursement";
import PackingReportTemplate from "components/Account/PackingReportTemplate";
import EditPackingReportTemplate from "components/Account/PackingReportTemplate/AddOrUpdatePackingReportTemplate/Edit";
import ViewPackingReportTemplate from "components/Account/PackingReportTemplate/AddOrUpdatePackingReportTemplate/View";
import AddPackingReportTemplate from "components/Account/PackingReportTemplate/AddOrUpdatePackingReportTemplate/create";
import PackingLineConfig from "components/Configuration/PackingLineConfig";
import PackingOperatorMappingConfig from "components/Configuration/PackingOperatorMappingConfig";
import AddOrUpdatePackingOperatorMapping from "components/Configuration/PackingOperatorMappingConfig/AddOrUpdate";
import PackingTableConfig from "components/Configuration/PackingTableConfig";
import HourlyIronOriginal from "components/Digitalization/Finishing/hourly-iron-original";
import UpdateFinishingHourlyIronOriginal from "components/Digitalization/Finishing/hourly-iron-original/UpdateFinishingHourlyIronOriginal";
import FoldingRequirement from "components/FoldingRequirement";
import UpdateFoldingRequirement from "components/FoldingRequirement/AddOrUpdateFoldingRequirement/Update";
import ViewFoldingRequirement from "components/FoldingRequirement/AddOrUpdateFoldingRequirement/View";
import AddFoldingRequirement from "components/FoldingRequirement/AddOrUpdateFoldingRequirement/create";
import GarmentsTrackingHourlyTarget from "components/GarmentsTrackingHourlyTarget";
import CreateOrEditHourlyTarget from "components/GarmentsTrackingHourlyTarget/CreateOrEdit";
import HourlyOperationTracking from "components/HourlyOperationTracking";
import UpdateHourlyOperationTracking from "components/HourlyOperationTracking/AddOrUpdateHourlyOperationTracking/Update";
import ViewHourlyOperationTracking from "components/HourlyOperationTracking/AddOrUpdateHourlyOperationTracking/View";
import AddHourlyOperationTracking from "components/HourlyOperationTracking/AddOrUpdateHourlyOperationTracking/create";
import IOUAdjustmentExport from "components/ImportCustomsClearance/IOUAdjustmentExport";
import AddIOUAdjustmentExport from "components/ImportCustomsClearance/IOUAdjustmentExport/AddIOUAdjustmentExport/AddIOUAdjustmentExport";
import UpdateIOUAdjustmentExport from "components/ImportCustomsClearance/IOUAdjustmentExport/UpdateIOUAdjustmentExport/UpdateIOUAdjustmentExport";
import ViewIOUAdjustmentExport from "components/ImportCustomsClearance/IOUAdjustmentExport/ViewIOUAdjustmentExport/ViewIOUAdjustmentExport";
import IOUAdjustmentGeneral from "components/ImportCustomsClearance/IOUAdjustmentGeneral";
import AddIOUAdjustmentGeneral from "components/ImportCustomsClearance/IOUAdjustmentGeneral/AddIOUAdjustmentGeneral/AddIOUAdjustmentGeneral";
import UpdateIOUAdjustmentGeneral from "components/ImportCustomsClearance/IOUAdjustmentGeneral/UpdateIOUAdjustmentGeneral/UpdateIOUAdjustmentGeneral";
import ViewIOUAdjustmentGeneral from "components/ImportCustomsClearance/IOUAdjustmentGeneral/ViewIOUAdjustmentGeneral/ViewIOUAdjustmentGeneral";
import IOUAdjustmentImport from "components/ImportCustomsClearance/IOUAdjustmentImport";
import AddIOUAdjustmentImport from "components/ImportCustomsClearance/IOUAdjustmentImport/AddIOUAdjustmentImport/AddIOUAdjustmentImport";
import UpdateIOUAdjustmentImport from "components/ImportCustomsClearance/IOUAdjustmentImport/UpdateIOUAdjustmentImport/UpdateIOUAdjustmentImport";
import ViewIOUAdjustmentImport from "components/ImportCustomsClearance/IOUAdjustmentImport/ViewIOUAdjustmentImport/ViewIOUAdjustmentImport";
import IOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement";
import AddIOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement/AddIOUDisbursement/AddIOUDisbursement";
import UpdateIOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement/UpdateIOUDisbursement/UpdateIOUDisbursement";
import ViewIOUDisbursement from "components/ImportCustomsClearance/IOUDisbursement/ViewIOUDisbursement/ViewIOUDisbursement";
import IOUDocuments from "components/ImportCustomsClearance/IOUDocuments";
import AddIOUDocuments from "components/ImportCustomsClearance/IOUDocuments/AddIOUDocuments/AddIOUDocuments";
import UpdateIOUDocuments from "components/ImportCustomsClearance/IOUDocuments/UpdateIOUDocuments/UpdateIOUDocuments";
import ViewIOUDocuments from "components/ImportCustomsClearance/IOUDocuments/ViewIOUDocuments/ViewIOUDocuments";
import LienCost from "components/ImportCustomsClearance/LienCost";
import AddLienCost from "components/ImportCustomsClearance/LienCost/AddLienCost/AddLienCost";
import UpdateLienCost from "components/ImportCustomsClearance/LienCost/UpdateLienCost/UpdateLienCost";
import ViewLienCost from "components/ImportCustomsClearance/LienCost/ViewLienCost/ViewLienCost";
import MarinaCoverNoteBill from "components/ImportCustomsClearance/MarinaCoverNoteBill";
import AddMarinaCoverNoteBill from "components/ImportCustomsClearance/MarinaCoverNoteBill/Add";
import UpdateMarinaCoverNoteBill from "components/ImportCustomsClearance/MarinaCoverNoteBill/Update";
import ViewMarinaCoverNoteBill from "components/ImportCustomsClearance/MarinaCoverNoteBill/View";
import DashboardPNL from "components/PNLReport/Dashboard";
import HourlyPackingConfirmation from "components/Production/Packing/HourlyPackingConfirmation";
import HourlyPackingConfirmationList from "components/Production/Packing/HourlyPackingConfirmation/HourlyPackingConfirmationList";
import CartonBooking from "components/InventoryFabric/CartonBooking";
import CreateCartonBooking from "components/InventoryFabric/CartonBooking/AddOrUpdateCartonBooking/Create";
import EditCartonBooking from "components/InventoryFabric/CartonBooking/AddOrUpdateCartonBooking/Edit";
import SampleRequisition from "components/Merchandising/SampleRequisition";
import SampleRequisitionForm from "components/Merchandising/SampleRequisition/SampleRequisitionForm";
import SampleTypeConfig from "components/Merchandising/SampleTypeConfig";
import SalesContractCostReport from "components/Report/SalesContractCostReport";
import SupplierwiseItemPriceReport from "components/Report/SupplierwiseItemPriceReport";

const B2BLcOpeningCost = lazy(() => import("components/ImportCustomsClearance/B2BLcOpeningCost"));
const AddB2BLcOpeningCost = lazy(() => import("components/ImportCustomsClearance/B2BLcOpeningCost/Add"));
const UpdateB2BLcOpeningCost = lazy(() => import("components/ImportCustomsClearance/B2BLcOpeningCost/Update"));
const ViewB2BLcOpeningCost = lazy(() => import("components/ImportCustomsClearance/B2BLcOpeningCost/View"));

const B2BLcAmendmentOpeningCost = lazy(() => import("components/ImportCustomsClearance/B2BLcAmendmentOpeningCost"));
const AddB2BLcAmendmentOpeningCost = lazy(
  () => import("components/ImportCustomsClearance/B2BLcAmendmentOpeningCost/Add"),
);
const UpdateB2BLcAmendmentOpeningCost = lazy(
  () => import("components/ImportCustomsClearance/B2BLcAmendmentOpeningCost/Update"),
);
const ViewB2BLcAmendmentOpeningCost = lazy(
  () => import("components/ImportCustomsClearance/B2BLcAmendmentOpeningCost/View"),
);

const B2BLcShippingGuaranteeCost = lazy(() => import("components/ImportCustomsClearance/B2BLCShippingGuranteeCost"));
const AddB2BLcShippingGuaranteeCost = lazy(
  () => import("components/ImportCustomsClearance/B2BLCShippingGuranteeCost/Add"),
);
const UpdateB2BLcShippingGuaranteeCost = lazy(
  () => import("components/ImportCustomsClearance/B2BLCShippingGuranteeCost/Update"),
);
const ViewB2BLcShippingGuaranteeCost = lazy(
  () => import("components/ImportCustomsClearance/B2BLCShippingGuranteeCost/View"),
);

const B2BLcAcceptanceCommission = lazy(() => import("components/ImportCustomsClearance/B2BLCAcceptanceCommission"));
const AddB2BLcAcceptanceCommission = lazy(
  () => import("components/ImportCustomsClearance/B2BLCAcceptanceCommission/Add"),
);
const UpdateB2BLcAcceptanceCommission = lazy(
  () => import("components/ImportCustomsClearance/B2BLCAcceptanceCommission/Update"),
);
const ViewB2BLcAcceptanceCommission = lazy(
  () => import("components/ImportCustomsClearance/B2BLCAcceptanceCommission/View"),
);

const ImportBillRetirement = lazy(() => import("components/ImportCustomsClearance/ImportBillRetirement"));
const AddImportBillRetirement = lazy(() => import("components/ImportCustomsClearance/ImportBillRetirement/Add"));
const UpdateImportBillRetirement = lazy(() => import("components/ImportCustomsClearance/ImportBillRetirement/Update"));
const ViewImportBillRetirement = lazy(() => import("components/ImportCustomsClearance/ImportBillRetirement/View"));

const EbCollectionCharge = lazy(() => import("components/ImportCustomsClearance/EbCollectionCharge"));
const AddEbCollectionCharge = lazy(() => import("components/ImportCustomsClearance/EbCollectionCharge/Add"));
const UpdateEbCollectionCharge = lazy(() => import("components/ImportCustomsClearance/EbCollectionCharge/Update"));
const ViewEbCollectionCharge = lazy(() => import("components/ImportCustomsClearance/EbCollectionCharge/View"));

const TransportParticularRate = lazy(() => import("components/TransportationCost/Config/ParticularRate"));
const TransportChargeType = lazy(() => import("components/TransportationCost/Config/ChargeType"));
const TransportationCostList = lazy(() => import("components/TransportationCost/Entry"));
const AddTransportationCost = lazy(() => import("components/TransportationCost/Entry/Add"));
const UpdateTransportationCost = lazy(() => import("components/TransportationCost/Entry/Update"));
const ViewTransportationCost = lazy(() => import("components/TransportationCost/Entry/View"));

const RolePanel = lazy(() => import("components/Digitalization/Roles"));
const UserLineAssign = lazy(() => import("components/Digitalization/UserLineAssign"));
const SubContractFactory = lazy(() => import("components/SubContractFactory"));
const DefectCategory = lazy(() => import("components/Digitalization/Defect/Category/DefectCategory"));
const DefectReason = lazy(() => import("components/Digitalization/Defect/Reason/DefectReason"));
const DefectResponsible = lazy(() => import("components/Digitalization/Defect/Responsible/DefectResponsible"));
const DefectRecommendation = lazy(() => import("components/Digitalization/Defect/Recommendation/DefectRecommendation"));
const DefectCategoryMapping = lazy(
  () => import("components/Digitalization/Defect/CategoryMapping/DefectCategoryMapping"),
);
const AddOrEditCategoryMapping = lazy(
  () => import("components/Digitalization/Defect/CategoryMapping/addEdit/AddOrEdit"),
);
const LineNSectionMapping = lazy(
  () => import("components/Digitalization/Defect/LineNSectionMapping/LineNSectionMapping"),
);
const HourlyProductionRecord = lazy(() => import("components/Digitalization/HourlyProductionRecord/Index"));
const HourlyProductionRecordView = lazy(() => import("components/Digitalization/HourlyProductionRecord/view"));
const SalesContract360 = lazy(() => import("components/Merchandising/SalesContract360/SalesContract360"));
const AppProductDetails = lazy(() => import("components/AppDashboard/ProductDetails/AppProductDetails"));
const OperatorWisePerformance = lazy(
  () => import("components/AppDashboard/OperatorWisePerformance/OperatorWisePerformance"),
);

let AuthRouter = [
  {
    path: "/inventory/store/fabric-store-entry/add",
    name: "inventory-fabric-store-add",
    component: <CreateFabricInventory />,
    allowedpermissions: [
      INVENTORY_VIEW_PERMISSION,
      INVENTORY_CREATE_PERMISSION,
      INVENTORY_EDIT_PERMISSION,
      INVENTORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "fabric-store",
      action_type: "create",
    },
  },
  {
    path: "/inventory/store/fabric-store-entry",
    name: "inventory-fabric-store",
    component: <FabricStoreEntryList />,
    allowedpermissions: [
      INVENTORY_VIEW_PERMISSION,
      INVENTORY_CREATE_PERMISSION,
      INVENTORY_EDIT_PERMISSION,
      INVENTORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "fabric-store",
      action_type: "view",
    },
  },
  {
    path: "/production/cutting",
    name: "production",
    component: <Cutting />,
    allowedpermissions: [
      CUTTING_VIEW_PERMISSION,
      CUTTING_CREATE_PERMISSION,
      CUTTING_EDIT_PERMISSION,
      CUTTING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "cutting",
      action_type: "view",
    },
  },
  {
    path: "/production/cutting/entry",
    name: "production",
    component: (
      <CuttingContextProvider>
        <CreateCuttingEntry />
      </CuttingContextProvider>
    ),
    allowedpermissions: [CUTTING_CREATE_PERMISSION, CUTTING_EDIT_PERMISSION],
    analytics: {
      event_type: "cutting",
      action_type: "view",
    },
  },
  {
    path: "/production/folding/entry",
    name: "production",
    component: (
      <FoldingContextProvider>
        <CreateFoldingEntry />
      </FoldingContextProvider>
    ),
    allowedpermissions: [
      FOLDING_VIEW_PERMISSION,
      FOLDING_CREATE_PERMISSION,
      FOLDING_EDIT_PERMISSION,
      FOLDING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "folding",
      action_type: "view",
    },
  },
  {
    path: "/production/packing/packing-entry",
    name: "production",
    component: <CreatePackingEntry />,
    allowedpermissions: [
      PACKING_VIEW_PERMISSION,
      PACKING_CREATE_PERMISSION,
      PACKING_EDIT_PERMISSION,
      PACKING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production/packing",
    name: "production",
    component: <PackingList />,
    allowedpermissions: [
      PACKING_VIEW_PERMISSION,
      PACKING_CREATE_PERMISSION,
      PACKING_EDIT_PERMISSION,
      PACKING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "packing-confirmation",
      action_type: "view",
    },
  },
  {
    path: "/production/folding",
    name: "production-folding",
    component: <Folding />,
    allowedpermissions: [
      FOLDING_VIEW_PERMISSION,
      FOLDING_CREATE_PERMISSION,
      FOLDING_EDIT_PERMISSION,
      FOLDING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "folding",
      action_type: "view",
    },
  },
  {
    path: "/production/assignment",
    name: "production",
    component: (
      <AssignmentContextProvider>
        <Assignment />
      </AssignmentContextProvider>
    ),
    allowedpermissions: [
      ASSIGNMENT_VIEW_PERMISSION,
      ASSIGNMENT_CREATE_PERMISSION,
      ASSIGNMENT_EDIT_PERMISSION,
      ASSIGNMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "assignment",
      action_type: "view",
    },
  },
  {
    path: "/production/sewing",
    name: "production",
    component: <Sewing />,
    allowedpermissions: [
      SEWING_VIEW_PERMISSION,
      SEWING_CREATE_PERMISSION,
      SEWING_EDIT_PERMISSION,
      SEWING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production/add-sewing",
    name: "production",
    component: <AddSewing />,
    allowedpermissions: [
      SEWING_VIEW_PERMISSION,
      SEWING_CREATE_PERMISSION,
      SEWING_EDIT_PERMISSION,
      SEWING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/",
    name: "dashboard",
    component: <Dashboard />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "dashboard",
      action_type: "view",
    },
  },
  {
    path: "/configuration/organization",
    name: "organization",
    component: <Organization />,
    allowedpermissions: [
      ORGANIZATION_VIEW_PERMISSION,
      ORGANIZATION_CREATE_PERMISSION,
      ORGANIZATION_EDIT_PERMISSION,
      ORGANIZATION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/forwarding/shipment",
    name: "shipment",
    component: <ShipmentInformation />,
    allowedpermissions: [
      SHIPPING_VIEW_PERMISSION,
      SHIPPING_CREATE_PERMISSION,
      SHIPPING_EDIT_PERMISSION,
      SHIPPING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/forwarding/store-shipment-info",
    name: "shipment",
    component: <ShipmentEntry />,
    allowedpermissions: [
      SHIPPING_VIEW_PERMISSION,
      SHIPPING_CREATE_PERMISSION,
      SHIPPING_EDIT_PERMISSION,
      SHIPPING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/organization/create-organization",
    name: "create-organization",
    component: <CreateOrganization />,
    allowedpermissions: [ORGANIZATION_CREATE_PERMISSION],
  },
  {
    path: "/configuration/buyer",
    name: "buyer",
    component: <Buyer />,
    allowedpermissions: [
      BUYER_VIEW_PERMISSION,
      BUYER_CREATE_PERMISSION,
      BUYER_EDIT_PERMISSION,
      BUYER_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "buyer",
      action_type: "view",
    },
  },
  {
    path: "/configuration/buyer/create-buyer",
    name: "buyer",
    component: <CreateOrEditBuyer isAdd />,
    allowedpermissions: [BUYER_CREATE_PERMISSION],
    analytics: {
      event_type: "buyer",
      action_type: "view",
    },
  },
  {
    path: "/configuration/buying-office",
    name: "buying-office",
    component: <BuyingOffice />,
    allowedpermissions: [
      BUYING_OFFICE_VIEW_PERMISSION,
      BUYING_OFFICE_CREATE_PERMISSION,
      BUYING_OFFICE_EDIT_PERMISSION,
      BUYING_OFFICE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "buying-office",
      action_type: "view",
    },
  },
  {
    path: "/configuration/buying-office/create-buying-office",
    name: "create-buying-office",
    component: <CreateOrEditBuyingOffice isAdd />,
    allowedpermissions: [BUYING_OFFICE_CREATE_PERMISSION],
    analytics: {
      event_type: "buying-office",
      action_type: "view",
    },
  },
  {
    path: "/configuration/sewing-line",
    name: "sewing-line",
    component: <SewingLine />,
    layout: "/configuration/sewing-line",
    allowedpermissions: [
      SEWING_LINE_VIEW_PERMISSION,
      SEWING_LINE_CREATE_PERMISSION,
      SEWING_LINE_EDIT_PERMISSION,
      SEWING_LINE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/items",
    name: "items",
    component: <Item />,
    layout: "/configuration/items",
    allowedpermissions: [ITEM_VIEW_PERMISSION, ITEM_CREATE_PERMISSION, ITEM_EDIT_PERMISSION, ITEM_DELETE_PERMISSION],
    analytics: {
      event_type: "item",
      action_type: "view",
    },
  },
  {
    path: "/configuration/item-types",
    name: "item-types",
    component: <ItemType />,
    layout: "/configuration/item-types",
    allowedpermissions: [
      ITEM_TYPES_VIEW_PERMISSION,
      ITEM_TYPES_CREATE_PERMISSION,
      ITEM_TYPES_EDIT_PERMISSION,
      ITEM_TYPES_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "item-types",
      action_type: "view",
    },
  },
  {
    path: "/settings/users",
    name: "users",
    component: <UserList />,
    layout: "/settings/users",
    allowedpermissions: [USER_VIEW_PERMISSION, USER_CREATE_PERMISSION, USER_EDIT_PERMISSION, USER_DELETE_PERMISSION],
    analytics: {
      event_type: "user",
      action_type: "view",
    },
  },
  {
    path: "/settings/users/create-user",
    name: "create-user",
    component: <CreateUser />,
    layout: "/settings/users/create-user",
    allowedpermissions: [USER_CREATE_PERMISSION],
    analytics: {
      event_type: "user",
      action_type: "view",
    },
  },
  {
    path: "/settings/role",
    name: "user-role-list",
    component: <UserRole />,
    layout: "/settings/role",
    allowedpermissions: [ROLE_VIEW_PERMISSION, ROLE_CREATE_PERMISSION, ROLE_EDIT_PERMISSION, ROLE_DELETE_PERMISSION],
  },
  {
    path: "/settings/role/create-role",
    name: "create-role",
    component: <CreateUserRole />,
    layout: "/settings/role/create-role",
    allowedpermissions: [ROLE_CREATE_PERMISSION],
  },
  {
    path: "/configuration/item-category",
    name: "item-category",
    component: <ItemCategory />,
    layout: "/configuration/item-category",
    allowedpermissions: [
      ITEM_CATEGORY_VIEW_PERMISSION,
      ITEM_CATEGORY_CREATE_PERMISSION,
      ITEM_CATEGORY_EDIT_PERMISSION,
      ITEM_CATEGORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "item-category",
      action_type: "view",
    },
  },
  // {
  //   path: "/configuration/item-type",
  //   name: "item-category",
  //   component: <ItemType />,
  //   layout: "/configuration/item-type",
  //   allowedpermissions: [
  //     ITEM_TYPE_VIEW_PERMISSION,
  //     ITEM_TYPE_CREATE_PERMISSION,
  //     ITEM_TYPE_EDIT_PERMISSION,
  //     ITEM_TYPE_DELETE_PERMISSION,
  //   ],
  // },
  {
    path: "/merchandising/style",
    name: "style",
    component: <Style />,
    breadcrumbname: "style",
    layout: "/merchandising/style",
    allowedpermissions: [
      STYLE_VIEW_PERMISSION,
      STYLE_CREATE_PERMISSION,
      STYLE_EDIT_PERMISSION,
      STYLE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "style",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-style",
    name: "Add style",
    component: <AddStyle />,
    breadcrumbname: "style",
    layout: "/merchandising/add-style",
    allowedpermissions: [STYLE_CREATE_PERMISSION],
    analytics: {
      event_type: "style",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/copy-style/:styleId",
    name: "Add Copied style",
    component: <AddCopiedStyle />,
    breadcrumbname: "style",
    layout: "/merchandising/add-copied-style",
    allowedpermissions: [STYLE_CREATE_PERMISSION],
    analytics: {
      event_type: "style",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-style/:styleId",
    name: "Update style",
    component: <UpdateStyle />,
    breadcrumbname: "style",
    layout: "/merchandising/update-style",
    allowedpermissions: [STYLE_EDIT_PERMISSION],
    analytics: {
      event_type: "style",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/view-style/:styleId",
    name: "View style",
    component: <ViewStyle />,
    breadcrumbname: "style",
    layout: "/merchandising/view-style",
    allowedpermissions: [STYLE_VIEW_PERMISSION],
    analytics: {
      event_type: "style",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/sales-contact",
    name: "sales-contact",
    component: <SalesContact />,
    breadcrumbname: "SalesContact",
    layout: "/merchandising/sales-contact",
    allowedpermissions: [
      SALES_CONTRACT_VIEW_PERMISSION,
      SALES_CONTRACT_CREATE_PERMISSION,
      SALES_CONTRACT_EDIT_PERMISSION,
      SALES_CONTRACT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "sales-contract",
      action_type: "view",
    },
  },

  {
    path: "/merchandising/add-sales-contact",
    name: "Add Sales Contact",
    component: <AddSalesContact />,
    breadcrumbname: "SalesContact",
    layout: "/merchandising/add-sales-contact",
    allowedpermissions: [SALES_CONTRACT_CREATE_PERMISSION],
    analytics: {
      event_type: "sales-contract",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-sales-contact/:styleId",
    name: "Update style",
    component: <UpdateSalesContact isEdit />,
    breadcrumbname: "style",
    layout: "/merchandising/update-sales-contact",
    allowedpermissions: [SALES_CONTRACT_EDIT_PERMISSION],
    analytics: {
      event_type: "sales-contract",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/view-sales-contact/:styleId",
    name: "Update style",
    component: <ViewSalesContact />,
    breadcrumbname: "style",
    layout: "/merchandising/view-sales-contact",
    allowedpermissions: [SALES_CONTRACT_VIEW_PERMISSION],
    analytics: {
      event_type: "sales-contract",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/sub-sales-contact",
    name: "sub-sales-contact",
    component: <SubSalesContract />,
    breadcrumbname: "SubSalesContact",
    layout: "/merchandising/sub-sales-contact",
    allowedpermissions: [
      SALES_CONTRACT_VIEW_PERMISSION,
      SALES_CONTRACT_CREATE_PERMISSION,
      SALES_CONTRACT_EDIT_PERMISSION,
      SALES_CONTRACT_DELETE_PERMISSION,
    ],
  },
  {
    path: "/merchandising/add-sub-sales-contact",
    name: "Add Sub Contact",
    component: <AddSubSalesContact />,
    breadcrumbname: "AddSalesContact",
    layout: "/merchandising/add-sub-sales-contact",
    allowedpermissions: [SALES_CONTRACT_CREATE_PERMISSION],
  },
  {
    path: "/merchandising/update-sub-sales-contact/:styleId",
    name: "Update Sub Contact",
    component: <UpdateSubSalesContact isEdit />,
    breadcrumbname: "EditSalesContact",
    layout: "/merchandising/update-sub-sales-contact",
    allowedpermissions: [SALES_CONTRACT_EDIT_PERMISSION],
  },
  {
    path: "/merchandising/view-sub-sales-contact/:styleId",
    name: "View Sub Contact",
    component: <ViewSubSalesContact />,
    breadcrumbname: "ViewSalesContact",
    layout: "/merchandising/view-sub-sales-contact",
    allowedpermissions: [SALES_CONTRACT_VIEW_PERMISSION],
  },
  {
    path: "/merchandising/sub-sales-contact-size-specs/:salesContractId",
    name: "sub-sales-contact-size-specs",
    component: <SizeSpecs />,
    breadcrumbname: "style",
    layout: "/merchandising/sub-sales-contact-size-specs",
    allowedpermissions: [SALES_CONTRACT_EDIT_PERMISSION],
  },
  {
    path: "/merchandising/style-wise-quantity-breakdown",
    name: "order-details",
    component: <PurchaseOrder />,
    breadcrumbname: "SalesContact",
    layout: "/merchandising/style-wise-quantity-breakdown",
    allowedpermissions: [
      PURCHASE_ORDER_VIEW_PERMISSION,
      PURCHASE_ORDER_CREATE_PERMISSION,
      PURCHASE_ORDER_EDIT_PERMISSION,
      PURCHASE_ORDER_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "style-wise-quantity-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-style-wise-quantity-breakdown",
    name: "add-order-details",
    component: <AddPurchaseOrder />,
    breadcrumbname: "SalesContact",
    layout: "/merchandising/add-style-wise-quantity-breakdown",
    allowedpermissions: [PURCHASE_ORDER_CREATE_PERMISSION],
    analytics: {
      event_type: "style-wise-quantity-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-style-wise-quantity-breakdown/:styleId",
    name: "add-order-details",
    component: <UpdatePurchaseOrder />,
    breadcrumbname: "SalesContact",
    layout: "/merchandising/update-style-wise-quantity-breakdown",
    allowedpermissions: [PURCHASE_ORDER_EDIT_PERMISSION],
    analytics: {
      event_type: "style-wise-quantity-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-price-purchase-order/:styleId",
    name: "add-price-details",
    component: <UpdatePurchaseOrder isAddPrice={true} />,
    breadcrumbname: "AddPrice",
    layout: "/merchandising/add-price-purchase-order",
    allowedpermissions: [PURCHASE_ORDER_EDIT_PERMISSION],
    analytics: {
      event_type: "purchase-order-breakdown",
      action_type: "view",
    },
    // allowedpermissions: [PURCHASE_ORDER_ADD_PRICE_PERMISSION],
  },
  {
    path: "/merchandising/view-style-wise-quantity-breakdown/:styleId",
    name: "View style",
    component: <ViewPO />,
    breadcrumbname: "style",
    layout: "/merchandising/view-style-wise-quantity-breakdown/:styleId",
    allowedpermissions: [PURCHASE_ORDER_VIEW_PERMISSION],
    analytics: {
      event_type: "style-wise-quantity-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/BOM",
    name: "BOM",
    component: <BOM />,
    breadcrumbname: "BOM",
    layout: "/merchandising/BOM",
    allowedpermissions: [
      BOM_VIEW_PERMISSION,
      BOM_CREATE_PERMISSION,
      BOM_EDIT_PERMISSION,
      BOM_DELETE_PERMISSION,
      BOM_EXPORT_PERMISSION,
    ],
    analytics: {
      event_type: "bill-of-material",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-BOM",
    name: "BOM",
    component: <AddBOM />,
    breadcrumbname: "BOM",
    layout: "/merchandising/add-BOM",
    allowedpermissions: [BOM_CREATE_PERMISSION],
    analytics: {
      event_type: "bill-of-material",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-BOM/:bomId",
    name: "BOM",
    component: <UpdateBOM />,
    breadcrumbname: "BOM",
    layout: "/merchandising/update-BOM",
    allowedpermissions: [BOM_EDIT_PERMISSION],
    analytics: {
      event_type: "bill-of-material",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/view-BOM/:styleId",
    name: "BOM",
    component: <ViewBOM />,
    breadcrumbname: "BOM",
    layout: "/merchandising/view-BOM",
    allowedpermissions: [BOM_VIEW_PERMISSION],
    analytics: {
      event_type: "bill-of-material",
      action_type: "view",
    },
  },
  {
    // New ID for Preview
    path: "/merchandising/preview-BOM/:styleId",
    name: "Preview BOM",
    component: <PreviewBOM />, // Your PreviewBOM component
    breadcrumbname: "Preview BOM",
    layout: "/merchandising/preview-BOM",
    allowedpermissions: [BOM_VIEW_PERMISSION], // Adjust permissions if needed
    analytics: {
      event_type: "bill-of-material",
      action_type: "view",
    },
  },
  // {
  //
  //   path: "/accounting/iou",
  //   name: "iou",
  //   component: <Iou />,
  //   breadcrumbname: "iou",
  //   layout: "/accounting/iou",
  //   allowedpermissions: [""],
  // },
  // {
  //
  //   path: "/accounting/add-iou",
  //   name: "Add IOU",
  //   component: <AddIou />,
  //   breadcrumbname: "iou",
  //   layout: "/accounting/add-iou",
  //   allowedpermissions: [""],
  // },
  // {
  //
  //   path: "/accounting/update-iou/:iouId",
  //   name: "Update IOU",
  //   component: <UpdateIou />,
  //   breadcrumbname: "iou",
  //   layout: "/accounting/update-iou",
  //   allowedpermissions: [""],
  // },
  // {
  //
  //   path: "/accounting/view-iou/:iouId",
  //   name: "View IOU",
  //   component: <ViewIou />,
  //   breadcrumbname: "iou",
  //   layout: "/accounting/view-iou",
  //   allowedpermissions: [""],
  // },
  {
    path: "/export/sales-contract",
    name: "export-sales-contract",
    component: <ExportSalesContract />,
    breadcrumbname: "iou",
    layout: "/accounting/iou",
    allowedpermissions: [
      SALES_CONTRACT_COMMERCIAL_VIEW_PERMISSION,
      SALES_CONTRACT_COMMERCIAL_CREATE_PERMISSION,
      SALES_CONTRACT_COMMERCIAL_EDIT_PERMISSION,
      SALES_CONTRACT_COMMERCIAL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "sales-contract-master-lc",
      action_type: "view",
    },
  },
  {
    path: "/export/add-sales-contract",
    name: "Add Export Sales Contract",
    component: <AddExportSalesContract />,
    breadcrumbname: "iou",
    layout: "/export/add-sales-contract",
    allowedpermissions: [SALES_CONTRACT_COMMERCIAL_CREATE_PERMISSION],
    analytics: {
      event_type: "sales-contract-master-lc",
      action_type: "view",
    },
  },
  {
    path: "/export/edit-sales-contract/:exportId",
    name: "Edit Export Sales Contract",
    component: <EditExportSalesContract />,
    breadcrumbname: "iou",
    layout: "/export/edit-sales-contract",
    allowedpermissions: [SALES_CONTRACT_COMMERCIAL_EDIT_PERMISSION],
    analytics: {
      event_type: "sales-contract-master-lc",
      action_type: "view",
    },
  },
  {
    path: "/import/b2blc",
    name: "import-b2blc",
    component: <ImportB2bLc />,
    breadcrumbname: "iou",
    layout: "/accounting/iou",
    allowedpermissions: [
      B2BLC_VIEW_PERMISSION,
      B2BLC_CREATE_PERMISSION,
      B2BLC_EDIT_PERMISSION,
      B2BLC_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "import-b2b-lc-rtgs-tt",
      action_type: "view",
    },
  },
  {
    path: "/import/add-b2blc",
    name: "Add B2B LC",
    component: <AddB2bLc />,
    breadcrumbname: "iou",
    layout: "/export/add-sales-contract",
    allowedpermissions: [B2BLC_CREATE_PERMISSION],
    analytics: {
      event_type: "import-b2b-lc-rtgs-tt",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-b2blc/:importId",
    name: "Edit Export Sales Contract",
    component: <EditB2bLc />,
    breadcrumbname: "iou",
    layout: "/import/edit-b2blc/:importId",
    allowedpermissions: [B2BLC_EDIT_PERMISSION],
    analytics: {
      event_type: "import-b2b-lc-rtgs-tt",
      action_type: "view",
    },
  },
  {
    path: "/import/pi",
    name: "import-pi",
    component: <ImportPi />,
    breadcrumbname: "iou",
    layout: "/accounting/iou",
    allowedpermissions: [PI_VIEW_PERMISSION, PI_CREATE_PERMISSION, PI_EDIT_PERMISSION, PI_DELETE_PERMISSION],
    analytics: {
      event_type: "proforma-invoice",
      action_type: "view",
    },
  },
  {
    path: "/import/add-pi",
    name: "Add PI",
    component: <AddPi />,
    breadcrumbname: "iou",
    layout: "/export/add-sales-contract",
    allowedpermissions: [PI_CREATE_PERMISSION],
    analytics: {
      event_type: "proforma-invoice",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-pi/:importId",
    name: "Edit PI",
    component: <EditPi />,
    breadcrumbname: "iou",
    layout: "/import/edit-pi/:importId",
    allowedpermissions: [PI_EDIT_PERMISSION],
    analytics: {
      event_type: "proforma-invoice",
      action_type: "view",
    },
  },
  {
    path: "/import/view-pi/:importId",
    name: "View PI",
    component: <ViewPi />,
    breadcrumbname: "iou",
    layout: "/import/view-pi/:importId",
    allowedpermissions: [PI_VIEW_PERMISSION],
    analytics: {
      event_type: "proforma-invoice",
      action_type: "view",
    },
  },
  {
    path: "/import/details/:supplierTypeId",
    name: "import-details",
    component: <ImportDetails />,
    breadcrumbname: "iou",
    layout: "/accounting/iou",
    allowedpermissions: [
      DAILY_IMPORT_POSITION_VIEW_PERMISSION,
      DAILY_IMPORT_POSITION_CREATE_PERMISSION,
      DAILY_IMPORT_POSITION_EDIT_PERMISSION,
      DAILY_IMPORT_POSITION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "import-shipment-status",
      action_type: "view",
    },
  },
  {
    path: "/import/add-detail/:supplierType",
    name: "Add Details",
    component: <AddDetails />,
    breadcrumbname: "iou",
    layout: "/export/add-sales-contract",
    allowedpermissions: [DAILY_IMPORT_POSITION_CREATE_PERMISSION],
    analytics: {
      event_type: "import-shipment-status",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-detail/:importId/:supplierType",
    name: "Edit Details",
    component: <EditDetails />,
    breadcrumbname: "iou",
    layout: "/import/edit-detail/:importId",
    allowedpermissions: [DAILY_IMPORT_POSITION_EDIT_PERMISSION],
    analytics: {
      event_type: "import-shipment-status",
      action_type: "view",
    },
  },
  {
    path: "/import/acceptance-details",
    name: "import-acceptance-details",
    component: <ImportAcceptanceDetails />,
    breadcrumbname: "iou",
    layout: "/accounting/iou",
    allowedpermissions: [
      IMPORT_ACCEPTANCE_DETAIL_VIEW_PERMISSION,
      IMPORT_ACCEPTANCE_DETAIL_CREATE_PERMISSION,
      IMPORT_ACCEPTANCE_DETAIL_EDIT_PERMISSION,
      IMPORT_ACCEPTANCE_DETAIL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "import-acceptance-payment-details",
      action_type: "view",
    },
  },
  {
    path: "/import/add-acceptance-detail",
    name: "Add Acceptance Details",
    component: <AcceptanceDetails isAdd />,
    breadcrumbname: "iou",
    layout: "/export/add-sales-contract",
    allowedpermissions: [IMPORT_ACCEPTANCE_DETAIL_CREATE_PERMISSION],
    analytics: {
      event_type: "import-acceptance-payment-details",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-acceptance-detail/:importId",
    name: "Edit Acceptance Details",
    component: <AcceptanceDetails isEdit />,
    breadcrumbname: "iou",
    layout: "/import/edit-acceptance-detail/:importId",
    allowedpermissions: [IMPORT_ACCEPTANCE_DETAIL_EDIT_PERMISSION],
    analytics: {
      event_type: "import-acceptance-payment-details",
      action_type: "view",
    },
  },
  {
    path: "/configuration/warehouse",
    name: "Warehouse Configuration",
    component: <WarehouseConfig />,
    breadcrumbname: "warehouse-config",
    layout: "/configuration/warehouse",
    allowedpermissions: [
      WAREHOUSE_VIEW_PERMISSION,
      WAREHOUSE_CREATE_PERMISSION,
      WAREHOUSE_EDIT_PERMISSION,
      WAREHOUSE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/rack",
    name: "Rack Configuration",
    component: <RackConfig />,
    breadcrumbname: "rack-config",
    layout: "/configuration/rack",
    allowedpermissions: [RACK_VIEW_PERMISSION, RACK_CREATE_PERMISSION, RACK_EDIT_PERMISSION, RACK_DELETE_PERMISSION],
  },
  {
    path: "/configuration/bin",
    name: "Bin Configuration",
    component: <BinConfig />,
    breadcrumbname: "bin-config",
    layout: "/configuration/bin",
    allowedpermissions: [BIN_VIEW_PERMISSION, BIN_CREATE_PERMISSION, BIN_EDIT_PERMISSION, BIN_DELETE_PERMISSION],
  },
  {
    path: "/configuration/carton-warehouse",
    name: "Carton Warehouse Configuration",
    component: <CartonWarehouseConfig />,
    breadcrumbname: "carton-warehouse-config",
    layout: "/configuration/carton-warehouse",
    allowedpermissions: [
      CARTON_WAREHOUSE_VIEW_PERMISSION,
      CARTON_WAREHOUSE_CREATE_PERMISSION,
      CARTON_WAREHOUSE_EDIT_PERMISSION,
      CARTON_WAREHOUSE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/carton-floor",
    name: "Carton Floor Configuration",
    component: <CartonFloorConfig />,
    breadcrumbname: "carton-floor-config",
    layout: "/configuration/carton-floor",
    allowedpermissions: [
      CARTON_FLOOR_VIEW_PERMISSION,
      CARTON_FLOOR_CREATE_PERMISSION,
      CARTON_FLOOR_EDIT_PERMISSION,
      CARTON_FLOOR_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/carton-partition",
    name: "Carton Partition Configuration",
    component: <CartonPartitionConfig />,
    breadcrumbname: "carton-partition-config",
    layout: "/configuration/carton-partition",
    allowedpermissions: [
      CARTON_PARTITION_VIEW_PERMISSION,
      CARTON_PARTITION_CREATE_PERMISSION,
      CARTON_PARTITION_EDIT_PERMISSION,
      CARTON_PARTITION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/fabric-defect-category",
    name: "Fabric Defect Category Configuration",
    component: <FabricDefectCategoryConfig />,
    breadcrumbname: "fabric-defect-category-config",
    layout: "/configuration/fabric-defect-category",
    allowedpermissions: [
      "no-permission-required",
      FABRIC_DEFECT_CATEGORY_VIEW_PERMISSION,
      FABRIC_DEFECT_CATEGORY_CREATE_PERMISSION,
      FABRIC_DEFECT_CATEGORY_EDIT_PERMISSION,
      FABRIC_DEFECT_CATEGORY_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/unit",
    name: "Unit Configuration",
    component: <UnitConfig />,
    breadcrumbname: "unit-config",
    layout: "/configuration/unit",
    allowedpermissions: [UNIT_VIEW_PERMISSION, UNIT_CREATE_PERMISSION, UNIT_EDIT_PERMISSION, UNIT_DELETE_PERMISSION],
  },
  {
    path: "/configuration/supplier",
    name: "Supplier Configuration",
    component: <SupplierConfig />,
    breadcrumbname: "supplier-config",
    layout: "/configuration/supplier",
    allowedpermissions: [
      SUPPLIER_VIEW_PERMISSION,
      SUPPLIER_CREATE_PERMISSION,
      SUPPLIER_EDIT_PERMISSION,
      SUPPLIER_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "supplier",
      action_type: "view",
    },
  },
  {
    path: "/inventory/finish-good",
    name: "Finish Good",
    component: <FinishGood />,
    breadcrumbname: "finish-good",
    layout: "/inventory/finish-good",
    allowedpermissions: [
      FINISH_GARMENT_VIEW_PERMISSION,
      FINISH_GARMENT_CREATE_PERMISSION,
      FINISH_GARMENT_EDIT_PERMISSION,
      FINISH_GARMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "finish-good",
      action_type: "view",
    },
  },
  {
    path: "/fabric-inspection",
    name: "Fabric Inspection",
    component: <FabricInspection />,
    breadcrumbname: "fabric-inspection",
    layout: "/fabric-inspection",
    allowedpermissions: [
      FABRIC_INSPECTION_VIEW_PERMISSION,
      FABRIC_INSPECTION_CREATE_PERMISSION,
      FABRIC_INSPECTION_EDIT_PERMISSION,
      FABRIC_INSPECTION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/final-inspection",
    name: "Final Inspection",
    component: <FinalInspection />,
    breadcrumbname: "final-inspection",
    layout: "/final-inspection",
    allowedpermissions: [
      FINAL_PRODUCT_INSPECTION_VIEW_PERMISSION,
      FINAL_PRODUCT_INSPECTION_CREATE_PERMISSION,
      FINAL_PRODUCT_INSPECTION_EDIT_PERMISSION,
      FINAL_PRODUCT_INSPECTION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/final-inspection/add",
    name: "Final Inspection Add",
    component: <FinalInspectionForm />,
    breadcrumbname: "final-inspection-add",
    layout: "/final-inspection/add",
    allowedpermissions: [FINAL_PRODUCT_INSPECTION_CREATE_PERMISSION],
  },
  {
    path: "/final-inspection/edit/:id",
    name: "Final Inspection Edit",
    component: <FinalInspectionForm isEdit={true} />,
    breadcrumbname: "final-inspection-edit",
    layout: "/final-inspection/edit",
    allowedpermissions: [FINAL_PRODUCT_INSPECTION_EDIT_PERMISSION],
  },
  {
    path: "/inventory/carton-inventory",
    name: "carton-inventory",
    component: <CartonInventoryList />,
    layout: "/inventory/carton-inventory",
    allowedpermissions: [
      CARTON_INVENTORY_VIEW_PERMISSION,
      CARTON_INVENTORY_CREATE_PERMISSION,
      CARTON_INVENTORY_EDIT_PERMISSION,
      CARTON_INVENTORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "carton-inventory",
      action_type: "view",
    },
  },
  {
    path: "/inventory/carton-inventory/add",
    name: "carton-inventory-add",
    component: <CreateCartonInventory />,
    layout: "/inventory/carton-inventory/add",
    allowedpermissions: [
      CARTON_INVENTORY_VIEW_PERMISSION,
      CARTON_INVENTORY_CREATE_PERMISSION,
      CARTON_INVENTORY_EDIT_PERMISSION,
      CARTON_INVENTORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "carton-inventory",
      action_type: "create",
    },
  },
  {
    path: "/configuration/color",
    name: "Color Configuration",
    component: <ColorConfig />,
    breadcrumbname: "color-config",
    layout: "/configuration/color",
    allowedpermissions: [
      COLOR_VIEW_PERMISSION,
      COLOR_CREATE_PERMISSION,
      COLOR_EDIT_PERMISSION,
      COLOR_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/size",
    name: "Size Configuration",
    component: <SizeConfig />,
    breadcrumbname: "size-config",
    layout: "/configuration/size",
    allowedpermissions: [SIZE_VIEW_PERMISSION, SIZE_CREATE_PERMISSION, SIZE_EDIT_PERMISSION, SIZE_DELETE_PERMISSION],
  },
  {
    path: "/configuration/unit-convertion",
    name: "Unit Convertion",
    component: <UnitConvertionConfig />,
    breadcrumbname: "unit-convertion-config",
    layout: "/configuration/unit-convertion",
    allowedpermissions: [UNIT_VIEW_PERMISSION, UNIT_CREATE_PERMISSION, UNIT_EDIT_PERMISSION, UNIT_DELETE_PERMISSION],
  },
  {
    path: "/import/budget-pi",
    name: "budget-pi",
    component: <BudgetPi />,
    breadcrumbname: "iou",
    layout: "/accounting/iou",
    allowedpermissions: [PI_BUDGET_VIEW_PERMISSION],
  },
  {
    path: "/export/export-details",
    name: "export-details",
    component: <ExportDetails />,
    breadcrumbname: "export-details",
    layout: "/export/export-details",
    allowedpermissions: [
      EXPORT_DETAILS_VIEW_PERMISSION,
      EXPORT_DETAILS_CREATE_PERMISSION,
      EXPORT_DETAILS_EDIT_PERMISSION,
      EXPORT_DETAILS_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "export-details",
      action_type: "view",
    },
  },
  {
    path: "/export/add-export-details",
    name: "add-export-details",
    component: <AddExportDetails />,
    breadcrumbname: "add-export-details",
    layout: "/export/add-export-details",
    allowedpermissions: [EXPORT_DETAILS_CREATE_PERMISSION],
    analytics: {
      event_type: "export-details",
      action_type: "view",
    },
  },
  {
    path: "/export/edit-export-details/:exportId",
    name: "edit-export-details",
    component: <EditExportDetails />,
    breadcrumbname: "edit-export-details",
    layout: "/export/edit-export-details",
    allowedpermissions: [EXPORT_DETAILS_EDIT_PERMISSION],
    analytics: {
      event_type: "export-details",
      action_type: "view",
    },
  },
  {
    path: "/export/submission-realization",
    name: "submission-realization",
    component: <SubmissionRealization />,
    breadcrumbname: "submission-realization",
    layout: "/export/submission-realization",
    allowedpermissions: [
      SUBMISSION_REALIZATION_VIEW_PERMISSION,
      SUBMISSION_REALIZATION_CREATE_PERMISSION,
      SUBMISSION_REALIZATION_EDIT_PERMISSION,
      SUBMISSION_REALIZATION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "export-submission-realization",
      action_type: "view",
    },
  },
  {
    path: "/export/add-submission-realization",
    name: "add-submission-realization",
    component: <AddSubmissionRealization />,
    breadcrumbname: "add-submission-realization",
    layout: "/export/add-submission-realization",
    allowedpermissions: [SUBMISSION_REALIZATION_CREATE_PERMISSION],
    analytics: {
      event_type: "export-submission-realization",
      action_type: "view",
    },
  },
  {
    path: "/export/edit-submission-realization/:exportId",
    name: "edit-submission-realization",
    component: <EditSubmissionRealization />,
    breadcrumbname: "edit-submission-realization",
    layout: "/export/edit-submission-realization",
    allowedpermissions: [SUBMISSION_REALIZATION_EDIT_PERMISSION],
    analytics: {
      event_type: "export-submission-realization",
      action_type: "view",
    },
  },
  {
    path: "/import-customs-clearance/noting-assessment-examination",
    name: "noting-assessment-examination",
    component: <Noting />,
    breadcrumbname: "noting-assessment-examination",
    layout: "/import-customs-clearance/noting-assessment-examination",
    allowedpermissions: [
      NOTING_ASSESSMENT_VIEW_PERMISSION,
      NOTING_ASSESSMENT_CREATE_PERMISSION,
      NOTING_ASSESSMENT_EDIT_PERMISSION,
      NOTING_ASSESSMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "noting-assessment-and-examinations",
      action_type: "view",
    },
  },
  {
    path: "/import-customs-clearance/add-noting-assessment-examination",
    name: "add-noting-assessment-examination",
    component: <AddNoting />,
    breadcrumbname: "add-noting-assessment-examination",
    layout: "/import-customs-clearance/add-noting-assessment-examination",
    allowedpermissions: [NOTING_ASSESSMENT_CREATE_PERMISSION],
    analytics: {
      event_type: "noting-assessment-and-examinations",
      action_type: "view",
    },
  },
  {
    path: "/import-customs-clearance/edit-noting-assessment-examination/:notingId",
    name: "edit-noting-assessment-examination",
    component: <EditNoting />,
    breadcrumbname: "edit-noting-assessment-examination",
    layout: "/import-customs-clearance/edit-noting-assessment-examination",
    allowedpermissions: [NOTING_ASSESSMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "noting-assessment-and-examinations",
      action_type: "view",
    },
  },
  {
    path: "/import/goods-delivery",
    name: "goods-delivery",
    component: <GoodsDelivery />,
    breadcrumbname: "goods-delivery",
    layout: "/import/goods-delivery",
    allowedpermissions: [
      GOODS_DELIVERY_VIEW_PERMISSION,
      GOODS_DELIVERY_CREATE_PERMISSION,
      GOODS_DELIVERY_EDIT_PERMISSION,
      GOODS_DELIVERY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "import-shipment-for-single-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/export/goods-delivery",
    name: "export-goods-delivery",
    component: <GoodsDelivery />,
    breadcrumbname: "export-goods-delivery",
    layout: "/export/goods-delivery",
    allowedpermissions: [
      EXPORT_SHIPMENT_VIEW_PERMISSION,
      EXPORT_SHIPMENT_CREATE_PERMISSION,
      EXPORT_SHIPMENT_EDIT_PERMISSION,
      EXPORT_SHIPMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "export-shipment-for-single-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/import/add-goods-delivery",
    name: "add-goods-delivery",
    component: <GoodsDeliveryForm />,
    breadcrumbname: "add-goods-delivery",
    layout: "/export/add-goods-delivery",
    allowedpermissions: [GOODS_DELIVERY_CREATE_PERMISSION],
    analytics: {
      event_type: "import-shipment-for-single-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-goods-delivery/:importId",
    name: "edit-goods-delivery",
    component: <GoodsDeliveryForm editMode={true} />,
    breadcrumbname: "edit-goods-delivery",
    layout: "/import/edit-goods-delivery",
    allowedpermissions: [GOODS_DELIVERY_EDIT_PERMISSION],
    analytics: {
      event_type: "import-shipment-for-single-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/export/add-goods-delivery",
    name: "export-add-goods-delivery",
    component: <GoodsDeliveryForm />,
    breadcrumbname: "export-add-goods-delivery",
    layout: "/export/add-goods-delivery",
    allowedpermissions: [EXPORT_SHIPMENT_CREATE_PERMISSION],
    analytics: {
      event_type: "export-shipment-for-single-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/export/edit-goods-delivery/:importId",
    name: "export-edit-goods-delivery",
    component: <GoodsDeliveryForm editMode={true} />,
    breadcrumbname: "export-edit-goods-delivery",
    layout: "/export/edit-goods-delivery",
    allowedpermissions: [EXPORT_SHIPMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "export-shipment-for-single-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/import/vehicle-assignment",
    name: "vehicle-assignment",
    component: <ImportVehicleAssignment />,
    breadcrumbname: "vehicle-assignment",
    layout: "/import/vehicle-assignment",
    allowedpermissions: [
      IMPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
      IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
      IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
      IMPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "import-shipment-for-multiple-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/export/vehicle-assignment",
    name: "export-vehicle-assignment",
    component: <ImportVehicleAssignment />,
    breadcrumbname: "export-vehicle-assignment",
    layout: "/export/vehicle-assignment",
    allowedpermissions: [
      EXPORT_VEHICLE_ASSIGNMENT_VIEW_PERMISSION,
      EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION,
      EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION,
      EXPORT_VEHICLE_ASSIGNMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "export-shipment-for-multiple-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/import/add-vehicle-assignment",
    name: "add-vehicle-assignment",
    component: <ImportVehicleAssignmentForm />,
    breadcrumbname: "add-vehicle-assignment",
    layout: "/import/add-vehicle-assignment",
    allowedpermissions: [IMPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION],
    analytics: {
      event_type: "import-shipment-for-multiple-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-vehicle-assignment/:assignmentId",
    name: "edit-vehicle-assignment",
    component: <ImportVehicleAssignmentForm editMode={true} />,
    breadcrumbname: "edit-vehicle-assignment",
    layout: "/import/edit-vehicle-assignment",
    allowedpermissions: [IMPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "import-shipment-for-multiple-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/export/add-vehicle-assignment",
    name: "export-add-vehicle-assignment",
    component: <ImportVehicleAssignmentForm />,
    breadcrumbname: "export-add-vehicle-assignment",
    layout: "/export/add-vehicle-assignment",
    allowedpermissions: [EXPORT_VEHICLE_ASSIGNMENT_STORE_PERMISSION],
    analytics: {
      event_type: "export-shipment-for-multiple-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/export/edit-vehicle-assignment/:assignmentId",
    name: "export-edit-vehicle-assignment",
    component: <ImportVehicleAssignmentForm editMode={true} />,
    breadcrumbname: "export-edit-vehicle-assignment",
    layout: "/export/edit-vehicle-assignment",
    allowedpermissions: [EXPORT_VEHICLE_ASSIGNMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "export-shipment-for-multiple-vehicle",
      action_type: "view",
    },
  },
  {
    path: "/local/outgoing",
    name: "local-outgoing",
    component: <LocalShipment />,
    breadcrumbname: "local-outgoing",
    layout: "/local/outgoing",
    allowedpermissions: [
      LOCAL_OUTGOING_SHIPMENT_VIEW_PERMISSION,
      LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
      LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
      LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "local-outgoing-shipment",
      action_type: "view",
    },
  },
  {
    path: "/local/add-outgoing",
    name: "local-add-outgoing",
    component: <LocalShipmentForm />,
    breadcrumbname: "local-add-outgoing",
    layout: "/local/add-outgoing",
    allowedpermissions: [LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION],
    analytics: {
      event_type: "local-outgoing-shipment",
      action_type: "view",
    },
  },
  {
    path: "/local/edit-outgoing/:localShipmentId",
    name: "local-edit-outgoing",
    component: <LocalShipmentForm editMode={true} />,
    breadcrumbname: "local-edit-outgoing",
    layout: "/local/edit-outgoing",
    allowedpermissions: [LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "local-outgoing-shipment",
      action_type: "view",
    },
  },
  {
    path: "/local/incoming",
    name: "local-incoming",
    component: <LocalShipment />,
    breadcrumbname: "local-incoming",
    layout: "/local/incoming",
    allowedpermissions: [
      LOCAL_INCOMING_SHIPMENT_VIEW_PERMISSION,
      LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
      LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
      LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "local-incoming-shipment",
      action_type: "view",
    },
  },
  {
    path: "/local/add-incoming",
    name: "local-add-incoming",
    component: <LocalShipmentForm />,
    breadcrumbname: "local-add-incoming",
    layout: "/local/add-incoming",
    allowedpermissions: [LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION],
    analytics: {
      event_type: "local-incoming-shipment",
      action_type: "view",
    },
  },
  {
    path: "/local/edit-incoming/:localShipmentId",
    name: "local-edit-incoming",
    component: <LocalShipmentForm editMode={true} />,
    breadcrumbname: "local-edit-incoming",
    layout: "/local/edit-incoming",
    allowedpermissions: [LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "local-incoming-shipment",
      action_type: "view",
    },
  },
  {
    path: "/import/vehicle-information",
    name: "vehicle-information",
    component: <ImportVehicleInformation />,
    breadcrumbname: "vehicle-information",
    layout: "/import/vehicle-information",
    allowedpermissions: [
      GOODS_DELIVERY_VIEW_PERMISSION,
      GOODS_DELIVERY_CREATE_PERMISSION,
      GOODS_DELIVERY_EDIT_PERMISSION,
      GOODS_DELIVERY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "vehicle-information",
      action_type: "view",
    },
  },
  {
    path: "/import/add-vehicle-information",
    name: "add-vehicle-information",
    component: <ImportVehicleInformationForm />,
    breadcrumbname: "add-vehicle-information",
    layout: "/export/add-vehicle-information",
    allowedpermissions: [GOODS_DELIVERY_CREATE_PERMISSION],
    analytics: {
      event_type: "vehicle-information",
      action_type: "view",
    },
  },
  {
    path: "/import/edit-vehicle-information/:importId",
    name: "edit-vehicle-information",
    component: <ImportVehicleInformationForm editMode={true} />,
    breadcrumbname: "edit-vehicle-information",
    layout: "/import/edit-vehicle-information",
    allowedpermissions: [GOODS_DELIVERY_EDIT_PERMISSION],
    analytics: {
      event_type: "vehicle-information",
      action_type: "view",
    },
  },
  {
    path: "/report/report-fabric-reconciliation",
    name: "report-fabric-reconciliation",
    component: <FabricReconcil />,
    breadcrumbname: "report-fabric-reconciliation",
    layout: "/report-fabric-reconciliation",
    allowedpermissions: [
      FABRIC_REPORT_VIEW_PERMISSION,
      FABRIC_REPORT_GENERATE_PERMISSION,
      FABRIC_REPORT_DELETE_PERMISSION,
    ],
  },
  {
    path: "/report/report-production-tracking",
    name: "report-production-tracking",
    component: <ProductionTracking />,
    breadcrumbname: "report-production-tracking",
    layout: "/report-production-tracking",
    allowedpermissions: [
      PRODUCT_TRACK_REPORT_VIEW_PERMISSION,
      PRODUCT_TRACK_REPORT_GENERATE_PERMISSION,
      PRODUCT_TRACK_REPORT_DELETE_PERMISSION,
    ],
  },
  {
    path: "/report/report-production-details",
    name: "report-production-details",
    component: <ProductionDetails />,
    breadcrumbname: "report-production-details",
    layout: "/report-production-details",
    allowedpermissions: [PRODUCT_DETAIL_REPORT_GENERATE_PERMISSION, PRODUCT_DETAIL_REPORT_DELETE_PERMISSION],
  },
  {
    path: "/report/supplier-wise-item-price-report",
    name: "report/supplier-wise-item-price-report",
    component: <SupplierwiseItemPriceReport />,
    breadcrumbname: "report/supplier-wise-item-price-report",
    layout: "/report/supplier-wise-item-price-report",
    allowedpermissions: [SUPPLIER_WISE_ITEM_PRICE_REPORT_VIEW_PERMISSION],
  },
  {
    path: "/report/pi-report",
    name: "report/pi-report",
    component: <PIReport />,
    breadcrumbname: "report/pi-report",
    layout: "/report/pi-report",
    allowedpermissions: [PI_REPORT_VIEW_PERMISSION],
  },
  {
    path: "/report/sales-contract-cost",
    name: "report/sales-contract-cost",
    component: <SalesContractCostReport />,
    breadcrumbname: "report/sales-contract-cost",
    layout: "/report/sales-contract-cost",
    allowedpermissions: [SALES_CONTRACT_COSTING_REPORT],
  },
  {
    path: "/report/report-cost-sheet",
    name: "report-cost-sheet",
    component: <CostSheet />,
    breadcrumbname: "report-cost-sheet",
    layout: "/report-cost-sheet",
    allowedpermissions: [
      COST_SHEET_REPORT_VIEW_PERMISSION,
      COST_SHEET_REPORT_GENERATE_PERMISSION,
      COST_SHEET_REPORT_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-files",
    name: "import-files",
    component: <ImportFiles />,
    breadcrumbname: "import-files",
    layout: "/import-files",
    allowedpermissions: [
      UPLOAD_BUYER_PERMISSION,
      UPLOAD_BRAND_PERMISSION,
      UPLOAD_BUYING_OFFICE_PERMISSION,
      UPLOAD_BANK_PERMISSION,
      UPLOAD_BRANCH_PERMISSION,
      UPLOAD_MERCHANDISER_PERMISSION,
      UPLOAD_STYLE_PERMISSION,
      UPLOAD_SUBSTYLE_PERMISSION,
      UPLOAD_SALES_CONTRACT_PERMISSION,
      UPLOAD_SUPPLIER_PERMISSION,
      UPLOAD_COLOR_PERMISSION,
      UPLOAD_SIZE_PERMISSION,
      UPLOAD_BOM_PERMISSION,
      UPLOAD_PO_PERMISSION,
    ],
  },
  // {
  //
  //   path: "/ex-factory/security-bolt-seal-log",
  //   name: "security-bolt-seal-log",
  //   component: <SecurityBolt />,
  //   breadcrumbname: "security-bolt-seal-log",
  //   layout: "/ex-factory/security-bolt-seal-log",
  //   allowedpermissions: [
  //     SECURITY_BOLT_VIEW_PERMISSION,
  //     SECURITY_BOLT_CREATE_PERMISSION,
  //     SECURITY_BOLT_EDIT_PERMISSION,
  //     SECURITY_BOLT_DELETE_PERMISSION,
  //   ],
  // },

  {
    path: "/ex-factory/vehicle-information",
    name: "vehicle-information",
    component: <VehicleInformation />,
    breadcrumbname: "vehicle-information",
    layout: "/ex-factory/vehicle-information",
    allowedpermissions: [
      DRIVER_VEHICLE_INFO_VIEW_PERMISSION,
      DRIVER_VEHICLE_INFO_CREATE_PERMISSION,
      DRIVER_VEHICLE_INFO_EDIT_PERMISSION,
      DRIVER_VEHICLE_INFO_DELETE_PERMISSION,
      DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION,
    ],
    analytics: {
      event_type: "exfactor-vehicle-information",
      action_type: "view",
    },
  },
  {
    path: "/ex-factory/driver-information",
    name: "driver-information",
    component: <DriverInformation />,
    breadcrumbname: "driver-information",
    layout: "/ex-factory/driver-information",
    allowedpermissions: [
      DRIVER_VEHICLE_INFO_VIEW_PERMISSION,
      DRIVER_VEHICLE_INFO_CREATE_PERMISSION,
      DRIVER_VEHICLE_INFO_EDIT_PERMISSION,
      DRIVER_VEHICLE_INFO_DELETE_PERMISSION,
      DRIVER_VEHICLE_INFO_DISPATCH_TIME_PERMISSION,
    ],
    analytics: {
      event_type: "driver-information",
      action_type: "view",
    },
  },
  {
    path: "/ex-factory/bolt-seal-usage",
    name: "bolt-seal-usage",
    component: <BoltSealLogList />,
    breadcrumbname: "bolt-seal-usage",
    layout: "/ex-factory/bolt-seal-usage",
    allowedpermissions: [
      BOLT_SEAL_LOG_CREATE_PERMISSION,
      BOLT_SEAL_LOG_EDIT_PERMISSION,
      BOLT_SEAL_LOG_VIEW_PERMISSION,
      BOLT_SEAL_LOG_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "bolt-seal-usage",
      action_type: "view",
    },
  },
  {
    path: "/ex-factory/add-bolt-seal-usage",
    name: "add-bolt-seal-usage",
    component: <AddOrUpdateBoltSealLog />,
    breadcrumbname: "add-bolt-seal-usage",
    layout: "/ex-factory/add-bolt-seal-usage",
    allowedpermissions: [BOLT_SEAL_LOG_CREATE_PERMISSION],
    analytics: {
      event_type: "bolt-seal-usage",
      action_type: "view",
    },
  },
  {
    path: "/ex-factory/edit-bolt-seal-usage/:boltSealId",
    name: "edit-bolt-seal-usage",
    component: <AddOrUpdateBoltSealLog editMode={true} />,
    breadcrumbname: "edit-bolt-seal-usage",
    layout: "/ex-factory/edit-bolt-seal-usage",
    allowedpermissions: [BOLT_SEAL_LOG_EDIT_PERMISSION],
    analytics: {
      event_type: "bolt-seal-usage",
      action_type: "view",
    },
  },
  {
    path: "/ex-factory/add-security-bolt-seal-usage",
    name: "add-security-bolt-seal-usage",
    component: <AddSecurityBolt />,
    breadcrumbname: "add-security-bolt-seal-usage",
    layout: "/ex-factory/add-security-bolt-seal-usage",
    allowedpermissions: [SECURITY_BOLT_CREATE_PERMISSION],
  },
  {
    path: "/ex-factory/edit-security-bolt-seal-usage/:securityBoltId",
    name: "edit-security-bolt-seal-usage",
    component: <EditSecurityBolt />,
    breadcrumbname: "edit-security-bolt-seal-usage",
    layout: "/ex-factory/edit-security-bolt-seal-usage",
    allowedpermissions: [SECURITY_BOLT_EDIT_PERMISSION],
  },
  {
    path: "/ex-factory/packing-report-template",
    name: "ex-factory/packing-report-template",
    component: <PackingReportTemplate />,
    breadcrumbname: "ex-factory/packing-report-template",
    layout: "/ex-factory/packing-report-template",
    allowedpermissions: [PACKING_REPORT_TEMPLATE_VIEW_PERMISSION],
  },
  {
    path: "/ex-factory/packing-report-template/add",
    name: "ex-factory/packing-report-template",
    component: <AddPackingReportTemplate />,
    breadcrumbname: "ex-factory/packing-report-template",
    layout: "/ex-factory/packing-report-template",
    allowedpermissions: [PACKING_REPORT_TEMPLATE_STORE_PERMISSION],
  },
  {
    path: "/ex-factory/packing-report-template/view/:id",
    name: "ex-factory/packing-report-template",
    component: <ViewPackingReportTemplate />,
    breadcrumbname: "ex-factory/packing-report-template",
    layout: "/ex-factory/packing-report-template",
    allowedpermissions: [PACKING_REPORT_TEMPLATE_VIEW_PERMISSION],
  },
  {
    path: "/ex-factory/packing-report-template/edit/:id",
    name: "ex-factory/packing-report-template",
    component: <EditPackingReportTemplate />,
    breadcrumbname: "ex-factory/packing-report-template",
    layout: "/ex-factory/packing-report-template",
    allowedpermissions: [PACKING_REPORT_TEMPLATE_UPDATE_PERMISSION],
  },
  {
    path: "/export-customs-clearance/shipment-handover",
    name: "shipment-handover",
    component: <ShipmentOver />,
    breadcrumbname: "shipment-handover",
    layout: "/ex-factory/security-bolt-seal-log",
    allowedpermissions: [
      SHIPMENT_HANDOVER_VIEW_PERMISSION,
      SHIPMENT_HANDOVER_CREATE_PERMISSION,
      SHIPMENT_HANDOVER_EDIT_PERMISSION,
      SHIPMENT_HANDOVER_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "shipment-handover",
      action_type: "view",
    },
  },
  {
    path: "/export-customs-clearance/add-shipment-handover",
    name: "add-shipment-handover",
    component: <AddShipmentOver />,
    breadcrumbname: "add-shipment-handover",
    layout: "/export-customs-clearance/add-shipment-handover",
    allowedpermissions: [SHIPMENT_HANDOVER_CREATE_PERMISSION],
    analytics: {
      event_type: "shipment-handover",
      action_type: "view",
    },
  },
  {
    path: "/export-customs-clearance/edit-shipment-handover/:shipmentOverId",
    name: "edit-shipment-handover",
    component: <EditShipmentOver />,
    breadcrumbname: "edit-shipment-handover",
    layout: "/export-customs-clearance/edit-shipment-handover",
    allowedpermissions: [SHIPMENT_HANDOVER_EDIT_PERMISSION],
    analytics: {
      event_type: "shipment-handover",
      action_type: "view",
    },
  },
  {
    path: "/report/report-inventory-details",
    name: "report-inventory-details",
    component: <InventoryDetails />,
    breadcrumbname: "report-inventory-details",
    layout: "/report-inventory-details",
    allowedpermissions: [
      INVENTORY_DETAIL_REPORT_VIEW_PERMISSION,
      INVENTORY_DETAIL_REPORT_GENERATE_PERMISSION,
      INVENTORY_DETAIL_REPORT_DELETE_PERMISSION,
    ],
  },
  {
    path: "/report/report-bolt-seal",
    name: "report-bolt-seal",
    component: <BoltSealReport />,
    breadcrumbname: "report-bolt-seal",
    layout: "report-bolt-seal",
    allowedpermissions: [BOLT_SEAL_LOG_REPORT_PERMISSION],
  },
  {
    path: "/report/report-post-costing",
    name: "report-post-costing",
    component: <PostCostingReport />,
    breadcrumbname: "report-post-costing",
    layout: "report-post-costing",
    allowedpermissions: [POST_COSTING_REPORT_GENERATE_PERMISSION],
  },
  {
    path: "/merchandising/purchase-order-new",
    name: "order-details",
    component: <PurchaseOrderNew />,
    breadcrumbname: "Purchase Order",
    layout: "/merchandising/purchase-order-new",
    allowedpermissions: [
      BUYER_PO_PO_WISE_VIEW_PERMISSION,
      BUYER_PO_PO_WISE_CREATE_PERMISSION,
      BUYER_PO_PO_WISE_EDIT_PERMISSION,
      BUYER_PO_PO_WISE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/merchandising/update-purchase-order-new",
    name: "update-purchase-order-new",
    component: <UpdatePurchaseOrderNew />,
    breadcrumbname: "Update Purchase Order New",
    layout: "/merchandising/update-purchase-order-new",
    allowedpermissions: [BUYER_PO_PO_WISE_EDIT_PERMISSION],
  },
  {
    path: "/merchandising/view-purchase-order-new/:styleId",
    name: "View style",
    component: <ViewPONew />,
    breadcrumbname: "View Purchase Order New",
    layout: "/merchandising/view-purchase-order-new/:styleId",
    allowedpermissions: [BUYER_PO_PO_WISE_VIEW_PERMISSION],
  },
  {
    path: "/merchandising/add-purchase-order-new",
    name: "add-order-details",
    component: <AddPurchaseOrderNew />,
    breadcrumbname: "Add Purchase Order New",
    layout: "/merchandising/add-purchase-order-new",
    allowedpermissions: [BUYER_PO_PO_WISE_CREATE_PERMISSION],
  },
  {
    path: "/notifications",
    name: "notifications",
    component: <Notifications />,
    allowedpermissions: [NOTIFICATION_VIEW_PERMISSION],
  },
  {
    path: "/activity-log/all",
    name: "activity-log-all",
    component: <ActivityLog />,
    allowedpermissions: [ACTIVITY_LOG_VIEW_PERMISSION],
  },
  {
    path: "/merchandising/packing-requirements",
    name: "packing-requirements",
    component: <PackingReqList />,
    allowedpermissions: [
      PACKING_VIEW_PERMISSION,
      PACKING_CREATE_PERMISSION,
      PACKING_EDIT_PERMISSION,
      PACKING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "packing-requirements",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/packing-requirements/entry",
    name: "packing-requirements-entry",
    component: <CreatePackingReq />,
    allowedpermissions: [PACKING_CREATE_PERMISSION],
    analytics: {
      event_type: "packing-requirements",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/packing-requirements/edit/:id",
    name: "packing-requirements-update",
    component: <UpdatePackingReq />,
    allowedpermissions: [PACKING_EDIT_PERMISSION],
    analytics: {
      event_type: "packing-requirements",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/packing-requirements/view/:id",
    name: "packing-requirements-update",
    component: <ViewPackingReq />,
    allowedpermissions: [PACKING_EDIT_PERMISSION],
    analytics: {
      event_type: "packing-requirements",
      action_type: "view",
    },
  },
  {
    path: "/report/report-inventory-mrr",
    name: "report-inventory-mrr",
    component: <InventoryMRR />,
    breadcrumbname: "report-inventory-mrr",
    layout: "/report-inventory-mrr",
    allowedpermissions: [
      INVENTORY_MRR_REPORT_VIEW_PERMISSION,
      GENERATE_MRR_REPORT_VIEW_PERMISSION,
      DELETE_MRR_REPORT_VIEW_PERMISSION,
    ],
  },
  {
    path: "/production/packing/packing-confirmation",
    name: "packing-confirmation",
    component: <PackingConfirmation />,
    allowedpermissions: [
      PACKING_VIEW_PERMISSION,
      PACKING_CREATE_PERMISSION,
      PACKING_EDIT_PERMISSION,
      PACKING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "packing-confirmation",
      action_type: "view",
    },
  },
  {
    path: "/report/report-packing",
    name: "report-packing",
    component: <PackingReport />,
    breadcrumbname: "report-packing",
    layout: "/report-packing",
    allowedpermissions: [PACKING_LIST_REPORT_VIEW_PERMISSION],
  },
  {
    path: "/report/buyer-report-packing",
    name: "buyer-report-packing",
    component: <BuyerPackingReport />,
    breadcrumbname: "report-packing",
    layout: "/buyer-report-packing",
    allowedpermissions: [PACKING_LIST_REPORT_VIEW_PERMISSION],
  },
  {
    path: "/configuration/ob-machine",
    name: "ob-machine",
    component: <OBMachineConfig />,
    breadcrumbname: "ob-machine",
    layout: "/ob-machine",
    allowedpermissions: [
      OB_MACHINE_VIEW_PERMISSION,
      OB_MACHINE_CREATE_PERMISSION,
      OB_MACHINE_EDIT_PERMISSION,
      OB_MACHINE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "ob-machine",
      action_type: "view",
    },
  },
  {
    path: "/configuration/ob-section",
    name: "ob-section",
    component: <OBSectionConfig />,
    breadcrumbname: "ob-section",
    layout: "/ob-section",
    allowedpermissions: [
      OB_SECTION_VIEW_PERMISSION,
      OB_SECTION_CREATE_PERMISSION,
      OB_SECTION_EDIT_PERMISSION,
      OB_SECTION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "ob-section",
      action_type: "view",
    },
  },
  {
    path: "/configuration/ob-sam-data-bank",
    name: "ob-sam-data-bank",
    component: <OBSamBankConfig />,
    breadcrumbname: "ob-sam-data-bank",
    layout: "/ob-sam-data-bank",
    allowedpermissions: [
      OB_SAM_DATA_BANK_VIEW_PERMISSION,
      OB_SAM_DATA_BANK_CREATE_PERMISSION,
      OB_SAM_DATA_BANK_EDIT_PERMISSION,
      OB_SAM_DATA_BANK_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "ob-sam-data-bank",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/operation-bulletin-entry",
    name: "operation-bulletin-entry",
    component: <OBEntry />,
    breadcrumbname: "operation-bulletin-entry",
    layout: "/operation-bulletin-entry",
    allowedpermissions: [OB_VIEW_PERMISSION, OB_CREATE_PERMISSION],
    analytics: {
      event_type: "operation-bulletin",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/operation-bulletin",
    name: "operation-bulletin",
    component: <OperationBulletin />,
    breadcrumbname: "operation-bulletin",
    layout: "/operation-bulletin",
    allowedpermissions: [OB_VIEW_PERMISSION, OB_CREATE_PERMISSION, OB_EDIT_PERMISSION, OB_DELETE_PERMISSION],
    analytics: {
      event_type: "operation-bulletin",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/operation-bulletin/edit/:ob_id",
    name: "operation-bulletin-edit",
    component: <OBEntry edit={true} />,
    breadcrumbname: "operation-bulletin-edit",
    layout: "/operation-bulletin-edit",
    allowedpermissions: [OB_VIEW_PERMISSION, OB_CREATE_PERMISSION, OB_EDIT_PERMISSION, OB_DELETE_PERMISSION],
    analytics: {
      event_type: "operation-bulletin",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/operation-bulletin/show/:ob_id",
    name: "operation-bulletin-show",
    component: <OperationBulletinShow view={true} />,
    breadcrumbname: "operation-bulletin-show",
    layout: "/operation-bulletin-show",
    allowedpermissions: [OB_VIEW_PERMISSION],
    analytics: {
      event_type: "operation-bulletin",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/cost-estimate",
    name: "cost-estimate",
    component: <CostEstimate />,
    breadcrumbname: "cost-estimate",
    layout: "/cost-estimate",
    allowedpermissions: [
      COST_ESTIMATE_VIEW_PERMISSION,
      COST_ESTIMATE_CREATE_PERMISSION,
      COST_ESTIMATE_EDIT_PERMISSION,
      COST_ESTIMATE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "cost-estimate",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/cost-estimate-entry",
    name: "cost-estimate-entry",
    component: <AddOrUpdateCostEstimate />,
    breadcrumbname: "cost-estimate-entry",
    layout: "/cost-estimate-entry",
    allowedpermissions: [COST_ESTIMATE_CREATE_PERMISSION],
    analytics: {
      event_type: "cost-estimate",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/cost-estimate-update/:id",
    name: "cost-estimate-update",
    component: <AddOrUpdateCostEstimate editMode={true} viewMode={false} />,
    breadcrumbname: "cost-estimate-update",
    layout: "/cost-estimate-update",
    allowedpermissions: [COST_ESTIMATE_EDIT_PERMISSION],
    analytics: {
      event_type: "cost-estimate",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/cost-estimate-view/:id",
    name: "cost-estimate-view",
    component: <AddOrUpdateCostEstimate viewMode={true} editMode={false} />,
    breadcrumbname: "cost-estimate-view",
    layout: "/cost-estimate-view",
    allowedpermissions: [COST_ESTIMATE_VIEW_PERMISSION],
    analytics: {
      event_type: "cost-estimate",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/amend-sales-contact/:styleId",
    name: "amend-sales-contact",
    component: <UpdateSalesContact isAmend />,
    breadcrumbname: "style",
    layout: "/merchandising/amend-sales-contact",
    allowedpermissions: [SALES_CONTRACT_EDIT_PERMISSION],
  },
  {
    path: "/configuration/ob-template",
    name: "ob-template",
    component: <OBTemplate />,
    breadcrumbname: "ob-template",
    layout: "/ob-template",
    allowedpermissions: [
      OB_TEMPLATE_VIEW_PERMISSION,
      OB_TEMPLATE_CREATE_PERMISSION,
      OB_TEMPLATE_EDIT_PERMISSION,
      OB_TEMPLATE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "ob-template",
      action_type: "view",
    },
  },
  {
    path: "/configuration/ob-template-add",
    name: "ob-template-add",
    component: <OBTemplateForm isAdd />,
    breadcrumbname: "ob-template-add",
    layout: "/ob-template-add",
    allowedpermissions: [OB_TEMPLATE_CREATE_PERMISSION],
    analytics: {
      event_type: "ob-template",
      action_type: "view",
    },
  },
  {
    path: "/configuration/ob-template-edit/:ob_id",
    name: "ob-template-edit",
    component: <OBTemplateForm isEdit />,
    breadcrumbname: "ob-template-edit",
    layout: "/ob-template-edit",
    allowedpermissions: [OB_TEMPLATE_EDIT_PERMISSION],
    analytics: {
      event_type: "ob-template",
      action_type: "view",
    },
  },
  {
    path: "/configuration/buyer/edit/:buyerId",
    name: "buyer-edit",
    component: <CreateOrEditBuyer isEdit />,
    allowedpermissions: [BUYER_EDIT_PERMISSION],
    analytics: {
      event_type: "buyer",
      action_type: "view",
    },
  },
  {
    path: "/configuration/buying-office/edit/:buyingOfficeId",
    name: "edit-buying-office",
    component: <CreateOrEditBuyingOffice isEdit />,
    allowedpermissions: [BUYING_OFFICE_CREATE_PERMISSION],
    analytics: {
      event_type: "buying-office",
      action_type: "view",
    },
  },
  {
    path: "/settings/notification-slugs",
    name: "notification-slugs",
    component: <NotificationSlugs />,
    layout: "/settings/notification-slugs",
    allowedpermissions: [
      NOTIFICATION_SLUG_VIEW_PERMISSION,
      NOTIFICATION_SLUG_CREATE_PERMISSION,
      NOTIFICATION_SLUG_EDIT_PERMISSION,
      NOTIFICATION_SLUG_DELETE_PERMISSION,
    ],
  },
  {
    path: "/settings/notification-slugs/create",
    name: "create-slug",
    component: <AddOrUpdateNotificationSlug />,
    layout: "/settings/notification-slugs/create",
    allowedpermissions: [NOTIFICATION_SLUG_CREATE_PERMISSION],
  },
  {
    path: "/settings/notification-slug-update/:id",
    name: "create-slug",
    component: <AddOrUpdateNotificationSlug editMode={true} viewMode={false} />,
    layout: "/settings/notification-slugs-update",
    allowedpermissions: [NOTIFICATION_SLUG_EDIT_PERMISSION],
  },
  {
    path: "/settings/notification-settings",
    name: "notification-settings",
    component: <NotificationSettings />,
    layout: "/settings/notification-settings",
    allowedpermissions: [
      NOTIFICATION_SETTING_VIEW_PERMISSION,
      NOTIFICATION_SETTING_CREATE_PERMISSION,
      NOTIFICATION_SETTING_EDIT_PERMISSION,
      NOTIFICATION_SETTING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/settings/notification-settings/create",
    name: "create-settings",
    component: <AddOrUpdateNotificationSetting />,
    layout: "/settings/notification-slugs/create",
    allowedpermissions: [NOTIFICATION_SETTING_CREATE_PERMISSION],
  },
  {
    path: "/settings/notification-settings-update/:id",
    name: "update-settings",
    component: <AddOrUpdateNotificationSetting editMode={true} viewMode={false} />,
    layout: "/settings/notification-settings-update",
    allowedpermissions: [NOTIFICATION_SETTING_EDIT_PERMISSION],
  },
  {
    path: "/settings/notification-settings-view/:id",
    name: "view-settings",
    component: <ViewNotificationSetting editMode={true} viewMode={false} />,
    layout: "/settings/notification-settings-view",
    allowedpermissions: [NOTIFICATION_SETTING_VIEW_PERMISSION],
  },
  {
    path: "/configuration/challan",
    name: "Rack Configuration",
    component: <ChallanConfig />,
    breadcrumbname: "challan-config",
    layout: "/configuration/challan",
    allowedpermissions: [
      CHALLAN_CREATE_PERMISSION,
      CHALLAN_EDIT_PERMISSION,
      CHALLAN_VIEW_PERMISSION,
      CHALLAN_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production/daily-line-target",
    name: "Daily Line Target",
    component: <DailyLineTarget />,
    breadcrumbname: "daily-line-target-config",
    layout: "/production/daily-line-target",
    allowedpermissions: [
      DAILY_LINE_TARGET_CREATE_PERMISSION,
      DAILY_LINE_TARGET_EDIT_PERMISSION,
      DAILY_LINE_TARGET_VIEW_PERMISSION,
      DAILY_LINE_TARGET_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "daily-line-target",
      action_type: "view",
    },
  },
  {
    path: "/local-purchase-reconciliation",
    name: "Local Purchase Reconciliation",
    component: <LocalPurchaseReconciliation />,
    breadcrumbname: "local-purchase-reconciliation",
    layout: "/import/local-purchase-reconciliation",
    allowedpermissions: [
      LOCAL_PURCHASE_RECONCILIATION_VIEW_PERMISSION,
      LOCAL_PURCHASE_RECONCILIATION_CREATE_PERMISSION,
      LOCAL_PURCHASE_RECONCILIATION_EDIT_PERMISSION,
      LOCAL_PURCHASE_RECONCILIATION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "local-purchase-reconciliation",
      action_type: "view",
    },
  },
  {
    path: "/local-purchase-reconciliation/create",
    name: "Local Purchase Reconciliation",
    component: <AddLocalPurchaseReconciliation />,
    breadcrumbname: "local-purchase-reconciliation/create",
    layout: "/local-purchase-reconciliation/create",
    allowedpermissions: [LOCAL_PURCHASE_RECONCILIATION_CREATE_PERMISSION],
    analytics: {
      event_type: "local-purchase-reconciliation",
      action_type: "view",
    },
  },
  {
    path: "/local-purchase-reconciliation/edit/:reconciliationId",
    name: "Local Purchase Reconciliation",
    component: <UpdateLocalPurchaseReconciliation />,
    breadcrumbname: "local-purchase-reconciliation/edit/:reconciliationId",
    layout: "/local-purchase-reconciliation/edit/:reconciliationId",
    allowedpermissions: [LOCAL_PURCHASE_RECONCILIATION_EDIT_PERMISSION],
    analytics: {
      event_type: "local-purchase-reconciliation",
      action_type: "view",
    },
  },
  {
    path: "/local-purchase-reconciliation/view/:reconciliationId",
    name: "Local Purchase Reconciliation",
    component: <UpdateLocalPurchaseReconciliation viewMode={true} />,
    breadcrumbname: "local-purchase-reconciliation/view/:reconciliationId",
    layout: "/local-purchase-reconciliation/view/:reconciliationId",
    allowedpermissions: [LOCAL_PURCHASE_RECONCILIATION_VIEW_PERMISSION],
    analytics: {
      event_type: "local-purchase-reconciliation",
      action_type: "view",
    },
  },
  {
    path: "/report/hourly-production",
    name: "hourly-production",
    component: <HourlyProduction />,
    breadcrumbname: "hourly-production",
    layout: "/hourly-production",
    allowedpermissions: [HOURLY_PRODUCTION_VIEW_PERMISSION],
  },
  {
    path: "/report/hourly-production-detail-report",
    name: "hourly-production-detail-report",
    component: <HourlyProductionDetailReport />,
    breadcrumbname: "hourly-production-detail-report",
    layout: "/hourly-production-detail-report",
    allowedpermissions: [HOURLY_PRODUCTION_VIEW_PERMISSION],
  },
  {
    path: "/configuration/garment-category",
    name: "Garment Category",
    component: <GarmentCategoryConfig />,
    breadcrumbname: "garment-category",
    layout: "/configuration/garment-category",
    allowedpermissions: [
      GARMENT_CATEGORY_VIEW_PERMISSION,
      GARMENT_CATEGORY_CREATE_PERMISSION,
      GARMENT_CATEGORY_EDIT_PERMISSION,
      GARMENT_CATEGORY_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/garment-type",
    name: "Garment Type",
    component: <GarmentTypeConfig />,
    breadcrumbname: "garment-type",
    layout: "/configuration/garment-type",
    allowedpermissions: [
      GARMENT_TYPE_VIEW_PERMISSION,
      GARMENT_TYPE_CREATE_PERMISSION,
      GARMENT_TYPE_EDIT_PERMISSION,
      GARMENT_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/air-hole-types",
    name: "Air Hole Types",
    component: <AirHoleTypeConfig />,
    breadcrumbname: "air-hole-types",
    layout: "/configuration/air-hole-types",
    allowedpermissions: [
      AIR_HOLE_TYPE_VIEW_PERMISSION,
      AIR_HOLE_TYPE_CREATE_PERMISSION,
      AIR_HOLE_TYPE_EDIT_PERMISSION,
      AIR_HOLE_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/au-formulas",
    name: "AU Formulas",
    component: <AuFormulaConfig />,
    breadcrumbname: "au-formulas",
    layout: "/configuration/au-formulas",
    allowedpermissions: [
      AU_FORMULA_VIEW_PERMISSION,
      AU_FORMULA_CREATE_PERMISSION,
      AU_FORMULA_EDIT_PERMISSION,
      AU_FORMULA_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/carton-types",
    name: "Carton Types",
    component: <CartonTypeConfig />,
    breadcrumbname: "carton-types",
    layout: "/configuration/carton-types",
    allowedpermissions: [
      CARTON_TYPE_VIEW_PERMISSION,
      CARTON_TYPE_CREATE_PERMISSION,
      CARTON_TYPE_EDIT_PERMISSION,
      CARTON_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/gusset-types",
    name: "Gusset Types",
    component: <GussetTypeConfig />,
    breadcrumbname: "gusset-types",
    layout: "/configuration/gusset-types",
    allowedpermissions: [
      GUSSET_TYPE_VIEW_PERMISSION,
      GUSSET_TYPE_CREATE_PERMISSION,
      GUSSET_TYPE_EDIT_PERMISSION,
      GUSSET_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/plies",
    name: "Plies",
    component: <PlyConfig />,
    breadcrumbname: "plies",
    layout: "/configuration/plies",
    allowedpermissions: [PLY_VIEW_PERMISSION, PLY_CREATE_PERMISSION, PLY_EDIT_PERMISSION, PLY_DELETE_PERMISSION],
  },
  {
    path: "/configuration/poly-types",
    name: "Poly Types",
    component: <PolyTypeConfig />,
    breadcrumbname: "poly-types",
    layout: "/configuration/poly-types",
    allowedpermissions: [
      POLY_TYPE_VIEW_PERMISSION,
      POLY_TYPE_CREATE_PERMISSION,
      POLY_TYPE_EDIT_PERMISSION,
      POLY_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/supporting-material-types",
    name: "Supporting Material Types",
    component: <SupportingMaterialTypeConfig />,
    breadcrumbname: "supporting-material-types",
    layout: "/configuration/supporting-material-types",
    allowedpermissions: [
      SUPPORTING_MATERIAL_TYPE_VIEW_PERMISSION,
      SUPPORTING_MATERIAL_TYPE_CREATE_PERMISSION,
      SUPPORTING_MATERIAL_TYPE_EDIT_PERMISSION,
      SUPPORTING_MATERIAL_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/cost-of-making/expense-calculation",
    name: "Expense Calcualtion",
    component: <CmExpenseCalculation />,
    breadcrumbname: "cost-of-making",
    layout: "/cm-expense-calculation",
    allowedpermissions: [COST_OF_MAKING_LIST, COST_OF_MAKING_CREATE, COST_OF_MAKING_EDIT, COST_OF_MAKING_DELETE],
    analytics: {
      event_type: "expense-data-calculation",
      action_type: "view",
    },
  },
  {
    path: "/cost-of-making/default-data",
    name: "Default Data",
    component: <CmDefaultData />,
    breadcrumbname: "cost-of-making",
    layout: "/cm-default-data",
    allowedpermissions: [COST_OF_MAKING_LIST, COST_OF_MAKING_CREATE, COST_OF_MAKING_EDIT, COST_OF_MAKING_DELETE],
    analytics: {
      event_type: "cost-of-making-default-data",
      action_type: "view",
    },
  },
  {
    path: "/configuration/inquiry-reasons",
    name: "Inquiry Reasons Configuration",
    component: <InquiryReasonsConfig />,
    breadcrumbname: "inquiry-reasons",
    layout: "/configuration/inquiry-reasons",
    allowedpermissions: [
      INQUIRY_REASONS_CREATE_PERMISSION,
      INQUIRY_REASONS_EDIT_PERMISSION,
      INQUIRY_REASONS_VIEW_PERMISSION,
      INQUIRY_REASONS_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/inquiry-remarks",
    name: "Inquiry Remarks Configuration",
    component: <InquiryRemarksConfig />,
    breadcrumbname: "inquiry-remarks",
    layout: "/configuration/inquiry-remarks",
    allowedpermissions: [
      INQUIRY_REMARKS_CREATE_PERMISSION,
      INQUIRY_REMARKS_EDIT_PERMISSION,
      INQUIRY_REMARKS_VIEW_PERMISSION,
      INQUIRY_REMARKS_DELETE_PERMISSION,
    ],
  },
  {
    path: "/merchandising/buyer-inquiry",
    name: "Buyer Inquiry",
    component: <BuyerInquiry />,
    breadcrumbname: "buyer-inquiry",
    layout: "/merchandising/buyer-inquiry",
    allowedpermissions: [
      BUYER_INQUIRY_VIEW_PERMISSION,
      BUYER_INQUIRY_CREATE_PERMISSION,
      BUYER_INQUIRY_EDIT_PERMISSION,
      BUYER_INQUIRY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-buyer-inquiry",
    name: "add-buyer-inquiry",
    component: <AddBuyerInquiry />,
    breadcrumbname: "Add Buyer Inquiry",
    layout: "/merchandising/add-buyer-inquiry",
    allowedpermissions: [BUYER_INQUIRY_CREATE_PERMISSION],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-buyer-inquiry/:inquiryId",
    name: "update-buyer-inquiry",
    component: <UpdateBuyerInquiry viewMode={false} editMode={true} />,
    breadcrumbname: "Update Buyer Inquiry",
    layout: "/merchandising/update-buyer-inquiry",
    allowedpermissions: [BUYER_INQUIRY_EDIT_PERMISSION],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/capacity-booking",
    name: "Capacity Booking",
    component: <CapacityBooking />,
    breadcrumbname: "capacity-booking",
    layout: "/merchandising/capacity-booking",
    allowedpermissions: [
      CAPACITY_BOOKING_VIEW_PERMISSION,
      CAPACITY_BOOKING_CREATE_PERMISSION,
      CAPACITY_BOOKING_EDIT_PERMISSION,
      CAPACITY_BOOKING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-capacity-booking",
    name: "add-capacity-booking",
    component: <AddCapacityBooking />,
    breadcrumbname: "Add Capacity Booking",
    layout: "/merchandising/add-capacity-booking",
    allowedpermissions: [CAPACITY_BOOKING_CREATE_PERMISSION],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/view-capacity-booking/:inquiryId",
    name: "view-capacity-booking",
    component: <UpdateCapacityBooking viewMode={true} editMode={false} />,
    breadcrumbname: "View Capacity Booking",
    layout: "/merchandising/view-capacity-booking",
    allowedpermissions: [CAPACITY_BOOKING_VIEW_PERMISSION],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-capacity-booking/:inquiryId",
    name: "update-capacity-booking",
    component: <UpdateCapacityBooking viewMode={false} editMode={true} />,
    breadcrumbname: "Update Capacity Booking",
    layout: "/merchandising/update-capacity-booking",
    allowedpermissions: [CAPACITY_BOOKING_EDIT_PERMISSION],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/capacity-booking-special-process/:inquiryId",
    name: "capacity-booking-special-process",
    component: <CapacityBookingSpecialProcess />,
    breadcrumbname: "Capacity Booking Special Process",
    layout: "/merchandising/capacity-booking-special-process",
    allowedpermissions: [CAPACITY_BOOKING_VIEW_PERMISSION],
    analytics: {
      event_type: "buyer-inquiry",
      action_type: "view",
    },
  },
  {
    path: "/cost-of-making/details/:buyerInquiryId",
    name: "cost-of-making-details",
    component: <CostOfMakingReport />,
    breadcrumbname: "Update Buyer Inquiry",
    layout: "/cost-of-making/details",
    allowedpermissions: [COST_OF_MAKING_DETAILS],
  },
  {
    path: "/merchandising/add-style-from-inquiry/:inquiryId",
    name: "Add style",
    component: <AddStyleFromInquiry />,
    breadcrumbname: "style",
    layout: "/merchandising/add-style",
    allowedpermissions: [STYLE_CREATE_PERMISSION],
  },
  {
    path: "/merchandising/sales-contact-size-specs/:salesContractId",
    name: "sales-contact-size-specs",
    component: <SizeSpecs />,
    breadcrumbname: "style",
    layout: "/merchandising/sales-contact-size-specs",
    allowedpermissions: [SALES_CONTRACT_EDIT_PERMISSION],
  },
  {
    path: "/merchandising/learning-curves",
    name: "learning-curves",
    component: <LearningCure />,
    breadcrumbname: "learning-curves",
    layout: "/learning-curves",
    allowedpermissions: [
      LEARNING_CURVE_VIEW_PERMISSION,
      LEARNING_CURVE_CREATE_PERMISSION,
      LEARNING_CURVE_EDIT_PERMISSION,
      LEARNING_CURVE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "learning-curves",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/learning-curves/create",
    name: "learning-curves-create",
    component: <AddOrUpdateLearningCure />,
    breadcrumbname: "learning-curves/create",
    layout: "/learning-curves-create",
    allowedpermissions: [
      LEARNING_CURVE_VIEW_PERMISSION,
      LEARNING_CURVE_CREATE_PERMISSION,
      LEARNING_CURVE_EDIT_PERMISSION,
      LEARNING_CURVE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "learning-curves",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/learning-curves/:id",
    name: "learning-curves-edit",
    component: <AddOrUpdateLearningCure editMode={true} viewMode={false} />,
    breadcrumbname: "learning-curves/edit",
    layout: "/learning-curves-edit",
    allowedpermissions: [
      LEARNING_CURVE_VIEW_PERMISSION,
      LEARNING_CURVE_CREATE_PERMISSION,
      LEARNING_CURVE_EDIT_PERMISSION,
      LEARNING_CURVE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "learning-curves",
      action_type: "view",
    },
  },
  {
    path: "/production/sewing-new",
    name: "sewing",
    component: <SewingNew />,
    allowedpermissions: [
      SEWING_VIEW_PERMISSION,
      SEWING_CREATE_PERMISSION,
      SEWING_EDIT_PERMISSION,
      SEWING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "sewing",
      action_type: "view",
    },
  },
  {
    path: "/production/sewing-new/create",
    name: "sewing-create",
    component: <SewingCreate />,
    allowedpermissions: [SEWING_CREATE_PERMISSION],
    analytics: {
      event_type: "sewing",
      action_type: "view",
    },
  },
  {
    path: "/production/sewing-new/update",
    name: "sewing-update",
    component: <SewingUpdate />,
    allowedpermissions: [SEWING_EDIT_PERMISSION],
    analytics: {
      event_type: "sewing",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/operation-bulletin/update-manpower/:ob_id",
    name: "operation-bulletin-update-manpower",
    component: <OBEntry manpowerMode={true} />,
    breadcrumbname: "operation-bulletin-update-manpower",
    layout: "/operation-bulletin-update-manpower",
    allowedpermissions: [OB_VIEW_PERMISSION, OB_CREATE_PERMISSION, OB_EDIT_PERMISSION, OB_DELETE_PERMISSION],
    analytics: {
      event_type: "operation-bulletin",
      action_type: "view",
    },
  },
  {
    path: "/configuration/item-category-sequence",
    name: "item-category-sequence",
    component: <ItemCategorySequence />,
    layout: "/configuration/item-category-sequence",
    allowedpermissions: [ITEM_CATEGORY_CREATE_PERMISSION, ITEM_CATEGORY_EDIT_PERMISSION],
  },
  {
    path: "/settings/permission",
    name: "Permission Settings",
    component: <PermissionSettings />,
    breadcrumbname: "permission-settings",
    layout: "/settings/permission",
    allowedpermissions: [
      PERMISSION_VIEW_PERMISSION,
      PERMISSION_CREATE_PERMISSION,
      PERMISSION_EDIT_PERMISSION,
      PERMISSION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production/cutting/cutting-item-entry",
    name: "production",
    component: <CreateCuttingItemEntry />,
    allowedpermissions: [
      CUTTING_VIEW_PERMISSION,
      CUTTING_CREATE_PERMISSION,
      CUTTING_EDIT_PERMISSION,
      CUTTING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "cutting",
      action_type: "view",
    },
  },
  {
    path: "/inventory/store/trims-store-entry/add",
    name: "inventory-trims-store-add",
    component: <CreateTrimsInventory />,
    allowedpermissions: [
      INVENTORY_VIEW_PERMISSION,
      INVENTORY_CREATE_PERMISSION,
      INVENTORY_EDIT_PERMISSION,
      INVENTORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "trims-and-accessories",
      action_type: "create",
    },
  },
  {
    path: "/inventory/store/trims-store-entry",
    name: "inventory-trims-store",
    component: <TrimsStoreEntryList />,
    allowedpermissions: [
      INVENTORY_VIEW_PERMISSION,
      INVENTORY_CREATE_PERMISSION,
      INVENTORY_EDIT_PERMISSION,
      INVENTORY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "trims-and-accessories",
      action_type: "view",
    },
  },
  {
    path: "/production/cutting/update",
    name: "cutting-update",
    component: (
      <CuttingContextProvider>
        <UpdateCutting />
      </CuttingContextProvider>
    ),
    allowedpermissions: [CUTTING_CREATE_PERMISSION, CUTTING_EDIT_PERMISSION],
    analytics: {
      event_type: "cutting",
      action_type: "view",
    },
  },
  {
    path: "/production/assignment/entry",
    name: "assignment-entry",
    component: (
      <AssignmentContextProvider>
        <AssignmentEntry />
      </AssignmentContextProvider>
    ),
    allowedpermissions: [ASSIGNMENT_CREATE_PERMISSION, ASSIGNMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "assignment",
      action_type: "view",
    },
  },
  {
    path: "/production/folding/update",
    name: "folding-update",
    component: (
      <FoldingContextProvider>
        <UpdateFolding />
      </FoldingContextProvider>
    ),
    allowedpermissions: [FOLDING_CREATE_PERMISSION, FOLDING_EDIT_PERMISSION],
    analytics: {
      event_type: "folding",
      action_type: "view",
    },
  },
  {
    path: "/export/view-sales-contract/:exportId",
    name: "View Export Sales Contract",
    component: <EditExportSalesContract view={true} />,
    breadcrumbname: "view-sales-contract",
    layout: "/export/view-sales-contract",
    allowedpermissions: [SALES_CONTRACT_COMMERCIAL_VIEW_PERMISSION],
    analytics: {
      event_type: "sales-contract-master-lc",
      action_type: "view",
    },
  },
  {
    path: "/export/view-export-details/:exportId",
    name: "view-export-details",
    component: <EditExportDetails isView={true} />,
    breadcrumbname: "view-export-details",
    layout: "/export/view-export-details",
    allowedpermissions: [EXPORT_DETAILS_VIEW_PERMISSION],
    analytics: {
      event_type: "export-details",
      action_type: "view",
    },
  },
  {
    path: "/export/view-submission-realization/:exportId",
    name: "view-submission-realization",
    component: <EditSubmissionRealization view={true} />,
    breadcrumbname: "view-submission-realization",
    layout: "/export/view-submission-realization",
    allowedpermissions: [SUBMISSION_REALIZATION_VIEW_PERMISSION],
    analytics: {
      event_type: "export-submission-realization",
      action_type: "view",
    },
  },
  {
    path: "/import/view-b2blc/:importId",
    name: "View B2BLC",
    component: <EditB2bLc view={true} />,
    breadcrumbname: "import",
    layout: "/import/view-b2blc/:importId",
    allowedpermissions: [B2BLC_VIEW_PERMISSION],
    analytics: {
      event_type: "import-b2b-lc-rtgs-tt",
      action_type: "view",
    },
  },
  {
    path: "/import/view-detail/:importId/:supplierType",
    name: "View Details",
    component: <EditDetails view={true} />,
    breadcrumbname: "view-details",
    layout: "/import/view-detail/:importId",
    allowedpermissions: [DAILY_IMPORT_POSITION_VIEW_PERMISSION],
    analytics: {
      event_type: "import-shipment-status",
      action_type: "view",
    },
  },
  {
    path: "/import/view-acceptance-detail/:importId",
    name: "View Acceptance Details",
    component: <AcceptanceDetails view={true} />,
    breadcrumbname: "view-acceptance-detail",
    layout: "/import/view-acceptance-detail/:importId",
    allowedpermissions: [IMPORT_ACCEPTANCE_DETAIL_VIEW_PERMISSION],
  },

  {
    path: "/merchandising/view-buyer-inquiry/:inquiryId",
    name: "view-buyer-inquiry",
    component: <UpdateBuyerInquiry viewMode={true} editMode={false} />,
    breadcrumbname: "View Buyer Inquiry",
    layout: "/merchandising/view-buyer-inquiry",
    allowedpermissions: [BUYER_INQUIRY_VIEW_PERMISSION],
  },
  {
    path: "/merchandising/buyer-inquiry-approval/:inquiryId",
    name: "buyer-inquiry-approval",
    component: <BuyerInquiryApproval />,
    breadcrumbname: "View Approval",
    layout: "/merchandising/buyer-inquiry-approval",
    allowedpermissions: [CM_VALUE_APPROVE_PERMISSION],
  },
  {
    path: "/tanda/process",
    name: "process",
    component: <Process />,
    breadcrumbname: "Process",
    layout: "/tna/process",
    allowedpermissions: [TNA_PROCESS_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-process",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-process",
    name: "add-process",
    component: <AddProcess />,
    breadcrumbname: "Add Process",
    layout: "/tanda/add-process",
    allowedpermissions: [TNA_PROCESS_CREATE_PERMISSION],
    analytics: {
      event_type: "tna-process",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-process/:processId",
    name: "Update Process",
    component: <UpdateProcess viewMode={false} />,
    breadcrumbname: "Update Process",
    layout: "/tanda/update-process",
    allowedpermissions: [TNA_PROCESS_EDIT_PERMISSION],
    analytics: {
      event_type: "tna-process",
      action_type: "view",
    },
  },
  {
    path: "/tanda/view-process/:processId",
    name: "Update Process",
    component: <UpdateProcess viewMode={true} />,
    breadcrumbname: "Update Process",
    layout: "/tanda/view-process",
    allowedpermissions: [TNA_PROCESS_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-process",
      action_type: "view",
    },
  },
  {
    path: "/tanda/department",
    name: "department",
    component: <Department />,
    breadcrumbname: "Department",
    layout: "/tna/department",
    allowedpermissions: [TNA_DEPARTMENT_VIEW_PERMISSION],
  },
  {
    path: "/tanda/add-department",
    name: "add-department",
    component: <AddDepartment />,
    breadcrumbname: "Add department",
    layout: "/tanda/add-department",
    allowedpermissions: [TNA_DEPARTMENT_CREATE_PERMISSION],
  },
  {
    path: "/tanda/update-department/:deptId",
    name: "Update department",
    component: <UpdateDepartment viewMode={false} />,
    breadcrumbname: "Update department",
    layout: "/tanda/update-department",
    allowedpermissions: [TNA_DEPARTMENT_EDIT_PERMISSION],
  },
  {
    path: "/tanda/view-department/:deptId",
    name: "View department",
    component: <UpdateDepartment viewMode={true} />,
    breadcrumbname: "View department",
    layout: "/tanda/view-department",
    allowedpermissions: [TNA_DEPARTMENT_VIEW_PERMISSION],
  },
  {
    path: "/tanda/task",
    name: "task",
    component: <Task />,
    breadcrumbname: "Task",
    layout: "/tna/task",
    allowedpermissions: [TNA_TASK_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-task",
    name: "add-department",
    component: <AddTask />,
    breadcrumbname: "Add Task",
    layout: "/tanda/add-task",
    allowedpermissions: [TNA_TASK_CREATE_PERMISSION],
    analytics: {
      event_type: "tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-task/:taskId",
    name: "Update Task",
    component: <UpdateTask viewMode={false} />,
    breadcrumbname: "Update Task",
    layout: "/tanda/update-task",
    allowedpermissions: [TNA_TASK_EDIT_PERMISSION],
    analytics: {
      event_type: "tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/view-task/:taskId",
    name: "View Task",
    component: <UpdateTask viewMode={true} />,
    breadcrumbname: "View Task",
    layout: "/tanda/view-task",
    allowedpermissions: [TNA_TASK_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/new-task",
    name: "New Task",
    component: <NewTask />,
    breadcrumbname: "New Task",
    layout: "/tanda/new-task",
    allowedpermissions: [TNA_TASK_VIEW_PERMISSION],
    analytics: {
      event_type: "new-tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-new-task",
    name: "Add New Task",
    component: <AddNewTask />,
    breadcrumbname: "Add New Task",
    layout: "/tanda/add-new-task",
    allowedpermissions: [TNA_TASK_CREATE_PERMISSION],
    analytics: {
      event_type: "new-tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-new-task/:newTaskId",
    name: "Update New Task",
    component: <UpdateNewTask viewMode={false} />,
    breadcrumbname: "Update New Task",
    layout: "/tanda/update-new-task",
    allowedpermissions: [TNA_TASK_EDIT_PERMISSION],
    analytics: {
      event_type: "new-tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/view-new-task/:newTaskId",
    name: "View New Task",
    component: <UpdateNewTask viewMode={true} />,
    breadcrumbname: "View New Task",
    layout: "/tanda/view-new-task",
    allowedpermissions: [TNA_TASK_VIEW_PERMISSION],
    analytics: {
      event_type: "new-tna-tasks",
      action_type: "view",
    },
  },
  {
    path: "/tanda/template",
    name: "TNA Template List",
    component: <TNATemplate />,
    breadcrumbname: "TNA Template List",
    layout: "/tanda/template-list",
    allowedpermissions: [TNA_TEMPLATE_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-template",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-template",
    name: "TNA Template Add",
    component: <AddOrUpdateTNATemplate />,
    breadcrumbname: "TNA Template Add",
    layout: "/tanda/add-template",
    allowedpermissions: [TNA_TEMPLATE_CREATE_PERMISSION],
    analytics: {
      event_type: "tna-template",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-template/:templateID",
    name: "TNA Template Update",
    component: <AddOrUpdateTNATemplate isEdit={true} />,
    breadcrumbname: "TNA Template Update",
    layout: "/tanda/update-template",
    allowedpermissions: [TNA_TEMPLATE_EDIT_PERMISSION],
    analytics: {
      event_type: "tna-template",
      action_type: "view",
    },
  },
  {
    path: "/tanda/new-template",
    name: "New TNA Template List",
    component: <NewTNATemplate />,
    breadcrumbname: "New TNA Template List",
    layout: "/tanda/new-template-list",
    allowedpermissions: [TNA_TEMPLATE_VIEW_PERMISSION],
    analytics: {
      event_type: "new-tna-template",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-new-template",
    name: "New TNA Template Add",
    component: <AddOrUpdateNewTNATemplate />,
    breadcrumbname: "New TNA Template Add",
    layout: "/tanda/add-new-template",
    allowedpermissions: [TNA_TEMPLATE_CREATE_PERMISSION],
    analytics: {
      event_type: "new-tna-template",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-new-template/:templateID",
    name: "New TNA Template Update",
    component: <AddOrUpdateNewTNATemplate isEdit={true} />,
    breadcrumbname: "New TNA Template Update",
    layout: "/tanda/update-new-template",
    allowedpermissions: [TNA_TEMPLATE_EDIT_PERMISSION],
    analytics: {
      event_type: "new-tna-template",
      action_type: "view",
    },
  },
  {
    path: "/tanda/tna-by-styles",
    name: "TNA By Styles List",
    component: <TNAByStyles />,
    breadcrumbname: "TNA By Styles List",
    layout: "/tanda/tna-by-styles",
    allowedpermissions: [TNA_BY_STYLE_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-by-style",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-tna-by-style",
    name: "TNA By Styles Add",
    component: <AddOrUpdateTNAByStyle />,
    breadcrumbname: "TNA By Styles Add",
    layout: "/tanda/add-tna-by-style",
    allowedpermissions: [TNA_BY_STYLE_CREATE_PERMISSION],
    analytics: {
      event_type: "tna-by-style",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-tna-by-style/:tnaByStyleID",
    name: "TNA By Styles Update",
    component: <AddOrUpdateTNAByStyle isEdit={true} />,
    breadcrumbname: "TNA By Styles Update",
    layout: "/tanda/update-tna-by-style",
    allowedpermissions: [TNA_BY_STYLE_EDIT_PERMISSION],
    analytics: {
      event_type: "tna-by-style",
      action_type: "view",
    },
  },
  {
    path: "/tanda/plan-list",
    name: "TNA Plan List",
    component: <TNAPlan />,
    breadcrumbname: "TNA Plan List",
    layout: "/tanda/plan-list",
    allowedpermissions: [TNA_PLAN_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-plan",
      action_type: "view",
    },
  },
  {
    path: "/tanda/add-plan",
    name: "TNA Plan Add",
    component: <AddTNAPlan />,
    breadcrumbname: "TNA Plan Add",
    layout: "/tanda/add-plan",
    allowedpermissions: [TNA_PLAN_CREATE_PERMISSION],
    analytics: {
      event_type: "tna-plan",
      action_type: "view",
    },
  },
  {
    path: "/tanda/update-plan/:planID",
    name: "TNA Plan Update",
    component: <AddTNAPlan isEdit={true} />,
    breadcrumbname: "TNA Plan Update",
    layout: "/tanda/update-plan",
    allowedpermissions: [TNA_PLAN_EDIT_PERMISSION],
    analytics: {
      event_type: "tna-plan",
      action_type: "view",
    },
  },
  {
    path: "/tanda/todo-list",
    name: "Todo List",
    component: <TodoList />,
    breadcrumbname: "Todo List",
    layout: "/tanda/todo-lis",
    allowedpermissions: [TNA_TO_DO_LIST_VIEW_PERMISSION],
    analytics: {
      event_type: "todo-list",
      action_type: "view",
    },
  },
  {
    path: "/tanda/new-todo-list",
    name: "New Todo List",
    component: <NewTodoList />,
    breadcrumbname: "New Todo List",
    layout: "/tanda/new-todo-list",
    allowedpermissions: [TNA_TO_DO_LIST_VIEW_PERMISSION],
    analytics: {
      event_type: "new-todo-list",
      action_type: "view",
    },
  },
  {
    path: "/tanda/new-summary",
    name: "New T & A Summary",
    component: <NewSummaryList />,
    breadcrumbname: "New TNA Summary",
    layout: "/tanda/new-summary",
    allowedpermissions: [TNA_SUMMARY_VIEW_PERMISSION],
    analytics: {
      event_type: "new-tna-summary",
      action_type: "view",
    },
  },
  {
    path: "/tanda/new-summary/:summaryId",
    name: "New T & A Summary Details",
    component: <NewSummaryView />,
    breadcrumbname: "New TNA Summary View",
    layout: "/tanda/new-summary",
    allowedpermissions: [TNA_PLAN_SUMMARY_DETAILS_PERMISSION],
    analytics: {
      event_type: "new-tna-summary",
      action_type: "view",
    },
  },
  {
    path: "/tanda/new-progress/:salesContractId",
    name: "New T&A Progress",
    component: <NewSummaryProgress />,
    breadcrumbname: "New TNA progress View",
    layout: "/tanda/new-progress",
    allowedpermissions: [TNA_PLAN_SUMMARY_GRAPH_PERMISSION],
    analytics: {
      event_type: "new-tna-summary",
      action_type: "view",
    },
  },
  {
    path: "/tanda/summary",
    name: "T & A Summary",
    component: <SummaryList />,
    breadcrumbname: "TNA Summary",
    layout: "/tanda/summary",
    allowedpermissions: [TNA_SUMMARY_VIEW_PERMISSION],
    analytics: {
      event_type: "tna-summary",
      action_type: "view",
    },
  },
  {
    path: "/tanda/summary/:summaryId",
    name: "T & A Summary",
    component: <SummaryView />,
    breadcrumbname: "TNA Summary View",
    layout: "/tanda/summary",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "tna-summary",
      action_type: "view",
    },
  },
  {
    path: "/tanda/progress/:salesContractId",
    name: "T&A Progress",
    component: <ProgressGraph />,
    breadcrumbname: "TNA progress View",
    layout: "/tanda/progress",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/production/packing/update",
    name: "packing-update",
    component: <PackingConfirmation isEdit={true} />,
    allowedpermissions: [
      PACKING_VIEW_PERMISSION,
      PACKING_CREATE_PERMISSION,
      PACKING_EDIT_PERMISSION,
      PACKING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "packing-confirmation",
      action_type: "view",
    },
  },
  {
    path: "/production/fabric-accessories-auto-reconciliation",
    name: "fabric-accessories-auto-reconciliation",
    component: (
      <FabricAutoContextProvider>
        <FabricAccessoriesAutoReconciliation />
      </FabricAutoContextProvider>
    ),
    allowedpermissions: [FABRIC_ACCESSORIES_AUTO_RECONCILIATION_VIEW_PERMISSION],
    analytics: {
      event_type: "fabric-accessories-auto-reconciliation",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/supervisor-checklist",
    name: "digitalization-supervisor-checklist",
    component: <SupervisorChecklist />,
    allowedpermissions: [DIGITALIZATION_CHECKLIST_VIEW_PERMISSION],
    analytics: {
      event_type: "supervisor-checklist",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/supervisor-checklist/view/:id",
    name: "digitalization-supervisor-checklist-view",
    component: <SupervisorChecklistView />,
    allowedpermissions: [DIGITALIZATION_CHECKLIST_VIEW_PERMISSION],
    analytics: {
      event_type: "supervisor-checklist",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/operator-absenteeism",
    name: "digitalization-operator-absenteeism",
    component: <OperatorAbsenteeism />,
    allowedpermissions: [DIGITALIZATION_ABSENTEEISM_VIEW_PERMISSION],
    analytics: {
      event_type: "operator-absenteeism",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/operator-absenteeism/view/:id",
    name: "digitalization-operator-absenteeism-view",
    component: <OperatorAbsenteeismView />,
    allowedpermissions: [DIGITALIZATION_ABSENTEEISM_VIEW_PERMISSION],
    analytics: {
      event_type: "operator-absenteeism",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/production-defect",
    name: "digitalization-production-defect",
    component: <ProductionDefect />,
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "production-defects",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/production-defect/view/:id",
    name: "digitalization-production-defect-view",
    component: <ProductionDefectView />,
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "production-defects",
      action_type: "view",
    },
  },
  {
    path: "/configuration/upload-item-ocr",
    name: "upload-item-ocr",
    component: <ItemOCR />,
    layout: "/configuration/upload-item-ocr",
    allowedpermissions: [ITEM_OCR_UPLOAD_PERMISSION],
    analytics: {
      event_type: "upload-item-ocr",
      action_type: "view",
    },
  },
  {
    path: "/production-planning/weekends",
    name: "weekends",
    component: <Weekends />,
    layout: "/production-planning/weekends",
    allowedpermissions: [
      PP_WEEKEND_VIEW_PERMISSION,
      PP_WEEKEND_CREATE_PERMISSION,
      PP_WEEKEND_EDIT_PERMISSION,
      PP_WEEKEND_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production-planning/weekends/create",
    name: "create-weekend",
    component: <AddOrUpdateWeekend />,
    layout: "/production-planning/weekends/create",
    allowedpermissions: [PP_WEEKEND_CREATE_PERMISSION],
  },
  {
    path: "/production-planning/weekend-update/:id",
    name: "create-weekend",
    component: <AddOrUpdateWeekend editMode={true} viewMode={false} />,
    layout: "/production-planning/weekends-update",
    allowedpermissions: [PP_WEEKEND_EDIT_PERMISSION],
  },
  {
    path: "/production-planning/holidays",
    name: "holidays",
    component: <Holidays />,
    layout: "/production-planning/holidays",
    allowedpermissions: [
      PP_HOLIDAY_VIEW_PERMISSION,
      PP_HOLIDAY_CREATE_PERMISSION,
      PP_HOLIDAY_EDIT_PERMISSION,
      PP_HOLIDAY_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production-planning/holidays/create",
    name: "create-holiday",
    component: <AddOrUpdateHoliday />,
    layout: "/production-planning/holidays/create",
    allowedpermissions: [PP_HOLIDAY_CREATE_PERMISSION],
  },
  {
    path: "/production-planning/holiday-update/:id",
    name: "create-holiday",
    component: <AddOrUpdateHoliday editMode={true} viewMode={false} />,
    layout: "/production-planning/holidays-update",
    allowedpermissions: [PP_HOLIDAY_EDIT_PERMISSION],
  },
  //exception
  {
    path: "/production-planning/exceptions",
    name: "exceptions",
    component: <Exceptions />,
    layout: "/production-planning/exceptions",
    allowedpermissions: [
      PP_EXCEPTION_VIEW_PERMISSION,
      PP_EXCEPTION_CREATE_PERMISSION,
      PP_EXCEPTION_EDIT_PERMISSION,
      PP_EXCEPTION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production-planning/exceptions/create",
    name: "create-exception",
    component: <AddOrUpdateException />,
    layout: "/production-planning/exceptions/create",
    allowedpermissions: [PP_EXCEPTION_CREATE_PERMISSION],
  },
  {
    path: "/production-planning/exception-update/:id",
    name: "create-exception",
    component: <AddOrUpdateException editMode={true} viewMode={false} />,
    layout: "/production-planning/exceptions-update",
    allowedpermissions: [PP_EXCEPTION_EDIT_PERMISSION],
  },
  //Planning Request
  {
    path: "/production-planning/planningRequests",
    name: "planningRequests",
    component: <PlanningRequests />,
    layout: "/production-planning/planningRequests",
    allowedpermissions: [
      PP_PLANNING_REQUEST_VIEW_PERMISSION,
      PP_PLANNING_REQUEST_CREATE_PERMISSION,
      PP_PLANNING_REQUEST_EDIT_PERMISSION,
      PP_PLANNING_REQUEST_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "planning-request",
      action_type: "view",
    },
  },
  {
    path: "/production-planning/planningRequests/create",
    name: "create-planningRequest",
    component: <AddOrUpdatePlanningRequest />,
    layout: "/production-planning/planningRequests/create",
    allowedpermissions: [PP_PLANNING_REQUEST_CREATE_PERMISSION],
    analytics: {
      event_type: "planning-request",
      action_type: "view",
    },
  },
  {
    path: "/production-planning/planningRequests-update/:id",
    name: "create-planningRequest",
    component: <AddOrUpdatePlanningRequest editMode={true} viewMode={false} />,
    layout: "/production-planning/planningRequests-update",
    allowedpermissions: [PP_PLANNING_REQUEST_EDIT_PERMISSION],
    analytics: {
      event_type: "planning-request",
      action_type: "view",
    },
  },
  {
    path: "/production-planning/plan-entry",
    name: "production-planning-entry",
    component: (
      <ProductionPlanningContextProvider>
        <ProductionPlanning />
      </ProductionPlanningContextProvider>
    ),
    layout: "/production-planning/plan-entry",
    allowedpermissions: [PLAN_CREATE_PERMISSION],
    analytics: {
      event_type: "plan-entry",
      action_type: "view",
    },
  },
  {
    path: "digitalization/app-role",
    name: "digitalization-app-role",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <RolePanel />
      </Suspense>
    ),
    layout: "digitalization/app-role",
    allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
    analytics: {
      event_type: "digitalization-menu",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/daily-line-plan",
    name: "digitalization-daily-line-plane",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DailyLinePlanContextProvider>
          <DailyLinePlanList />
        </DailyLinePlanContextProvider>
      </Suspense>
    ),
    layout: "/digitalization/daily-line-plan",
    allowedpermissions: [DAILY_LINE_PLAN_VIEW_PERMISSION],
    analytics: {
      event_type: "line-wise-operator-assignment",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/daily-line-plan/add",
    name: "digitalization-daily-line-plane-add",
    component: (
      <DailyLinePlanContextProvider>
        <DailyLinePlanAdd />
      </DailyLinePlanContextProvider>
    ),
    layout: "/digitalization/daily-line-plan/add",
    allowedpermissions: [DAILY_LINE_PLAN_VIEW_PERMISSION],
    analytics: {
      event_type: "line-wise-operator-assignment",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/daily-line-plan/edit/:id",
    name: "digitalization-daily-line-plane-edit",
    component: (
      <DailyLinePlanContextProvider>
        <DailyLinePlanEdit isEdit={true} />
      </DailyLinePlanContextProvider>
    ),
    layout: "/digitalization/daily-line-plan/edit/:id",
    allowedpermissions: [DAILY_LINE_PLAN_VIEW_PERMISSION],
    analytics: {
      event_type: "line-wise-operator-assignment",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/daily-finishing-line-plan",
    name: "digitalization-daily-line-plane",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DailyFinishingLinePlanContextProvider>
          <DailyFinishingLinePlan />
        </DailyFinishingLinePlanContextProvider>
      </Suspense>
    ),
    layout: "/digitalization/daily-finishing-line-plan",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "daily-finishing-line-plan",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/daily-finishing-line-plan/add",
    name: "digitalization-daily-finishing-line-plan-add",
    component: (
      <DailyFinishingLinePlanContextProvider>
        <DailyFinishingLinePlanAdd />
      </DailyFinishingLinePlanContextProvider>
    ),
    layout: "/digitalization/daily-finishing-line-plan/add",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "daily-finishing-line-plan",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/daily-finishing-line-plan/edit/:id",
    name: "digitalization-daily-finishing-line-plan-edit",
    component: (
      <DailyFinishingLinePlanContextProvider>
        <DailyFinishingLinePlanEdit isEdit={true} />
      </DailyFinishingLinePlanContextProvider>
    ),
    layout: "/digitalization/daily-finishing-line-plan/edit/:id",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "daily-finishing-line-plan",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/category",
    name: "digitalization-defect-category",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DefectCategory />
      </Suspense>
    ),
    layout: "digitalization/defect/category",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-category",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/reason",
    name: "digitalization-defect-reason",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DefectReason />
      </Suspense>
    ),
    layout: "digitalization/defect/reason",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-reason",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/responsible",
    name: "digitalization-defect-responsible",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DefectResponsible />
      </Suspense>
    ),
    layout: "digitalization/defect/responsible",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-responsible",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/recommendation",
    name: "digitalization-defect-recommendation",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DefectRecommendation />
      </Suspense>
    ),
    layout: "digitalization/defect/recommendation",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-recommendation",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/category-mapping",
    name: "digitalization-defect-category-mapping",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DefectCategoryMapping />
      </Suspense>
    ),
    layout: "digitalization/defect/category-mapping",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-category-wise-operation-mapping",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/category-mapping/add",
    name: "digitalization-defect-category-mapping-add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddOrEditCategoryMapping />
      </Suspense>
    ),
    layout: "digitalization/defect/category-mapping-add",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-category-wise-operation-mapping",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/category-mapping/edit/:id",
    name: "digitalization-defect-category-mapping-edit/:id",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddOrEditCategoryMapping />
      </Suspense>
    ),
    layout: "digitalization/defect/category-mapping-edit",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "defect-category-wise-operation-mapping",
      action_type: "view",
    },
  },
  {
    path: "digitalization/defect/line-and-section-mapping",
    name: "digitalization-defect-line-and-section-mapping",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <LineNSectionMapping />
      </Suspense>
    ),
    layout: "digitalization/defect/line-and-section-mapping",
    allowedpermissions: [DIGITALIZATION_DEFECT_VIEW_PERMISSION],
    analytics: {
      event_type: "line-and-section-wise-qa-user-mapping",
      action_type: "view",
    },
  },
  {
    path: "/production-planning/plan-update/:id",
    name: "production-planning-update",
    component: (
      <ProductionPlanningContextProvider>
        <ProductionPlanning editMode={true} />
      </ProductionPlanningContextProvider>
    ),
    layout: "production-planning-update",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/checklist/checklist-questions/list",
    name: "checklist-checklist-questions-list",
    component: <ChecklistQuestionsList />,
    layout: "checklist-checklist-questions",
    allowedpermissions: [CHECKLIST_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "checklist-questions",
      action_type: "view",
    },
  },
  {
    path: "/checklist/checklist-questions/add",
    name: "checklist-questions-add",
    component: <ChecklistQuestionsAdd />,
    layout: "/checklist/checklist-questions/add",
    allowedpermissions: [CHECKLIST_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "checklist-questions",
      action_type: "view",
    },
  },
  {
    path: "/checklist/checklist-questions/edit/:id",
    name: "checklist-questions-edit",
    component: <ChecklistQuestionsEdit />,
    layout: "/checklist/checklist-questions/edit/:id",
    allowedpermissions: [CHECKLIST_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "checklist-questions",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/buyer-wise-checklist",
    name: "buyer-wise-checklist",
    component: <BuyerWiseChecklist />,
    allowedpermissions: [DIGITALIZATION_ROLE_CHECK_PREMISSION],
  },
  {
    path: "/digitalization/buyer-wise-checklist/view/:id",
    name: "buyer-wise-checklist-view",
    component: <BuyerWiseChecklistView />,
    allowedpermissions: [DIGITALIZATION_ROLE_CHECK_PREMISSION],
  },
  // {
  //
  //   path: "/production-planning/dashboard",
  //   name: "production-planning-dashboard",
  //   component: <ProductionPlanningDashboard />,
  //   layout: "production-planning-dashboard",
  //   allowedpermissions: [PLAN_DASHBOARD_VIEW_PERMISSION],
  // },
  {
    path: "/digitalization/hourly-production-record",
    name: "digitalization-hourly-production-record",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <HourlyProductionRecord />
      </Suspense>
    ),
    layout: "/digitalization/hourly-production-record",
    allowedpermissions: [HOURLY_PRODUCTION_VIEW_PERMISSION],
    analytics: {
      event_type: "hourly-production-record",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/hourly-production-record/view",
    name: "digitalization-hourly-production-record-view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DailyLinePlanContextProvider>
          <HourlyProductionRecordView />
        </DailyLinePlanContextProvider>
      </Suspense>
    ),
    layout: "/digitalization/hourly-production-record-view",
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "hourly-production-record",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/sales-contract-360",
    name: "merchandising-sales-contract-360",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <SalesContract360 />
      </Suspense>
    ),
    layout: "/merchandising/sales-contract-360",
    allowedpermissions: [SALES_CONTRACT_360_VIEW_PERMISSION],
  },
  {
    path: "digitalization/user-line-assign",
    name: "digitalization-user-line-assign",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UserLineAssign />
      </Suspense>
    ),
    layout: "digitalization/user-line-assign",
    allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
    analytics: {
      event_type: "user-line-assign",
      action_type: "view",
    },
  },

  {
    path: "merchandising/sub-contract-factory",
    name: "merchandising/sub-contract-factory",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <SubContractFactory />
      </Suspense>
    ),
    layout: "merchandising/sub-contract-factory",
    allowedpermissions: [SUBCONTRACT_FACTORY_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/operator-wise-performance",
    name: "app-dashboard/operator-wise-performance",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <OperatorWisePerformance />
      </Suspense>
    ),
    layout: "app-dashboard/operator-wise-performance",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/production-summary",
    name: "app-dashboard/production-summary",
    component: <ProductionSummary />,
    layout: "app-dashboard/production-summary",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/production-details",
    name: "app-dashboard/production-details",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AppProductDetails />
      </Suspense>
    ),
    layout: "app-dashboard/production-details",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/responsible-for-defects",
    name: "app-dashboard/responsible-for-defects",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ResponsibleForDefects />
      </Suspense>
    ),
    layout: "app-dashboard/responsible-for-defects",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/operator-wise-defect",
    name: "app-dashboard/operator-wise-defect",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <OperatorWiseDefect />
      </Suspense>
    ),
    layout: "app-dashboard/operator-wise-defect",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/production-tracker",
    name: "app-dashboard/production-tracker",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ProductionTracker />
      </Suspense>
    ),
    layout: "app-dashboard/production-tracker",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/defect-tracker",
    name: "app-dashboard/defect-tracker",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <DefectTracker />
      </Suspense>
    ),
    layout: "app-dashboard/defect-tracker",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/category-wise-defect",
    name: "app-dashboard/category-wise-defect",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <CategoryWiseDefect />
      </Suspense>
    ),
    layout: "app-dashboard/defect-tracker",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/category-wise-hourly-defect",
    name: "app-dashboard/category-wise-hourly-defect",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <CategoryWiseHourlyDefect />
      </Suspense>
    ),
    layout: "app-dashboard/category-wise-hourly-defect",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/app-dashboard/recommendation-against-defects",
    name: "app-dashboard/recommendation-against-defects",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <RecommendationAgainstDefects />
      </Suspense>
    ),
    layout: "app-dashboard/recommendation-against-defects",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
  },
  {
    path: "/digitalization/app-dashboard/:line_id",
    name: "digitalization/app-dashboard/:line_id",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AppDashboard />
      </Suspense>
    ),
    layout: "app-dashboard/:line_id",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
    analytics: {
      event_type: "app-dashboard",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/purchase-order-breakdown",
    name: "Purchase Order Breakdown",
    component: <UnitsPrice />,
    breadcrumbname: "Purchase Order Breakdown",
    layout: "/merchandising/purchase-order-breakdown",
    allowedpermissions: [
      PURCHASE_ORDER_VIEW_PERMISSION,
      PURCHASE_ORDER_CREATE_PERMISSION,
      PURCHASE_ORDER_EDIT_PERMISSION,
      PURCHASE_ORDER_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "purchase-order-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/add-purchase-order-breakdown",
    name: "Add Units Price",
    component: <AddUnitsPrice />,
    breadcrumbname: "UnitsPrice",
    layout: "/merchandising/add-purchase-order-breakdown",
    allowedpermissions: [PURCHASE_ORDER_CREATE_PERMISSION],
    analytics: {
      event_type: "purchase-order-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/update-purchase-order-breakdown/:itemId",
    name: "Update Units Price",
    component: <UpdateUnitsPrice />,
    breadcrumbname: "UnitsPrice",
    layout: "/merchandising/update-purchase-order-breakdown",
    allowedpermissions: [PURCHASE_ORDER_EDIT_PERMISSION],
    analytics: {
      event_type: "purchase-order-breakdown",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/view-units-price/:styleId",
    name: "View Units Price",
    component: <ViewUnitsPrice />,
    breadcrumbname: "style",
    layout: "/merchandising/view-units-price/:styleId",
    allowedpermissions: [PURCHASE_ORDER_VIEW_PERMISSION],
  },
  {
    path: "/merchandising/po-wise-purchase-order-breakdown",
    name: "PO Breakdown",
    component: <POWiseBreakdown />,
    breadcrumbname: "PO Breakdown",
    layout: "/merchandising/po-wise-purchase-order-breakdown",
    allowedpermissions: [
      PURCHASE_ORDER_VIEW_PERMISSION,
      PURCHASE_ORDER_CREATE_PERMISSION,
      PURCHASE_ORDER_EDIT_PERMISSION,
      PURCHASE_ORDER_DELETE_PERMISSION,
    ],
  },
  {
    path: "/merchandising/add-po-wise-purchase-order-breakdown",
    name: "Add PO Breakdown",
    component: <AddPOWiseBreakdown />,
    breadcrumbname: "PO Breakdown",
    layout: "/merchandising/add-po-wise-purchase-order-breakdown",
    allowedpermissions: [PURCHASE_ORDER_CREATE_PERMISSION],
  },
  {
    path: "/merchandising/update-po-wise-purchase-order-breakdown/:itemId/:poMapId",
    name: "Update PO Breakdown",
    component: <UpdatePOWiseBreakdown />,
    breadcrumbname: "PO Breakdown",
    layout: "/merchandising/update-po-wise-purchase-order-breakdown/:itemId/:poMapId",
    allowedpermissions: [PURCHASE_ORDER_EDIT_PERMISSION],
  },
  {
    path: "/merchandising/view-po-wise-purchase-order-breakdown/:styleId",
    name: "View PO Breakdown",
    component: <ViewPOWiseBreakdown />,
    breadcrumbname: "PO Breakdown",
    layout: "/merchandising/view-po-wise-purchase-order-breakdown/:styleId",
    allowedpermissions: [PURCHASE_ORDER_VIEW_PERMISSION],
  },
  {
    path: "/digitalization/app-dashboard",
    name: "digitalization/app-dashboard/",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AppDashboardLine />
      </Suspense>
    ),
    layout: "app-dashboard",
    allowedpermissions: [APP_DASHBOARD_VIEW_PERMISSION],
    analytics: {
      event_type: "app-dashboard",
      action_type: "view",
    },
  },
  {
    path: "/ot-signal-section",
    name: "ot-signal-section",
    component: <OTSignalSection />,
    allowedpermissions: [
      OT_SIGNAL_SECTION_VIEW_PERMISSION,
      OT_SIGNAL_SECTION_CREATE_PERMISSION,
      OT_SIGNAL_SECTION_EDIT_PERMISSION,
      OT_SIGNAL_SECTION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/ot-signal",
    name: "ot-signal",
    component: <OTSignal />,
    allowedpermissions: [
      OT_SIGNAL_VIEW_PERMISSION,
      OT_SIGNAL_CREATE_PERMISSION,
      OT_SIGNAL_EDIT_PERMISSION,
      OT_SIGNAL_DELETE_PERMISSION,
    ],
  },
  {
    path: "/digitalization/pp-meeting-date",
    name: "pp-meeting-date",
    component: <PPMeetingDate />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "pp-meeting-date",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/buyer-inspection-date",
    name: "buyer-inspection-date",
    component: <BuyerInspectionDate />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "buyer-inspection-date",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/buyer-visit-date",
    name: "buyer-visit-date",
    component: <BuyerVisitDate />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "buyer-visit-date",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/audit-date",
    name: "audit-date",
    component: <AuditDate />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "audit-date",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/capacity-of-sample-team",
    name: "capacity-of-sample-team",
    component: <CapacityOfSampleTeam />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "capacity-of-sample-team",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/fabric-loading-capacity-of-store",
    name: "fabric-loading-capacity-of-store",
    component: <FabricLoadingCapacityOfStore />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "fabric-loading-capacity-of-store",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/sample-requisitions",
    name: "sample-requisitions",
    component: <SampleRequisitions />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "sample-requisition",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/overtime-reasons",
    name: "overtime-reasons",
    component: <OvertimeReasons />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "overtime-reasons",
      action_type: "view",
    },
  },
  {
    path: "/capacity-bookings",
    name: "capacity-bookings",
    component: <CapacityBookings />,
    allowedpermissions: [CAPACITY_BOOKING_MENU_VIEW_PERMISSION],
  },
  {
    path: "/configuration/banks",
    name: "banks",
    component: <Banks />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/digitalization/garments-tracking",
    name: "garments-tracking",
    component: <GarmentsTracking />,
    allowedpermissions: [GARMENTS_TRACKING_VIEW_PERMISSION],
    analytics: {
      event_type: "garments-tracking",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/update-garments-tracking/:id",
    name: "update-garments-tracking",
    component: <UpdateGarmentsTracking />,
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
  },
  {
    path: "/digitalization/user-list",
    name: "user-list",
    component: <User />,
    allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
    analytics: {
      event_type: "app-user",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/mechanics",
    name: "mechanics",
    component: <MechanicUser />,
    allowedpermissions: [DIGITALIZATION_SETTINGS_VIEW_PERMISSION],
    analytics: {
      event_type: "machine-maintenance-mechanics",
      action_type: "view",
    },
  },
  {
    path: "/configuration/accounts",
    name: "accounts",
    component: <Accounts />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/configuration/branches",
    name: "branches",
    component: <Branches />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/configuration/garments-parts",
    name: "garments-parts",
    component: <GarmentsPartsConfig />,
    allowedpermissions: [
      GARMENTS_PARTS_CREATE_PERMISSION,
      GARMENTS_PARTS_EDIT_PERMISSION,
      GARMENTS_PARTS_VIEW_PERMISSION,
      GARMENTS_PARTS_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/packing-line",
    name: "packing-line",
    component: <PackingLineConfig />,
    allowedpermissions: [
      PACKING_LINE_CREATE_PERMISSION,
      PACKING_LINE_EDIT_PERMISSION,
      PACKING_LINE_VIEW_PERMISSION,
      PACKING_LINE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/packing-table",
    name: "packing-table",
    component: <PackingTableConfig />,
    allowedpermissions: [
      PACKING_TABLE_CREATE_PERMISSION,
      PACKING_TABLE_EDIT_PERMISSION,
      PACKING_TABLE_VIEW_PERMISSION,
      PACKING_TABLE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/packing-operator-mapping",
    name: "packing-operator-mapping",
    component: <PackingOperatorMappingConfig />,
    allowedpermissions: [
      PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
      PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
      PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
      PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/packing-operator-mapping/create",
    name: "packing-operator-mapping",
    component: <AddOrUpdatePackingOperatorMapping />,
    allowedpermissions: [
      PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
      PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
      PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
      PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/packing-operator-mapping/edit/:id",
    name: "packing-operator-mapping",
    component: <AddOrUpdatePackingOperatorMapping />,
    allowedpermissions: [
      PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
      PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
      PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
      PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/packing-operator-mapping/view/:id",
    name: "packing-operator-mapping",
    component: <PackingOperatorMappingConfig />,
    allowedpermissions: [
      PACKING_OPERATOR_MAPPING_CREATE_PERMISSION,
      PACKING_OPERATOR_MAPPING_EDIT_PERMISSION,
      PACKING_OPERATOR_MAPPING_VIEW_PERMISSION,
      PACKING_OPERATOR_MAPPING_DELETE_PERMISSION,
    ],
  },
  {
    path: "/configuration/stock-lot",
    name: "stock-lot",
    component: <StockLotConfigs />,
    allowedpermissions: [
      STOCK_LOT_VIEW_PERMISSION,
      STOCK_LOT_CREATE_PERMISSION,
      STOCK_LOT_EDIT_PERMISSION,
      STOCK_LOT_DELETE_PERMISSION,
    ],
  },
  {
    path: "/production/post-cutting-process",
    name: "post-cutting-process",
    component: <PostCuttingProcess />,
    allowedpermissions: [EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION],
    analytics: {
      event_type: "embroidery-printing",
      action_type: "view",
    },
  },
  {
    path: "/production/post-cutting-process/entry",
    name: "post-cutting-process-entry",
    component: (
      <PostCuttingProcessContextProvider>
        <PostCuttingProcessEntry />
      </PostCuttingProcessContextProvider>
    ),
    allowedpermissions: [EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION],
    analytics: {
      event_type: "embroidery-printing",
      action_type: "view",
    },
  },
  {
    path: "/production/post-cutting-process/update",
    name: "post-cutting-process-update",
    component: (
      <PostCuttingProcessContextProvider>
        <UpdatePostCutting />
      </PostCuttingProcessContextProvider>
    ),
    allowedpermissions: [EMBROIDERY_PRINTING_SMOCKING_PINTUCK_VIEW_PERMISSION],
    analytics: {
      event_type: "embroidery-printing",
      action_type: "view",
    },
  },
  {
    path: "/production/store-requisition",
    name: "store-requisition",
    component: <StoreRequisition />,
    allowedpermissions: [
      STORE_REQUISITION_VIEW_PERMISSION,
      STORE_REQUISITION_CREATE_PERMISSION,
      STORE_REQUISITION_EDIT_PERMISSION,
      STORE_REQUISITION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "store-requisition",
      action_type: "view",
    },
  },
  {
    path: "/production/store-requisition/entry",
    name: "store-requisition-entry",
    component: (
      <StoreRequisitionContextProvider>
        <StoreRequisitionEntry />
      </StoreRequisitionContextProvider>
    ),
    allowedpermissions: [STORE_REQUISITION_CREATE_PERMISSION],
    analytics: {
      event_type: "store-requisition",
      action_type: "create",
    },
  },
  {
    path: "/production/store-requisition/edit/:id",
    name: "store-requisition-edit",
    component: (
      <StoreRequisitionContextProvider>
        <StoreRequisitionUpdate />
      </StoreRequisitionContextProvider>
    ),
    allowedpermissions: [STORE_REQUISITION_EDIT_PERMISSION],
    analytics: {
      event_type: "store-requisition",
      action_type: "edit",
    },
  },
  {
    path: "/production/store-requisition/view/:id",
    name: "store-requisition-view",
    component: (
      <StoreRequisitionContextProvider>
        <StoreRequisitionView />
      </StoreRequisitionContextProvider>
    ),
    allowedpermissions: [STORE_REQUISITION_VIEW_PERMISSION],
    analytics: {
      event_type: "store-requisition",
      action_type: "view",
    },
  },
  {
    path: "/report/report-osr",
    name: "report-osr",
    component: <OSRReport />,
    allowedpermissions: [OSR_REPORT_GENERATE_PERMISSION],
  },
  {
    path: "/production-planning/dashboard",
    name: "production-planning-dashboard",
    component: <ProductionPlanningDashboard2 />,
    layout: "production-planning-dashboard",
    allowedpermissions: [PLAN_DASHBOARD_VIEW_PERMISSION],
    analytics: {
      event_type: "production-planning-dashboard",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/overtime-signals",
    name: "overtime-signals",
    component: <OvertimeSignals />,
    layout: "overtime-signals",
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "overtime-signals",
      action_type: "view",
    },
  },
  {
    path: "/tna/invoice-list",
    name: "TNA Invoice List",
    component: <TAndAInvoices />,
    breadcrumbname: "TNA Invoice List",
    layout: "",
    allowedpermissions: [TNA_TO_DO_LIST_VIEW_PERMISSION],
  },
  {
    path: "/digitalization/sam-justification",
    name: "Sam Justification",
    component: <SamJustification />,
    breadcrumbname: "Sam Justification",
    layout: "",
    allowedpermissions: [DIGITALIZATION_MENU_VIEW_PERMISSION],
    analytics: {
      event_type: "sam-justification",
      action_type: "view",
    },
  },
  {
    path: "/production/post-sewing-process",
    name: "post-sewing-process",
    component: <PostSewingProcess />,
    allowedpermissions: [WASHING_SNAP_BUTTON_VIEW_PERMISSION],
    analytics: {
      event_type: "washing-and-snap-button",
      action_type: "view",
    },
  },
  {
    path: "/production/post-sewing-process/entry",
    name: "post-sewing-process-entry",
    component: (
      <PostSewingProcessContextProvider>
        <PostSewingProcessEntry />
      </PostSewingProcessContextProvider>
    ),
    allowedpermissions: [WASHING_SNAP_BUTTON_VIEW_PERMISSION],
    analytics: {
      event_type: "washing-and-snap-button",
      action_type: "view",
    },
  },
  {
    path: "/production/post-sewing-process/update",
    name: "post-sewing-process-update",
    component: (
      <PostSewingProcessContextProvider>
        <UpdatePostSewing />
      </PostSewingProcessContextProvider>
    ),
    allowedpermissions: [WASHING_SNAP_BUTTON_VIEW_PERMISSION],
    analytics: {
      event_type: "washing-and-snap-button",
      action_type: "view",
    },
  },
  {
    path: "/capacity-bookings/report",
    name: "capacity-bookings-report",
    component: <CapacityBookingsReport />,
    allowedpermissions: [CAPACITY_BOOKING_MENU_VIEW_PERMISSION],
  },
  {
    path: "/report/report-sewing-and-folding",
    name: "report-sewing-and-folding",
    component: <SwingvsFolding />,
    allowedpermissions: [SEWING_FOLDING_REPORT_GENERATE_PERMISSION],
  },
  {
    path: "/report/report-operator-absinthium",
    name: "report-operator-absinthium",
    component: <AbsenteeismReport />,
    allowedpermissions: [ABSINTHIUM_REPORT_GENERATE_PERMISSION],
  },
  {
    path: "/report/absenteeism-informed-reason",
    name: "absenteeism-informed-reason",
    component: <AbsenteeismInformedReasonReport />,
    allowedpermissions: [
      ABSENTEEISM_INFORMED_REASON_REPORT_GENERATE_PERMISSION,
      ABSINTHIUM_REPORT_GENERATE_PERMISSION,
    ],
  },
  {
    path: "/report/sales-contract-pos",
    name: "report-sales-contract-pos",
    component: <SalesContractPOS />,
    allowedpermissions: [VIEW_ALL_ACTIVE_POS_PERMISSION],
  },
  {
    path: "/erp-usage/modules",
    name: "erp-usage/modules",
    component: <ERPUsageModule />,
    allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
    analytics: {
      event_type: "erp-usage-modules",
      action_type: "view",
    },
  },
  {
    path: "/erp-usage/module-uis",
    name: "erp-usage/module-uis",
    component: <ERPUsageModuleUi />,
    allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
    analytics: {
      event_type: "erp-usage-module-uis",
      action_type: "view",
    },
  },
  {
    path: "/erp-usage/issues",
    name: "erp-usage/issues",
    component: <ERPUsageIssue />,
    allowedpermissions: [ERP_USAGE_ISSUE_VIEW_PERMISSION],
    analytics: {
      event_type: "erp-usage-issues",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/buyer-inquiry/special-process/:buyerInquiryId",
    name: "special-process",
    component: <SpecialProcess />,
    allowedpermissions: [BUYER_INQUIRY_EDIT_PERMISSION],
  },
  {
    path: "/erp-usage/dashboard",
    name: "erp-usage/dashboard",
    component: <ERPUsageDashboard />,
    allowedpermissions: [ERP_USAGE_MODULE_VIEW_PERMISSION],
    analytics: {
      event_type: "erp-dashboard",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/hour",
    name: "digitalization/hour",
    component: <HourPage />,
    allowedpermissions: [HOUR_CONFIGURATION_CREATE_PERMISSION],
    analytics: {
      event_type: "garments-tracking-hour-configurations",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/daily-sewing-performance",
    name: "daily-sewing-performance",
    component: <DailySewingPerformance />,
    allowedpermissions: [DAILY_SEWING_PERFORMANCE_VIEW_PERMISSION],
    analytics: {
      event_type: "daily-sewing-performance-report",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/he-ot-expense-data",
    name: "he-ot-expense-data",
    component: <HROTExpenseData />,
    allowedpermissions: [HR_OT_EXPENSE_DATA_IMPORT_PERMISSION],
    analytics: {
      event_type: "hr-ot-expense-data",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/line-wise-sewing-report",
    name: "line-wise-sewing-report",
    component: <SewingProfitLoss />,
    allowedpermissions: [LINE_WISE_SEWING_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "line-wise-sewing-profit-loss",
      action_type: "view",
    },
  },
  {
    path: "/settings/permissions",
    name: "permissions",
    component: <Permission />,
    allowedpermissions: [
      PERMISSION_VIEW_PERMISSION,
      PERMISSION_CREATE_PERMISSION,
      PERMISSION_EDIT_PERMISSION,
      PERMISSION_DELETE_PERMISSION,
    ],
  },
  {
    path: "/pnl-report/ipr-mmd",
    name: "ipr-mmd",
    component: <IPRMMD />,
    allowedpermissions: [IPR_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "individual-performance-report",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/efficiency",
    name: "efficiency",
    component: <Efficiency />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "line-wise-daily-efficiency",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/target-vs-achievement",
    name: "target-vs-achievement",
    component: <TargetVsAchievement />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "line-wise-achievement-and-target-details",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/cpm",
    name: "cpm",
    component: <CPM />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "line-wise-daily-cpm",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/daily-profit-loss-summary",
    name: "daily-profit-loss-summary",
    component: <DailyProfitLossSummary />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "daily-profit-loss-summary",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/profit-loss-account",
    name: "daily-profit-loss-account",
    component: <ProfitLossAccount />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "daily-profit-loss-account",
      action_type: "view",
    },
  },
  {
    path: "/performance/performance-folding",
    name: "daily-profit-loss-account",
    component: <PerformanceFolding />,
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "profit-loss-statement",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/operator-efficiency",
    name: "digitalization-operator-efficiency",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <OperatorEfficiency />
      </Suspense>
    ),
    layout: "/digitalization/operator-efficiency",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "operator-efficiency",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/hourly-production-record-hour",
    name: "digitalization/hourly-production-record-hour",
    component: <HourlyProductionRecordHourPage />,
    allowedpermissions: [HOUR_CONFIGURATION_CREATE_PERMISSION],
    analytics: {
      event_type: "hpr-hour",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/line-wise-operator-hourly-report",
    name: "digitalization/line-wise-operator-hourly-report",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <OperatorHourlyProduction />
      </Suspense>
    ),
    layout: "/digitalization/operator-efficiency",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "line-wise-hourly-report",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/line-wise-operation-hourly-report",
    name: "digitalization/line-wise-operation-hourly-report",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <OperationHourlyProduction />
      </Suspense>
    ),
    layout: "/digitalization/operator-efficiency",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "line-wise-operation-hourly-report",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/initial-sam-entry",
    name: "merchandising/initial-sam-entry",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <InitialSAMEntry />
      </Suspense>
    ),
    layout: "/merchandising/inital-sam-entry",
    allowedpermissions: [INITIAL_SAM_MENU_PERMISSION, INITIAL_SAM_STORE_PERMISSION],
    analytics: {
      event_type: "initial-sam",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/export-invoice-expense",
    name: "export-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ExportInvoiceExpense />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-invoice-expense",
    allowedpermissions: [EXPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/export-invoice-expense/create",
    name: "export-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ExportInvoiceExpenseCreate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-invoice-expense/create",
    allowedpermissions: [EXPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-invoice-expense/create",
    name: "export-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportInvoiceExpenseCreate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-invoice-expense/create",
    allowedpermissions: [IMPORT_INVOICE_EXPENSE_TRACKER_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/export-invoice-expense/update/:exportInvoiceExpenseId",
    name: "export-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ExportInvoiceExpenseUpdate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-invoice-expense/update",
    allowedpermissions: [EXPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/export-invoice-expense/view/:exportInvoiceExpenseId",
    name: "export-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ExportInvoiceExpenseView />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-invoice-expense/view",
    allowedpermissions: [EXPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/sales-contract-expense",
    name: "sales-contract-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <SalesContractExpense />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/sales-contract-expense",
    allowedpermissions: [EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/sales-contract-expense/create",
    name: "sales-contract-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <SalesContractExpenseCreate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/sales-contract-expense/create",
    allowedpermissions: [EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/sales-contract-expense/update/:salesContractExpenseId",
    name: "sales-contract-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <SalesContractExpenseUpdate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/sales-contract-expense/update",
    allowedpermissions: [EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_EDIT_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/sales-contract-expense/view/:salesContractExpenseId",
    name: "sales-contract-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <SalesContractExpenseView />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/sales-contract-expense/view",
    allowedpermissions: [EXPORT_SALES_CONTRACT_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-invoice-expense",
    name: "import-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportInvoiceExpense />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-invoice-expense",
    allowedpermissions: [IMPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-invoice-expense/view/:id",
    name: "import-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportInvoiceExpenseView />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-invoice-expense/view",
    allowedpermissions: [IMPORT_INVOICE_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-invoice-expense/update/:id",
    name: "import-invoice-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportInvoiceExpenseUpdate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-invoice-expense/update",
    allowedpermissions: [IMPORT_INVOICE_EXPENSE_TRACKER_EDIT_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-lc-expense",
    name: "import-lc-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportLcExpense />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-lc-expense",
    allowedpermissions: [IMPORT_LC_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-lc-expense/create",
    name: "import-lc-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportLcExpenseCreate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-lc-expense/create",
    allowedpermissions: [IMPORT_LC_EXPENSE_TRACKER_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-lc-expense/view/:id",
    name: "import-lc-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportLcExpenseView />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-lc-expense/view/:id",
    allowedpermissions: [IMPORT_LC_EXPENSE_TRACKER_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/import-lc-expense/update/:id",
    name: "import-lc-expense",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportLcExpenseUpdate />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-lc-expense/update",
    allowedpermissions: [IMPORT_LC_EXPENSE_TRACKER_EDIT_PERMISSION],
  },
  {
    path: "/export/commercial-packing-requirement",
    name: "commercial-packing-requirement",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <CommercialPackingRequirement />
      </Suspense>
    ),
    layout: "/export/commercial-packing-requirement",
    allowedpermissions: [COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION],
    analytics: {
      event_type: "commercial-packing-requirement",
      action_type: "view",
    },
  },
  {
    path: "/export/commercial-packing-requirement/update/:id",
    name: "commercial-packing-requirement/update/",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <CommercialPackingRequirementUpdate />
      </Suspense>
    ),
    layout: "/export/commercial-packing-requirement/update/",
    allowedpermissions: [COMMERCIAL_PACKING_REQUIREMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "commercial-packing-requirement",
      action_type: "view",
    },
  },
  {
    path: "/export/commercial-packing-requirement/view/:id",
    name: "commercial-packing-requirement/view/",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <CommercialPackingRequirementView />
      </Suspense>
    ),
    layout: "/export/commercial-packing-requirement/view/",
    allowedpermissions: [COMMERCIAL_PACKING_REQUIREMENT_VIEW_PERMISSION],
    analytics: {
      event_type: "commercial-packing-requirement",
      action_type: "view",
    },
  },
  // /import-export-expense-tracking/import-details
  // /import-export-expense-tracking/export-and-summary
  {
    path: "/import-export-expense-tracking/import-details",
    name: "import-details",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportDetailsReport />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-details",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/import-export-expense-tracking/export-and-summary",
    name: "export-and-summary",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ExportAndSummary />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-and-summary",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/offline-sync-logs/failed-items",
    name: "offline-sync-logs/failed-items",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <FailedItems />
      </Suspense>
    ),
    layout: "/offline-sync-logs/failed-items",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "failed-items",
      action_type: "view",
    },
  },
  {
    path: "/offline-sync-logs/failed-items/view/:sync_date/:module_name",
    name: "offline-sync-logs/failed-items",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <FailedItemsView />
      </Suspense>
    ),
    layout: "/offline-sync-logs/failed-items",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "failed-items",
      action_type: "view",
    },
  },
  {
    path: "/settings/remedy-map",
    name: "settings/remedy-map",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <RemedyMap />
      </Suspense>
    ),
    layout: "/settings/remedy-map",
    allowedpermissions: [PROBLEM_REMEDY_MAP_VIEW_PERMISSION],
  },
  {
    path: "/problem-remedy/remedy-log",
    name: "problem-remedy/remedy-log",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <RemedyLogs />
      </Suspense>
    ),
    layout: "/problem-remedy/remedy-log",
    allowedpermissions: [PROBLEM_REMEDY_LOG_VIEW_PERMISSION],
    analytics: {
      event_type: "remedy-logs",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/line-wise-defects-dhu",
    name: "digitalization/line-wise-defects-dhu",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <LineWiseDefectsDHU />
      </Suspense>
    ),
    layout: "/problem-remedy/remedy-log",
    allowedpermissions: [LINE_WISE_CATEGORY_DEFECT_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "line-wise-defects-dhu",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/audit-report",
    name: "digitalization-audit-report",
    component: <AuditReport />,
    layout: "/digitalization/audit-report",
    allowedpermissions: [CGL_AUDIT_REPORT_LIST_VIEW_PERMISSION],
    analytics: {
      event_type: "audit-report",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/audit-report/view",
    name: "digitalization-audit-report-view",
    component: <AuditReportView />,
    layout: "/digitalization/audit-report/view",
    allowedpermissions: [CGL_AUDIT_REPORT_LIST_VIEW_PERMISSION],
    analytics: {
      event_type: "audit-report",
      action_type: "view-details",
    },
  },
  {
    path: "/digitalization/qc-validation-report",
    name: "digitalization-qc-validation-report",
    component: <QcValidationReport />,
    layout: "/digitalization/qc-validation-report",
    allowedpermissions: [QC_VALIDATION_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "qc-validation-report",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/sewing-line-defect",
    name: "digitalization-sewing-line-defect",
    component: <SewingLineDefect />,
    layout: "/digitalization/sewing-line-defect",
    allowedpermissions: [SEWING_LINE_DEFECT_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "sewing-line-defect",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/sewing-line-defect-monthly",
    name: "digitalization-sewing-line-defect-monthly",
    component: <SewingLineDefectMonthly />,
    layout: "/digitalization/sewing-line-defect-monthly",
    allowedpermissions: [SEWING_LINE_DEFECT_MONTHLY_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "sewing-line-defect-monthly",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/qc-validation-report/view/:id",
    name: "digitalization-qc-validation-report-view",
    component: <QcValidationReportView />,
    layout: "/digitalization/qc-validation-report/view",
    allowedpermissions: [QC_VALIDATION_REPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "qc-validation-report",
      action_type: "view-details",
    },
  },
  {
    path: "/digitalization/finishing-lines",
    name: "finishing-lines",
    component: <FinishingLine />,
    layout: "/digitalization/finishing-lines",
    allowedpermissions: [
      FINISHING_LINE_VIEW_PERMISSION,
      FINISHING_LINE_CREATE_PERMISSION,
      FINISHING_LINE_EDIT_PERMISSION,
      FINISHING_LINE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "finishing-line",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing-lines-mapping",
    name: "finishing-lines/mapping",
    component: <FinishingLineMapping />,
    layout: "/digitalization/finishing-lines-mapping",
    allowedpermissions: [FINISHING_LINE_MAPPING_VIEW_PERMISSION, FINISHING_LINE_MAPPING_CREATE_PERMISSION],
    analytics: {
      event_type: "finishing-line-mapping-configurations",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/garments-tracking-hourly-target",
    name: "/digitalization/garments-tracking-hourly-target",
    component: <GarmentsTrackingHourlyTarget />,
    layout: "/digitalization/garments-tracking-hourly-target",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "finishing-line-mapping-configurations",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/garments-tracking-hourly-target/create",
    name: "/digitalization/garments-tracking-hourly-target/create",
    component: <CreateOrEditHourlyTarget />,
    layout: "/digitalization/garments-tracking-hourly-target",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "garments-tracking-hourly-target",
      action_type: "create",
    },
  },
  {
    path: "/digitalization/garments-tracking-hourly-target/edit/:id",
    name: "/digitalization/garments-tracking-hourly-target/edit/:id",
    component: <CreateOrEditHourlyTarget />,
    layout: "/digitalization/garments-tracking-hourly-target",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "garments-tracking-hourly-target",
      action_type: "edit",
    },
  },

  {
    path: "/digitalization/finishing/sewing-to-folding",
    name: "digitalization/finishing/sewing-to-folding",
    component: <SewingToFolding />,
    layout: "/digitalization/finishing/sewing-to-folding",
    allowedpermissions: [
      GARMENT_RECEIVED_CREATE_PERMISSION,
      GARMENT_RECEIVED_VIEW_PERMISSION,
      GARMENT_RECEIVED_UPDATE_PERMISSION,
    ],
    analytics: {
      event_type: "finishing-sewing-to-folding",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/sewing-to-folding/edit/:id",
    name: "digitalization/finishing/sewing-to-folding/edit",
    component: <UpdateSewingToFolding />,
    layout: "/digitalization/finishing/sewing-to-folding",
    allowedpermissions: [
      GARMENT_RECEIVED_CREATE_PERMISSION,
      GARMENT_RECEIVED_VIEW_PERMISSION,
      GARMENT_RECEIVED_UPDATE_PERMISSION,
    ],
    analytics: {
      event_type: "finishing-sewing-to-folding",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/hourly-iron",
    name: "digitalization/finishing/hourly-iron",
    component: <HourlyIronOriginal type={"iron"} />,
    layout: "/digitalization/finishing/hourly-iron",
    allowedpermissions: [HOURLY_IRON_VIEW_PERMISSION, HOURLY_IRON_CREATE_PERMISSION, HOURLY_IRON_EDIT_PERMISSION],
    analytics: {
      event_type: "finishing-hourly-iron",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/hourly-iron/edit/:id",
    name: "digitalization/finishing/hourly-iron/edit",
    component: <UpdateFinishingHourlyIronOriginal type={"iron"} />,
    layout: "/digitalization/finishing/hourly-iron",
    allowedpermissions: [HOURLY_IRON_EDIT_PERMISSION],
    analytics: {
      event_type: "finishing-hourly-iron",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/hourly-fold",
    name: "digitalization/finishing/hourly-fold",
    component: <HourlyIron key="hourly-fold" type={"fold"} />,
    layout: "/digitalization/finishing/hourly-fold",
    allowedpermissions: [HOURLY_FOLD_VIEW_PERMISSION, HOURLY_FOLD_CREATE_PERMISSION, HOURLY_FOLD_EDIT_PERMISSION],
    analytics: {
      event_type: "finishing-hourly-fold",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/hourly-fold/edit/:id",
    name: "digitalization/finishing/hourly-fold/edit",
    component: <UpdateFinishingHourlyIron type={"fold"} />,
    layout: "/digitalization/finishing/hourly-fold",
    allowedpermissions: [HOURLY_FOLD_VIEW_PERMISSION, HOURLY_FOLD_CREATE_PERMISSION, HOURLY_FOLD_EDIT_PERMISSION],
    analytics: {
      event_type: "finishing-hourly-fold",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/hourly-poly",
    name: "digitalization/finishing/hourly-poly",
    component: <HourlyIron key="hourly-poly" type={"poly"} />,
    layout: "/digitalization/finishing/hourly-poly",
    allowedpermissions: [HOURLY_POLY_VIEW_PERMISSION, HOURLY_POLY_CREATE_PERMISSION, HOURLY_POLY_EDIT_PERMISSION],
    analytics: {
      event_type: "finishing-hourly-poly",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/hourly-poly/edit/:id",
    name: "digitalization/finishing/hourly-poly/edit",
    component: <UpdateFinishingHourlyIron type={"poly"} />,
    layout: "/digitalization/finishing/hourly-poly",
    allowedpermissions: [HOURLY_POLY_VIEW_PERMISSION, HOURLY_POLY_CREATE_PERMISSION, HOURLY_POLY_EDIT_PERMISSION],
    analytics: {
      event_type: "finishing-hourly-poly",
      action_type: "view",
    },
  },

  {
    path: "/production-planning/list",
    name: "/production-planning/list",
    component: <ProductionPlanningList />,
    layout: "/production-planning/list",
    allowedpermissions: [PRODUCTION_PLANNING_LIST_VIEW_PERMISSION],
  },
  {
    path: "/production-planning/planning-report",
    name: "/production-planning/planning-report",
    component: <PlanningReport />,
    layout: "/production-planning/planning-report",
    allowedpermissions: [PRODUCTION_PLANNING_LIST_VIEW_PERMISSION, PLAN_DASHBOARD_VIEW_PERMISSION],
  },

  {
    path: "/production-planning/capacity-booking-report",
    name: "/production-planning/capacity-booking-report",
    component: <PPAnalysisReport />,
    layout: "/production-planning/capacity-booking-report",
    allowedpermissions: [CAPACITY_BOOKING_REPORT_VIEW_PERMISSION],
  },
  {
    path: "/production-planning/booking-qty",
    name: "booking-qty",
    component: <BookingQty />,
    layout: "/production-planning/booking-qty",
    allowedpermissions: [
      BOOKING_QTY_VIEW_PERMISSION,
      BOOKING_QTY_CREATE_PERMISSION,
      BOOKING_QTY_EDIT_PERMISSION,
      BOOKING_QTY_DELETE_PERMISSION,
    ],
  },

  // folding to packing
  {
    path: "/digitalization/packing/folding-to-packing",
    name: "digitalization/packing/folding-to-packing",
    component: <FoldingToPacking />,
    layout: "/digitalization/packing/folding-to-packing",
    allowedpermissions: [
      FINISHING_GARMENT_RECEIVED_CREATE_PERMISSION,
      FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION,
      FINISHING_GARMENT_RECEIVED_UPDATE_PERMISSION,
    ],
    analytics: {
      event_type: "packing-folding-to-packing",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/packing/folding-to-packing/edit/:id",
    name: "digitalization/packing/folding-to-packing/edit/:id",
    component: <UpdateFoldingToPacking />,
    layout: "/digitalization/packing/folding-to-packing/edit",
    allowedpermissions: [
      FINISHING_GARMENT_RECEIVED_CREATE_PERMISSION,
      FINISHING_GARMENT_RECEIVED_VIEW_PERMISSION,
      FINISHING_GARMENT_RECEIVED_UPDATE_PERMISSION,
    ],
    analytics: {
      event_type: "packing-folding-to-packing",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/packing/assignment",
    name: "digitalization/packing/assignment",
    component: <PackingAssignmentList />,
    layout: "/digitalization/packing/assignment",
    allowedpermissions: [
      DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "daily-packing-assignment",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/packing/assignment/create",
    name: "digitalization/packing/assignment/create",
    component: <AddOrUpdatePackingAssignment width={window.innerWidth} />,
    layout: "/digitalization/packing/assignment/create",
    allowedpermissions: [
      DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "daily-packing-assignment",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/packing/assignment/edit/:id",
    name: "digitalization/packing/assignment/edit/:id",
    component: <AddOrUpdatePackingAssignment width={window.innerWidth} />,
    layout: "/digitalization/packing/assignment/edit/:id",
    allowedpermissions: [
      DAILY_PACKING_ASSIGNMENT_VIEW_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_CREATE_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_EDIT_PERMISSION,
      DAILY_PACKING_ASSIGNMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "daily-packing-assignment",
      action_type: "view",
    },
  },

  // Machine Information
  {
    path: "/digitalization/configurations/machine-information",
    name: "digitalization/configurations/machine-information",
    component: <MachineInformation />,
    layout: "/digitalization/configurations/machine-information",
    allowedpermissions: [
      MACHINE_INFORMATION_VIEW_PERMISSION,
      MACHINE_INFORMATION_STORE_PERMISSION,
      MACHINE_INFORMATION_UPDATE_PERMISSION,
      MACHINE_INFORMATION_DELETE_PERMISSION,
      MACHINE_INFORMATION_IMPORT_PERMISSION,
    ],
    analytics: {
      event_type: "machine-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/configurations/machine-information/store",
    name: "digitalization/configurations/machine-information/store",
    component: <MachineInformationForm />,
    layout: "/digitalization/configurations/machine-information/store",
    allowedpermissions: [
      MACHINE_INFORMATION_VIEW_PERMISSION,
      MACHINE_INFORMATION_STORE_PERMISSION,
      MACHINE_INFORMATION_UPDATE_PERMISSION,
      MACHINE_INFORMATION_DELETE_PERMISSION,
      MACHINE_INFORMATION_IMPORT_PERMISSION,
    ],
    analytics: {
      event_type: "machine-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/configurations/machine-information/edit/:id",
    name: "digitalization/configurations/machine-information/edit/:id",
    component: <MachineInformationForm />,
    layout: "/digitalization/configurations/machine-information/edit/:id",
    allowedpermissions: [
      MACHINE_INFORMATION_VIEW_PERMISSION,
      MACHINE_INFORMATION_STORE_PERMISSION,
      MACHINE_INFORMATION_UPDATE_PERMISSION,
      MACHINE_INFORMATION_DELETE_PERMISSION,
      MACHINE_INFORMATION_IMPORT_PERMISSION,
    ],
    analytics: {
      event_type: "machine-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/configurations/machine-information/view/:id",
    name: "digitalization/configurations/machine-information/view/:id",
    component: <MachineInformationForm />,
    layout: "/digitalization/configurations/machine-information/view/:id",
    allowedpermissions: [
      MACHINE_INFORMATION_VIEW_PERMISSION,
      MACHINE_INFORMATION_STORE_PERMISSION,
      MACHINE_INFORMATION_UPDATE_PERMISSION,
      MACHINE_INFORMATION_DELETE_PERMISSION,
      MACHINE_INFORMATION_IMPORT_PERMISSION,
    ],
    analytics: {
      event_type: "machine-information",
      action_type: "view",
    },
  },

  // machine maintenance configuration
  {
    path: "/digitalization/machine-maintenance/configurations/brand",
    name: "/digitalization/machine-maintenance/configurations/brand",
    component: <MaintenaceConfig type="brand" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_BRAND_VIEW_PERMISSION,
      MACHINE_BRAND_STORE_PERMISSION,
      MACHINE_BRAND_UPDATE_PERMISSION,
      MACHINE_BRAND_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "brand-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/brand/store",
    name: "/digitalization/machine-maintenance/configurations/brand/store",
    component: <MachineConfigForm type="brand" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_BRAND_VIEW_PERMISSION,
      MACHINE_BRAND_STORE_PERMISSION,
      MACHINE_BRAND_UPDATE_PERMISSION,
      MACHINE_BRAND_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "brand-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/brand/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/brand/edit/:id",
    component: <MachineConfigForm type="brand" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_BRAND_VIEW_PERMISSION,
      MACHINE_BRAND_STORE_PERMISSION,
      MACHINE_BRAND_UPDATE_PERMISSION,
      MACHINE_BRAND_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "brand-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/brand/view/:id",
    name: "/digitalization/machine-maintenance/configurations/brand/view/:id",
    component: <MachineConfigForm type="brand" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_BRAND_VIEW_PERMISSION,
      MACHINE_BRAND_STORE_PERMISSION,
      MACHINE_BRAND_UPDATE_PERMISSION,
      MACHINE_BRAND_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "brand-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/company",
    name: "/digitalization/machine-maintenance/configurations/company",
    component: <MaintenaceConfig type="company" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_COMPANY_VIEW_PERMISSION,
      MACHINE_COMPANY_STORE_PERMISSION,
      MACHINE_COMPANY_UPDATE_PERMISSION,
      MACHINE_COMPANY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "company-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/company/store",
    name: "/digitalization/machine-maintenance/configurations/company/store",
    component: <MachineConfigForm type="company" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_COMPANY_VIEW_PERMISSION,
      MACHINE_COMPANY_STORE_PERMISSION,
      MACHINE_COMPANY_UPDATE_PERMISSION,
      MACHINE_COMPANY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "company-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/company/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/company/edit/:id",
    component: <MachineConfigForm type="company" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_COMPANY_VIEW_PERMISSION,
      MACHINE_COMPANY_STORE_PERMISSION,
      MACHINE_COMPANY_UPDATE_PERMISSION,
      MACHINE_COMPANY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "company-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/company/view/:id",
    name: "/digitalization/machine-maintenance/configurations/company/view/:id",
    component: <MachineConfigForm type="company" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_COMPANY_VIEW_PERMISSION,
      MACHINE_COMPANY_STORE_PERMISSION,
      MACHINE_COMPANY_UPDATE_PERMISSION,
      MACHINE_COMPANY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "company-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/model",
    name: "/digitalization/machine-maintenance/configurations/model",
    component: <MaintenaceConfig type="model" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MODEL_VIEW_PERMISSION,
      MACHINE_MODEL_STORE_PERMISSION,
      MACHINE_MODEL_UPDATE_PERMISSION,
      MACHINE_MODEL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "model-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/configurations/model/store",
    name: "/digitalization/machine-maintenance/configurations/model/store",
    component: <MachineConfigForm type="model" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MODEL_VIEW_PERMISSION,
      MACHINE_MODEL_STORE_PERMISSION,
      MACHINE_MODEL_UPDATE_PERMISSION,
      MACHINE_MODEL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "model-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/model/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/model/edit/:id",
    component: <MachineConfigForm type="model" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MODEL_VIEW_PERMISSION,
      MACHINE_MODEL_STORE_PERMISSION,
      MACHINE_MODEL_UPDATE_PERMISSION,
      MACHINE_MODEL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "model-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/model/view/:id",
    name: "/digitalization/machine-maintenance/configurations/model/view/:id",
    component: <MachineConfigForm type="model" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MODEL_VIEW_PERMISSION,
      MACHINE_MODEL_STORE_PERMISSION,
      MACHINE_MODEL_UPDATE_PERMISSION,
      MACHINE_MODEL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "model-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/location",
    name: "/digitalization/machine-maintenance/configurations/location",
    component: <MaintenaceConfig type="location" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_LOCATION_VIEW_PERMISSION,
      MACHINE_LOCATION_STORE_PERMISSION,
      MACHINE_LOCATION_UPDATE_PERMISSION,
      MACHINE_LOCATION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "location-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/location/store",
    name: "/digitalization/machine-maintenance/configurations/location/store",
    component: <MachineConfigForm type="location" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_LOCATION_VIEW_PERMISSION,
      MACHINE_LOCATION_STORE_PERMISSION,
      MACHINE_LOCATION_UPDATE_PERMISSION,
      MACHINE_LOCATION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "location-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/location/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/location/edit/:id",
    component: <MachineConfigForm type="location" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_LOCATION_VIEW_PERMISSION,
      MACHINE_LOCATION_STORE_PERMISSION,
      MACHINE_LOCATION_UPDATE_PERMISSION,
      MACHINE_LOCATION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "location-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/location/view/:id",
    name: "/digitalization/machine-maintenance/configurations/location/view/:id",
    component: <MachineConfigForm type="location" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_LOCATION_VIEW_PERMISSION,
      MACHINE_LOCATION_STORE_PERMISSION,
      MACHINE_LOCATION_UPDATE_PERMISSION,
      MACHINE_LOCATION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "location-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-line",
    name: "/digitalization/machine-maintenance/configurations/machine-line",
    component: <MaintenaceConfig type="machine-line" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MACHINE_LINE_VIEW_PERMISSION,
      MACHINE_MACHINE_LINE_STORE_PERMISSION,
      MACHINE_MACHINE_LINE_UPDATE_PERMISSION,
      MACHINE_MACHINE_LINE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-line-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-line/store",
    name: "/digitalization/machine-maintenance/configurations/machine-line/store",
    component: <MachineConfigForm type="machine-line" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MACHINE_LINE_VIEW_PERMISSION,
      MACHINE_MACHINE_LINE_STORE_PERMISSION,
      MACHINE_MACHINE_LINE_UPDATE_PERMISSION,
      MACHINE_MACHINE_LINE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-line-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-line/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-line/edit/:id",
    component: <MachineConfigForm type="machine-line" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MACHINE_LINE_VIEW_PERMISSION,
      MACHINE_MACHINE_LINE_STORE_PERMISSION,
      MACHINE_MACHINE_LINE_UPDATE_PERMISSION,
      MACHINE_MACHINE_LINE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-line-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-line/view/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-line/view/:id",
    component: <MachineConfigForm type="machine-line" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_MACHINE_LINE_VIEW_PERMISSION,
      MACHINE_MACHINE_LINE_STORE_PERMISSION,
      MACHINE_MACHINE_LINE_UPDATE_PERMISSION,
      MACHINE_MACHINE_LINE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-line-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-origin-country",
    name: "/digitalization/machine-maintenance/configurations/machine-origin-country",
    component: <MaintenaceConfig type="machine-origin-country" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_STORE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_UPDATE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-origin-country-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-origin-country/store",
    name: "/digitalization/machine-maintenance/configurations/machine-origin-country/store",
    component: <MachineConfigForm type="machine-origin-country" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_STORE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_UPDATE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-origin-country-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-origin-country/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-origin-country/edit/:id",
    component: <MachineConfigForm type="machine-origin-country" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_STORE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_UPDATE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-origin-country-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-origin-country/view/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-origin-country/view/:id",
    component: <MachineConfigForm type="machine-origin-country" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ORIGIN_COUNTRY_VIEW_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_STORE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_UPDATE_PERMISSION,
      MACHINE_ORIGIN_COUNTRY_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-origin-country-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-action-type",
    name: "/digitalization/machine-maintenance/configurations/machine-action-type",
    component: <MaintenaceConfig type="machine-action-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ACTION_TYPE_VIEW_PERMISSION,
      MACHINE_ACTION_TYPE_STORE_PERMISSION,
      MACHINE_ACTION_TYPE_UPDATE_PERMISSION,
      MACHINE_ACTION_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-action-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-action-type/store",
    name: "/digitalization/machine-maintenance/configurations/machine-action-type/store",
    component: <MachineConfigForm type="machine-action-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ACTION_TYPE_VIEW_PERMISSION,
      MACHINE_ACTION_TYPE_STORE_PERMISSION,
      MACHINE_ACTION_TYPE_UPDATE_PERMISSION,
      MACHINE_ACTION_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-action-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-action-type/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-action-type/edit/:id",
    component: <MachineConfigForm type="machine-action-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ACTION_TYPE_VIEW_PERMISSION,
      MACHINE_ACTION_TYPE_STORE_PERMISSION,
      MACHINE_ACTION_TYPE_UPDATE_PERMISSION,
      MACHINE_ACTION_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-action-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-action-type/view/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-action-type/view/:id",
    component: <MachineConfigForm type="machine-action-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_ACTION_TYPE_VIEW_PERMISSION,
      MACHINE_ACTION_TYPE_STORE_PERMISSION,
      MACHINE_ACTION_TYPE_UPDATE_PERMISSION,
      MACHINE_ACTION_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-action-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-fault-type",
    name: "/digitalization/machine-maintenance/configurations/machine-fault-type",
    component: <MaintenaceConfig type="machine-fault-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_FAULT_TYPE_VIEW_PERMISSION,
      MACHINE_FAULT_TYPE_STORE_PERMISSION,
      MACHINE_FAULT_TYPE_UPDATE_PERMISSION,
      MACHINE_FAULT_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-fault-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-fault-type/store",
    name: "/digitalization/machine-maintenance/configurations/machine-fault-type/store",
    component: <MachineConfigForm type="machine-fault-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_FAULT_TYPE_VIEW_PERMISSION,
      MACHINE_FAULT_TYPE_STORE_PERMISSION,
      MACHINE_FAULT_TYPE_UPDATE_PERMISSION,
      MACHINE_FAULT_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-fault-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-fault-type/edit/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-fault-type/edit/:id",
    component: <MachineConfigForm type="machine-fault-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_FAULT_TYPE_VIEW_PERMISSION,
      MACHINE_FAULT_TYPE_STORE_PERMISSION,
      MACHINE_FAULT_TYPE_UPDATE_PERMISSION,
      MACHINE_FAULT_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-fault-type-information",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/machine-maintenance/configurations/machine-fault-type/view/:id",
    name: "/digitalization/machine-maintenance/configurations/machine-fault-type/view/:id",
    component: <MachineConfigForm type="machine-fault-type" />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [
      MACHINE_FAULT_TYPE_VIEW_PERMISSION,
      MACHINE_FAULT_TYPE_STORE_PERMISSION,
      MACHINE_FAULT_TYPE_UPDATE_PERMISSION,
      MACHINE_FAULT_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "machine-fault-type-information",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/machine-maintenance/machine-issues",
    name: "/digitalization/machine-maintenance/machine-issues",
    component: <MachineIssues />,
    layout: "/digitalization/machine-maintenance/configurations",
    allowedpermissions: [MACHINE_LINE_ISSUES_VIEW_PERMISSION],
    analytics: {
      event_type: "machine-issues",
      action_type: "view",
    },
  },
  {
    path: "/pnl-report/dashboard",
    name: "/pnl-report/dashboard",
    component: <DashboardPNL />,
    layout: "/pnl-report/dashboard",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
    analytics: {
      event_type: "pnl-dashboard",
      action_type: "view",
    },
  },
  {
    path: "/digitalization/finishing/mismatch-report",
    name: "digitalization/finishing/mismatch-report",
    component: <MismatchReport />,
    layout: "/digitalization/finishing/mismatch-report",
    allowedpermissions: [GARMENT_RECEIVED_VIEW_PERMISSION],
    analytics: {
      event_type: "mismatch-report",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/configure/cost-head",
    name: "/import-export-expense-tracking/configure/cost-head",
    component: <CostHead />,
    layout: "/import-export-expense-tracking/configure/cost-head",
    allowedpermissions: [
      EXIM_CONFIGURE_VIEW_PERMISSION,
      EXIM_CONFIGURE_CREATE_PERMISSION,
      EXIM_CONFIGURE_EDIT_PERMISSION,
      EXIM_CONFIGURE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/cost-type",
    name: "/import-export-expense-tracking/configure/cost-type",
    component: <CostType />,
    layout: "/import-export-expense-tracking/configure/cost-type",
    allowedpermissions: [
      EXIM_CONFIGURE_VIEW_PERMISSION,
      EXIM_CONFIGURE_CREATE_PERMISSION,
      EXIM_CONFIGURE_EDIT_PERMISSION,
      EXIM_CONFIGURE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/exim-accounts",
    name: "/import-export-expense-tracking/configure/exim-accounts",
    component: <EximAccounts />,
    layout: "/import-export-expense-tracking/configure/exim-accounts",
    allowedpermissions: [
      EXIM_CONFIGURE_VIEW_PERMISSION,
      EXIM_CONFIGURE_CREATE_PERMISSION,
      EXIM_CONFIGURE_EDIT_PERMISSION,
      EXIM_CONFIGURE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/epb-type",
    name: "/import-export-expense-tracking/configure/epb-type",
    component: <EPBType />,
    layout: "/import-export-expense-tracking/configure/epb-type",
    allowedpermissions: [
      EPB_TYPE_VIEW_PERMISSION,
      EPB_TYPE_CREATE_PERMISSION,
      EPB_TYPE_EDIT_PERMISSION,
      EPB_TYPE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/epb-attribute",
    name: "/import-export-expense-tracking/configure/epb-attribute",
    component: <EPBAttribute />,
    layout: "/import-export-expense-tracking/configure/epb-attribute",
    allowedpermissions: [
      EPB_ATTRIBUTE_VIEW_PERMISSION,
      EPB_ATTRIBUTE_CREATE_PERMISSION,
      EPB_ATTRIBUTE_EDIT_PERMISSION,
      EPB_ATTRIBUTE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/charges",
    name: "/import-export-expense-tracking/configure/charges",
    component: <Charges />,
    layout: "/import-export-expense-tracking/configure/charges",
    allowedpermissions: [
      EXIM_CONFIGURE_VIEW_PERMISSION,
      EXIM_CONFIGURE_CREATE_PERMISSION,
      EXIM_CONFIGURE_EDIT_PERMISSION,
      EXIM_CONFIGURE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/cnf-settings/import-cnf",
    name: "/import-export-expense-tracking/configure/cnf-settings/import-cnf",
    component: <ImportCnfExpenditure />,
    layout: "/import-export-expense-tracking/configure/cnf-settings/import-cnf",
    allowedpermissions: [
      EXIM_CONFIGURE_VIEW_PERMISSION,
      EXIM_CONFIGURE_CREATE_PERMISSION,
      EXIM_CONFIGURE_EDIT_PERMISSION,
      EXIM_CONFIGURE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/configure/cnf-settings/export-cnf",
    name: "/import-export-expense-tracking/configure/cnf-settings/export-cnf",
    component: <ExportCnfExpenditure />,
    layout: "/import-export-expense-tracking/configure/cnf-settings/export-cnf",
    allowedpermissions: [
      EXIM_CONFIGURE_VIEW_PERMISSION,
      EXIM_CONFIGURE_CREATE_PERMISSION,
      EXIM_CONFIGURE_EDIT_PERMISSION,
      EXIM_CONFIGURE_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
    name: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
    component: <ImportCnfBillList />,
    layout: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill",
    allowedpermissions: [
      EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
      EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
      EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
      EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/add",
    name: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/add",
    component: <AddImportCnfBill />,
    layout: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/add",
    allowedpermissions: [EXTERNAL_CNF_BILLS_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/edit/:importCnfBillId",
    name: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/edit",
    component: <UpdateImportCnfBill />,
    layout: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/edit",
    allowedpermissions: [EXTERNAL_CNF_BILLS_EDIT_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/view/:importCnfBillId",
    name: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/view",
    component: <ViewImportCnfBill />,
    layout: "/import-export-expense-tracking/external-cnf-bills/import-cnf-bill/view",
    allowedpermissions: [EXTERNAL_CNF_BILLS_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
    name: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
    component: <ExportCnfBillList />,
    layout: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
    allowedpermissions: [
      EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
      EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
      EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
      EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/add",
    name: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/add",
    component: <AddExportCnfBill />,
    layout: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/add",
    allowedpermissions: [EXTERNAL_CNF_BILLS_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/edit/:exportCnfBillId",
    name: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/edit",
    component: <UpdateExportCnfBill />,
    layout: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/edit",
    allowedpermissions: [EXTERNAL_CNF_BILLS_EDIT_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/view/:exportCnfBillId",
    name: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/view",
    component: <ViewExportCnfBill />,
    layout: "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill/view",
    allowedpermissions: [EXTERNAL_CNF_BILLS_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/prepare-billing",
    name: "/import-export-expense-tracking/external-cnf-bills/prepare-billing",
    component: <PrepareBillingList />,
    layout: "/import-export-expense-tracking/external-cnf-bills/prepare-billing",
    allowedpermissions: [
      EXTERNAL_CNF_BILLS_VIEW_PERMISSION,
      EXTERNAL_CNF_BILLS_CREATE_PERMISSION,
      EXTERNAL_CNF_BILLS_EDIT_PERMISSION,
      EXTERNAL_CNF_BILLS_DELETE_PERMISSION,
    ],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/add",
    name: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/add",
    component: <AddPrepareBilling />,
    layout: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/add",
    allowedpermissions: [EXTERNAL_CNF_BILLS_CREATE_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/edit/:prepareBillingId",
    name: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/edit",
    component: <UpdatePrepareBilling />,
    layout: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/edit",
    allowedpermissions: [EXTERNAL_CNF_BILLS_EDIT_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/view/:prepareBillingId",
    name: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/view",
    component: <ViewPrepareBilling />,
    layout: "/import-export-expense-tracking/external-cnf-bills/prepare-billing/view",
    allowedpermissions: [EXTERNAL_CNF_BILLS_VIEW_PERMISSION],
  },
  {
    path: "/import-export-expense-tracking/lien-cost",
    name: "/import-export-expense-tracking/lien-cost",
    component: <LienCost />,
    layout: "/import-export-expense-tracking/lien-cost",
    allowedpermissions: [
      SALES_CONTRACT_LIEN_COST_VIEW_PERMISSION,
      SALES_CONTRACT_LIEN_COST_CREATE_PERMISSION,
      SALES_CONTRACT_LIEN_COST_EDIT_PERMISSION,
      SALES_CONTRACT_LIEN_COST_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/lien-cost/add",
    name: "/import-export-expense-tracking/lien-cost/add",
    component: <AddLienCost />,
    layout: "/import-export-expense-tracking/lien-cost/add",
    allowedpermissions: [SALES_CONTRACT_LIEN_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/lien-cost/edit/:lienCostId",
    name: "/import-export-expense-tracking/lien-cost/edit",
    component: <UpdateLienCost />,
    layout: "/import-export-expense-tracking/lien-cost/edit",
    allowedpermissions: [SALES_CONTRACT_LIEN_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/lien-cost/view/:lienCostId",
    name: "/import-export-expense-tracking/lien-cost/view",
    component: <ViewLienCost />,
    layout: "/import-export-expense-tracking/lien-cost/view",
    allowedpermissions: [SALES_CONTRACT_LIEN_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/eb-collection-charge",
    name: "/import-export-expense-tracking/eb-collection-charge",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <EbCollectionCharge />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/eb-collection-charge",
    allowedpermissions: [
      EB_COLLECTION_CHARGE_VIEW_PERMISSION,
      EB_COLLECTION_CHARGE_CREATE_PERMISSION,
      EB_COLLECTION_CHARGE_EDIT_PERMISSION,
      EB_COLLECTION_CHARGE_DELETE_PERMISSION,
      EB_COLLECTION_CHARGE_PRINT_PERMISSION,
    ],
    analytics: {
      event_type: "eb-collection-charge",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/eb-collection-charge/add",
    name: "/import-export-expense-tracking/eb-collection-charge/add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddEbCollectionCharge />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/eb-collection-charge/add",
    allowedpermissions: [EB_COLLECTION_CHARGE_CREATE_PERMISSION],
    analytics: {
      event_type: "eb-collection-charge",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/eb-collection-charge/edit/:ebCollectionChargeId",
    name: "/import-export-expense-tracking/eb-collection-charge/edit",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateEbCollectionCharge />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/eb-collection-charge/edit",
    allowedpermissions: [EB_COLLECTION_CHARGE_EDIT_PERMISSION],
    analytics: {
      event_type: "eb-collection-charge",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/eb-collection-charge/view/:ebCollectionChargeId",
    name: "/import-export-expense-tracking/eb-collection-charge/view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewEbCollectionCharge />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/eb-collection-charge/view",
    allowedpermissions: [EB_COLLECTION_CHARGE_VIEW_PERMISSION],
    analytics: {
      event_type: "eb-collection-charge",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/amendment-lien-cost",
    name: "/import-export-expense-tracking/amendment-lien-cost",
    component: <AmendmentLienCost />,
    layout: "/import-export-expense-tracking/amendment-lien-cost",
    allowedpermissions: [
      SALES_CONTRACT_AMENDMENT_LIEN_COST_VIEW_PERMISSION,
      SALES_CONTRACT_AMENDMENT_LIEN_COST_CREATE_PERMISSION,
      SALES_CONTRACT_AMENDMENT_LIEN_COST_EDIT_PERMISSION,
      SALES_CONTRACT_AMENDMENT_LIEN_COST_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "amendment-lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/amendment-lien-cost/add",
    name: "/import-export-expense-tracking/amendment-lien-cost/add",
    component: <AddAmendmentLienCost />,
    layout: "/import-export-expense-tracking/amendment-lien-cost/add",
    allowedpermissions: [SALES_CONTRACT_AMENDMENT_LIEN_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "amendment-lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/amendment-lien-cost/edit/:amendmentLienCostId",
    name: "/import-export-expense-tracking/amendment-lien-cost/edit",
    component: <UpdateAmendmentLienCost />,
    layout: "/import-export-expense-tracking/amendment-lien-cost/edit",
    allowedpermissions: [SALES_CONTRACT_AMENDMENT_LIEN_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "amendment-lien-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/amendment-lien-cost/view/:amendmentLienCostId",
    name: "/import-export-expense-tracking/amendment-lien-cost/view",
    component: <ViewAmendmentLienCost />,
    layout: "/import-export-expense-tracking/amendment-lien-cost/view",
    allowedpermissions: [SALES_CONTRACT_AMENDMENT_LIEN_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "amendment-lien-cost",
      action_type: "view",
    },
  },
  // BGMEA UD Cost Routes
  {
    path: "/import-export-expense-tracking/bgmea-ud-cost",
    name: "/import-export-expense-tracking/bgmea-ud-cost",
    component: <BgmeaUdCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-cost",
    allowedpermissions: [
      BGMEA_UD_COST_VIEW_PERMISSION,
      BGMEA_UD_COST_CREATE_PERMISSION,
      BGMEA_UD_COST_EDIT_PERMISSION,
      BGMEA_UD_COST_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "bgmea-ud-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-cost/add",
    name: "/import-export-expense-tracking/bgmea-ud-cost/add",
    component: <AddBgmeaUdCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-cost/add",
    allowedpermissions: [BGMEA_UD_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-cost/edit/:bgmeaUdCostId",
    name: "/import-export-expense-tracking/bgmea-ud-cost/edit",
    component: <UpdateBgmeaUdCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-cost/edit",
    allowedpermissions: [BGMEA_UD_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-cost/view/:bgmeaUdCostId",
    name: "/import-export-expense-tracking/bgmea-ud-cost/view",
    component: <ViewBgmeaUdCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-cost/view",
    allowedpermissions: [BGMEA_UD_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-cost",
      action_type: "view",
    },
  },
  // BGMEA UD Amendment Routes
  {
    path: "/import-export-expense-tracking/bgmea-ud-amendment",
    name: "/import-export-expense-tracking/bgmea-ud-amendment",
    component: <BgmeaUdAmendment />,
    layout: "/import-export-expense-tracking/bgmea-ud-amendment",
    allowedpermissions: [
      BGMEA_UD_AMENDMENT_VIEW_PERMISSION,
      BGMEA_UD_AMENDMENT_CREATE_PERMISSION,
      BGMEA_UD_AMENDMENT_EDIT_PERMISSION,
      BGMEA_UD_AMENDMENT_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "bgmea-ud-amendment",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-amendment/add",
    name: "/import-export-expense-tracking/bgmea-ud-amendment/add",
    component: <AddBgmeaUdAmendment />,
    layout: "/import-export-expense-tracking/bgmea-ud-amendment/add",
    allowedpermissions: [BGMEA_UD_AMENDMENT_CREATE_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-amendment",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-amendment/edit/:bgmeaUdAmendmentId",
    name: "/import-export-expense-tracking/bgmea-ud-amendment/edit",
    component: <UpdateBgmeaUdAmendment />,
    layout: "/import-export-expense-tracking/bgmea-ud-amendment/edit",
    allowedpermissions: [BGMEA_UD_AMENDMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-amendment",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-amendment/view/:bgmeaUdAmendmentId",
    name: "/import-export-expense-tracking/bgmea-ud-amendment/view",
    component: <ViewBgmeaUdAmendment />,
    layout: "/import-export-expense-tracking/bgmea-ud-amendment/view",
    allowedpermissions: [BGMEA_UD_AMENDMENT_VIEW_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-amendment",
      action_type: "view",
    },
  },
  // BGMEA UD Export Permission Cost Routes
  {
    path: "/import-export-expense-tracking/bgmea-ud-export-permission-cost",
    name: "/import-export-expense-tracking/bgmea-ud-export-permission-cost",
    component: <BgmeaUdExportPermissionCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-export-permission-cost",
    allowedpermissions: [
      BGMEA_UD_EXPORT_PERMISSION_COST_VIEW_PERMISSION,
      BGMEA_UD_EXPORT_PERMISSION_COST_CREATE_PERMISSION,
      BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_PERMISSION,
      BGMEA_UD_EXPORT_PERMISSION_COST_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "bgmea-ud-export-permission-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/add",
    name: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/add",
    component: <AddBgmeaUdExportPermissionCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/add",
    allowedpermissions: [BGMEA_UD_EXPORT_PERMISSION_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-export-permission-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/edit/:bgmeaUdExportPermissionCostId",
    name: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/edit",
    component: <UpdateBgmeaUdExportPermissionCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/edit",
    allowedpermissions: [BGMEA_UD_EXPORT_PERMISSION_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-export-permission-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/view/:bgmeaUdExportPermissionCostId",
    name: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/view",
    component: <ViewBgmeaUdExportPermissionCost />,
    layout: "/import-export-expense-tracking/bgmea-ud-export-permission-cost/view",
    allowedpermissions: [BGMEA_UD_EXPORT_PERMISSION_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "bgmea-ud-export-permission-cost",
      action_type: "view",
    },
  },
  // Marine Cover Note Bill Routes
  {
    path: "/import-export-expense-tracking/marine-cover-note-bill",
    name: "/import-export-expense-tracking/marine-cover-note-bill",
    component: <MarinaCoverNoteBill />,
    layout: "/import-export-expense-tracking/marine-cover-note-bill",
    allowedpermissions: [
      MARINA_COVER_NOTE_BILL_VIEW_PERMISSION,
      MARINA_COVER_NOTE_BILL_CREATE_PERMISSION,
      MARINA_COVER_NOTE_BILL_EDIT_PERMISSION,
      MARINA_COVER_NOTE_BILL_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "marine-cover-note-bill",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/marine-cover-note-bill/add",
    name: "/import-export-expense-tracking/marine-cover-note-bill/add",
    component: <AddMarinaCoverNoteBill />,
    layout: "/import-export-expense-tracking/marine-cover-note-bill/add",
    allowedpermissions: [MARINA_COVER_NOTE_BILL_CREATE_PERMISSION],
    analytics: {
      event_type: "marine-cover-note-bill",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/marine-cover-note-bill/edit/:marinaCoverNoteBillId",
    name: "/import-export-expense-tracking/marine-cover-note-bill/edit",
    component: <UpdateMarinaCoverNoteBill />,
    layout: "/import-export-expense-tracking/marine-cover-note-bill/edit",
    allowedpermissions: [MARINA_COVER_NOTE_BILL_EDIT_PERMISSION],
    analytics: {
      event_type: "marine-cover-note-bill",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/marine-cover-note-bill/view/:marinaCoverNoteBillId",
    name: "/import-export-expense-tracking/marine-cover-note-bill/view",
    component: <ViewMarinaCoverNoteBill />,
    layout: "/import-export-expense-tracking/marine-cover-note-bill/view",
    allowedpermissions: [MARINA_COVER_NOTE_BILL_VIEW_PERMISSION],
    analytics: {
      event_type: "marine-cover-note-bill",
      action_type: "view",
    },
  },
  // B2B LC Opening Cost Routes
  {
    path: "/import-export-expense-tracking/b2b-lc-opening-cost",
    name: "/import-export-expense-tracking/b2b-lc-opening-cost",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <B2BLcOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-opening-cost",
    allowedpermissions: [B2B_LC_OPENING_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-opening-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-opening-cost/add",
    name: "/import-export-expense-tracking/b2b-lc-opening-cost/add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddB2BLcOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-opening-cost/add",
    allowedpermissions: [B2B_LC_OPENING_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "b2b-lc-opening-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-opening-cost/edit/:b2bLcOpeningCostId",
    name: "/import-export-expense-tracking/b2b-lc-opening-cost/edit",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateB2BLcOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-opening-cost/edit",
    allowedpermissions: [B2B_LC_OPENING_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "b2b-lc-opening-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-opening-cost/view/:b2bLcOpeningCostId",
    name: "/import-export-expense-tracking/b2b-lc-opening-cost/view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewB2BLcOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-opening-cost/view",
    allowedpermissions: [B2B_LC_OPENING_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-opening-cost",
      action_type: "view",
    },
  },
  // B2B LC Amendment Opening Cost Routes
  {
    path: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost",
    name: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <B2BLcAmendmentOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost",
    allowedpermissions: [B2B_LC_AMENDMENT_OPENING_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-amendment-opening-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/add",
    name: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddB2BLcAmendmentOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/add",
    allowedpermissions: [B2B_LC_AMENDMENT_OPENING_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "b2b-lc-amendment-opening-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/edit/:b2bLcAmendmentOpeningCostId",
    name: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/edit",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateB2BLcAmendmentOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/edit",
    allowedpermissions: [B2B_LC_AMENDMENT_OPENING_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "b2b-lc-amendment-opening-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/view/:b2bLcAmendmentOpeningCostId",
    name: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewB2BLcAmendmentOpeningCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-amendment-opening-cost/view",
    allowedpermissions: [B2B_LC_AMENDMENT_OPENING_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-amendment-opening-cost",
      action_type: "view",
    },
  },
  // B2B LC Shipping Guarantee Cost Routes
  {
    path: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost",
    name: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <B2BLcShippingGuaranteeCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost",
    allowedpermissions: [B2B_LC_SHIPPING_GUARANTEE_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-shipping-guarantee-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/add",
    name: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddB2BLcShippingGuaranteeCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/add",
    allowedpermissions: [B2B_LC_SHIPPING_GUARANTEE_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "b2b-lc-shipping-guarantee-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/edit/:b2bLcShippingGuaranteeCostId",
    name: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/edit",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateB2BLcShippingGuaranteeCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/edit",
    allowedpermissions: [B2B_LC_SHIPPING_GUARANTEE_COST_EDIT_PERMISSION],
    analytics: {
      event_type: "b2b-lc-shipping-guarantee-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/view/:b2bLcShippingGuaranteeCostId",
    name: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewB2BLcShippingGuaranteeCost />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-shipping-guarantee-cost/view",
    allowedpermissions: [B2B_LC_SHIPPING_GUARANTEE_COST_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-shipping-guarantee-cost",
      action_type: "view",
    },
  },
  // B2B LC Acceptance Commission Routes
  {
    path: "/import-export-expense-tracking/b2b-lc-acceptance-commission",
    name: "/import-export-expense-tracking/b2b-lc-acceptance-commission",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <B2BLcAcceptanceCommission />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-acceptance-commission",
    allowedpermissions: [B2B_LC_ACCEPTANCE_COMMISSION_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-acceptance-commission",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-acceptance-commission/add",
    name: "/import-export-expense-tracking/b2b-lc-acceptance-commission/add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddB2BLcAcceptanceCommission />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-acceptance-commission/add",
    allowedpermissions: [B2B_LC_ACCEPTANCE_COMMISSION_CREATE_PERMISSION],
    analytics: {
      event_type: "b2b-lc-acceptance-commission",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-acceptance-commission/edit/:b2bLcAcceptanceCommissionId",
    name: "/import-export-expense-tracking/b2b-lc-acceptance-commission/edit",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateB2BLcAcceptanceCommission />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-acceptance-commission/edit",
    allowedpermissions: [B2B_LC_ACCEPTANCE_COMMISSION_EDIT_PERMISSION],
    analytics: {
      event_type: "b2b-lc-acceptance-commission",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/b2b-lc-acceptance-commission/view/:b2bLcAcceptanceCommissionId",
    name: "/import-export-expense-tracking/b2b-lc-acceptance-commission/view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewB2BLcAcceptanceCommission />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/b2b-lc-acceptance-commission/view",
    allowedpermissions: [B2B_LC_ACCEPTANCE_COMMISSION_VIEW_PERMISSION],
    analytics: {
      event_type: "b2b-lc-acceptance-commission",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-cost",
    name: "/import-export-expense-tracking/iou-cost",
    component: <IOUCost />,
    layout: "/import-export-expense-tracking/iou-cost",
    allowedpermissions: [IOU_VIEW_PERMISSION],
    analytics: {
      event_type: "iou-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-cost/add",
    name: "/import-export-expense-tracking/iou-cost/add",
    component: <AddIOUCost />,
    layout: "/import-export-expense-tracking/iou-cost/add",
    allowedpermissions: [IOU_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-cost/edit/:iouCostId",
    name: "/import-export-expense-tracking/iou-cost/edit",
    component: <UpdateIOUCost viewMode={false} mode="update" />,
    layout: "/import-export-expense-tracking/iou-cost/edit",
    allowedpermissions: [IOU_EDIT_PERMISSION],
    analytics: {
      event_type: "iou-cost",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-cost/view/:iouCostId",
    name: "/import-export-expense-tracking/iou-cost/view",
    component: <ViewIOUCost />,
    layout: "/import-export-expense-tracking/iou-cost/view",
    allowedpermissions: [IOU_VIEW_PERMISSION],
    analytics: {
      event_type: "iou-cost",
      action_type: "view",
    },
  },

  {
    path: "/import-export-expense-tracking/iou-disbursement",
    name: "/import-export-expense-tracking/iou-disbursement",
    component: <IOUDisbursement />,
    layout: "/import-export-expense-tracking/iou-disbursement",
    allowedpermissions: [IOU_DISBURSE_PERMISSION],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-disbursement/add",
    name: "/import-export-expense-tracking/iou-disbursement/add",
    component: <AddIOUDisbursement />,
    layout: "/import-export-expense-tracking/iou-disbursement/add",
    allowedpermissions: [SALES_CONTRACT_IOU_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-disbursement/edit/:iouCostId",
    name: "/import-export-expense-tracking/iou-disbursement/edit",
    component: <UpdateIOUDisbursement viewMode={false} mode="update" />,
    layout: "/import-export-expense-tracking/iou-disbursement/edit",
    allowedpermissions: [IOU_DISBURSE_PERMISSION],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-disbursement/view/:iouCostId",
    name: "/import-export-expense-tracking/iou-disbursement/view",
    component: <ViewIOUDisbursement />,
    layout: "/import-export-expense-tracking/iou-cost/view",
    allowedpermissions: [IOU_DISBURSE_PERMISSION],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },

  {
    path: "/import-export-expense-tracking/iou-documents-upload",
    name: "/import-export-expense-tracking/iou-documents-upload",
    component: <IOUDocuments />,
    layout: "/import-export-expense-tracking/iou-documents-upload",
    allowedpermissions: [IOU_DISBURSE_PERMISSION],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-documents-upload/add",
    name: "/import-export-expense-tracking/iou-documents-upload/add",
    component: <AddIOUDocuments />,
    layout: "/import-export-expense-tracking/iou-documents-upload/add",
    allowedpermissions: [SALES_CONTRACT_IOU_COST_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-documents-upload/edit/:iouCostId",
    name: "/import-export-expense-tracking/iou-documents-upload/edit",
    component: <UpdateIOUDocuments viewMode={false} mode="update" />,
    layout: "/import-export-expense-tracking/iou-documents-upload/edit",
    allowedpermissions: [IOU_DISBURSE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-documents-upload/view/:iouCostId",
    name: "/import-export-expense-tracking/iou-documents-upload/view",
    component: <ViewIOUDocuments />,
    layout: "/import-export-expense-tracking/iou-documents-upload/view",
    allowedpermissions: [IOU_DISBURSE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },

  {
    path: "/import-export-expense-tracking/export-doc-fee",
    name: "/import-export-expense-tracking/export-doc-fee",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ExportDocumentationFee />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/export-doc-fee",
    allowedpermissions: [
      EXPORT_DOC_FEE_VIEW_PERMISSION,
      EXPORT_DOC_FEE_CREATE_PERMISSION,
      EXPORT_DOC_FEE_EDIT_PERMISSION,
      EXPORT_DOC_FEE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "export-documentation-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/export-doc-fee/add",
    name: "/import-export-expense-tracking/export-doc-fee/add",
    component: <AddExportDocumentationFee />,
    layout: "/import-export-expense-tracking/export-doc-fee/add",
    allowedpermissions: [EXPORT_DOC_FEE_CREATE_PERMISSION],
    analytics: {
      event_type: "export-documentation-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/export-doc-fee/edit/:exportDocFeeId",
    name: "/import-export-expense-tracking/export-doc-fee/edit",
    component: <UpdateExportDocumentationFee />,
    layout: "/import-export-expense-tracking/export-doc-fee/edit",
    allowedpermissions: [EXPORT_DOC_FEE_EDIT_PERMISSION],
    analytics: {
      event_type: "export-documentation-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/export-doc-fee/view/:exportDocFeeId",
    name: "/import-export-expense-tracking/export-doc-fee/view",
    component: <ViewExportDocumentationFee />,
    layout: "/import-export-expense-tracking/export-doc-fee/view",
    allowedpermissions: [EXPORT_DOC_FEE_VIEW_PERMISSION],
    analytics: {
      event_type: "export-documentation-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/certificate-of-origin-fee",
    name: "/import-export-expense-tracking/certificate-of-origin-fee",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <CertificateOfOriginFee />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/certificate-of-origin-fee",
    allowedpermissions: [
      CERTIFICATE_OF_ORIGIN_FEE_VIEW_PERMISSION,
      CERTIFICATE_OF_ORIGIN_FEE_CREATE_PERMISSION,
      CERTIFICATE_OF_ORIGIN_FEE_EDIT_PERMISSION,
      CERTIFICATE_OF_ORIGIN_FEE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "certificate-of-origin-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/certificate-of-origin-fee/add",
    name: "/import-export-expense-tracking/certificate-of-origin-fee/add",
    component: <AddCertificateOfOriginFee />,
    layout: "/import-export-expense-tracking/certificate-of-origin-fee/add",
    allowedpermissions: [CERTIFICATE_OF_ORIGIN_FEE_CREATE_PERMISSION],
    analytics: {
      event_type: "certificate-of-origin-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/certificate-of-origin-fee/edit/:certificateOfOriginFeeId",
    name: "/import-export-expense-tracking/certificate-of-origin-fee/edit",
    component: <UpdateCertificateOfOriginFee />,
    layout: "/import-export-expense-tracking/certificate-of-origin-fee/edit",
    allowedpermissions: [CERTIFICATE_OF_ORIGIN_FEE_EDIT_PERMISSION],
    analytics: {
      event_type: "certificate-of-origin-fee",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/certificate-of-origin-fee/view/:certificateOfOriginFeeId",
    name: "/import-export-expense-tracking/certificate-of-origin-fee/view",
    component: <ViewCertificateOfOriginFee />,
    layout: "/import-export-expense-tracking/certificate-of-origin-fee/view",
    allowedpermissions: [CERTIFICATE_OF_ORIGIN_FEE_VIEW_PERMISSION],
    analytics: {
      event_type: "certificate-of-origin-fee",
      action_type: "view",
    },
  },
  // Import Bill Retirement Auth Routes
  {
    path: "/import-export-expense-tracking/import-bill-retirement",
    name: "/import-export-expense-tracking/import-bill-retirement",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ImportBillRetirement />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-bill-retirement",
    allowedpermissions: [IMPORT_BILL_RETIREMENT_VIEW_PERMISSION],
    analytics: {
      event_type: "import-bill-retirement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/import-bill-retirement/add",
    name: "/import-export-expense-tracking/import-bill-retirement/add",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddImportBillRetirement />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-bill-retirement/add",
    allowedpermissions: [IMPORT_BILL_RETIREMENT_CREATE_PERMISSION],
    analytics: {
      event_type: "import-bill-retirement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/import-bill-retirement/edit/:importBillRetirementId",
    name: "/import-export-expense-tracking/import-bill-retirement/edit",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateImportBillRetirement />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-bill-retirement/edit",
    allowedpermissions: [IMPORT_BILL_RETIREMENT_EDIT_PERMISSION],
    analytics: {
      event_type: "import-bill-retirement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/import-bill-retirement/view/:importBillRetirementId",
    name: "/import-export-expense-tracking/import-bill-retirement/view",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewImportBillRetirement />
      </Suspense>
    ),
    layout: "/import-export-expense-tracking/import-bill-retirement/view",
    allowedpermissions: [IMPORT_BILL_RETIREMENT_VIEW_PERMISSION],
    analytics: {
      event_type: "import-bill-retirement",
      action_type: "view",
    },
  },

  {
    path: "/digitalization/folding-requirement",
    name: "/digitalization/folding-requirement",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <FoldingRequirement />
      </Suspense>
    ),
    layout: "/digitalization/folding-requirement",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/digitalization/folding-requirement/create",
    name: "/digitalization/folding-requirement/create",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddFoldingRequirement />
      </Suspense>
    ),
    layout: "/digitalization/folding-requirement/create",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/digitalization/folding-requirement/view/:id",
    name: "/digitalization/folding-requirement/view/:id",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewFoldingRequirement />
      </Suspense>
    ),
    layout: "/digitalization/folding-requirement/view/:id",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },
  {
    path: "/digitalization/folding-requirement/edit/:id",
    name: "/digitalization/folding-requirement/edit/:id",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateFoldingRequirement />
      </Suspense>
    ),
    layout: "/digitalization/folding-requirement/edit/:id",
    allowedpermissions: [NO_PERMISSION_REQUIRED],
  },

  {
    path: "/digitalization/hourly-operation-tracking",
    name: "/digitalization/hourly-operation-tracking",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <HourlyOperationTracking />
      </Suspense>
    ),
    layout: "/digitalization/hourly-operation-tracking",
    allowedpermissions: [HOURLY_OPERATION_TRACKING_VIEW_PERMISSION],
  },
  {
    path: "/digitalization/hourly-operation-tracking/create",
    name: "/digitalization/hourly-operation-tracking/create",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <AddHourlyOperationTracking />
      </Suspense>
    ),
    layout: "/digitalization/hourly-operation-tracking/create",
    allowedpermissions: [HOURLY_OPERATION_TRACKING_CREATE_PERMISSION],
  },
  {
    path: "/digitalization/hourly-operation-tracking/view/:id",
    name: "/digitalization/hourly-operation-tracking/view/:id",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <ViewHourlyOperationTracking />
      </Suspense>
    ),
    layout: "/digitalization/hourly-operation-tracking/view/:id",
    allowedpermissions: [HOURLY_OPERATION_TRACKING_VIEW_PERMISSION],
  },
  {
    path: "/digitalization/hourly-operation-tracking/edit/:id",
    name: "/digitalization/hourly-operation-tracking/edit/:id",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <UpdateHourlyOperationTracking />
      </Suspense>
    ),
    layout: "/digitalization/hourly-operation-tracking/edit/:id",
    allowedpermissions: [HOURLY_OPERATION_TRACKING_EDIT_PERMISSION],
  },

  {
    path: "/digitalization/packing/confirmation",
    name: "hourly-packing-confirmation-list",
    component: <HourlyPackingConfirmationList width={window.innerWidth} />,
    allowedpermissions: [
      PACKING_VIEW_PERMISSION,
      PACKING_CREATE_PERMISSION,
      PACKING_EDIT_PERMISSION,
      PACKING_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "hourly-packing-confirmation",
      action_type: "list",
    },
  },
  {
    path: "/digitalization/packing/confirmation/edit/:id",
    name: "hourly-packing-confirmation-edit",
    component: <HourlyPackingConfirmation isEdit={true} />,
    allowedpermissions: [PACKING_VIEW_PERMISSION, PACKING_EDIT_PERMISSION],
    analytics: {
      event_type: "hourly-packing-confirmation",
      action_type: "edit",
    },
  },

  {
    path: "/import-export-expense-tracking/iou-adjustment-for-export",
    name: "/import-export-expense-tracking/iou-adjustment-for-export",
    component: <IOUAdjustmentExport />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-export",
    allowedpermissions: [
      IOU_ADJUSTMENT_EXPORT_VIEW_PERMISSION,
      IOU_ADJUSTMENT_EXPORT_CREATE_PERMISSION,
      IOU_ADJUSTMENT_EXPORT_EDIT_PERMISSION,
      IOU_ADJUSTMENT_EXPORT_DELETE_PERMISSION,
      IOU_ADJUSTMENT_EXPORT_APPROVE_PERMISSION,
    ],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-export/add",
    name: "/import-export-expense-tracking/iou-adjustment-for-export/add",
    component: <AddIOUAdjustmentExport />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-export/add",
    allowedpermissions: [IOU_ADJUSTMENT_EXPORT_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-export/edit/:iouCostId",
    name: "/import-export-expense-tracking/iou-adjustment-for-export/edit",
    component: <UpdateIOUAdjustmentExport viewMode={false} mode="update" />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-export/edit",
    allowedpermissions: [IOU_ADJUSTMENT_EXPORT_EDIT_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-export/view/:iouCostId",
    name: "/import-export-expense-tracking/iou-adjustment-for-export/view",
    component: <ViewIOUAdjustmentExport />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-export/view",
    allowedpermissions: [IOU_ADJUSTMENT_EXPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },

  {
    path: "/import-export-expense-tracking/iou-adjustment-for-general",
    name: "/import-export-expense-tracking/iou-adjustment-for-general",
    component: <IOUAdjustmentGeneral />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-general",
    allowedpermissions: [
      IOU_ADJUSTMENT_GENERAL_VIEW_PERMISSION,
      IOU_ADJUSTMENT_GENERAL_CREATE_PERMISSION,
      IOU_ADJUSTMENT_GENERAL_EDIT_PERMISSION,
      IOU_ADJUSTMENT_GENERAL_DELETE_PERMISSION,
      IOU_ADJUSTMENT_GENERAL_APPROVE_PERMISSION,
    ],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-general/add",
    name: "/import-export-expense-tracking/iou-adjustment-for-general/add",
    component: <AddIOUAdjustmentGeneral />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-general/add",
    allowedpermissions: [IOU_ADJUSTMENT_GENERAL_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-general/edit/:iouCostId",
    name: "/import-export-expense-tracking/iou-adjustment-for-general/edit",
    component: <UpdateIOUAdjustmentGeneral viewMode={false} mode="update" />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-general/edit",
    allowedpermissions: [IOU_ADJUSTMENT_GENERAL_EDIT_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-general/view/:iouCostId",
    name: "/import-export-expense-tracking/iou-adjustment-for-general/view",
    component: <ViewIOUAdjustmentGeneral />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-general/view",
    allowedpermissions: [IOU_ADJUSTMENT_GENERAL_VIEW_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },

  {
    path: "/import-export-expense-tracking/iou-adjustment-for-import",
    name: "/import-export-expense-tracking/iou-adjustment-for-import",
    component: <IOUAdjustmentImport />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-import",
    allowedpermissions: [
      IOU_ADJUSTMENT_IMPORT_VIEW_PERMISSION,
      IOU_ADJUSTMENT_IMPORT_CREATE_PERMISSION,
      IOU_ADJUSTMENT_IMPORT_EDIT_PERMISSION,
      IOU_ADJUSTMENT_IMPORT_DELETE_PERMISSION,
      IOU_ADJUSTMENT_IMPORT_APPROVE_PERMISSION,
    ],
    analytics: {
      event_type: "iou-disbursement",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-import/add",
    name: "/import-export-expense-tracking/iou-adjustment-for-import/add",
    component: <AddIOUAdjustmentImport />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-import/add",
    allowedpermissions: [IOU_ADJUSTMENT_IMPORT_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-import/edit/:iouCostId",
    name: "/import-export-expense-tracking/iou-adjustment-for-import/edit",
    component: <UpdateIOUAdjustmentImport viewMode={false} mode="update" />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-import/edit",
    allowedpermissions: [IOU_ADJUSTMENT_IMPORT_EDIT_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/import-export-expense-tracking/iou-adjustment-for-import/view/:iouCostId",
    name: "/import-export-expense-tracking/iou-adjustment-for-import/view",
    component: <ViewIOUAdjustmentImport />,
    layout: "/import-export-expense-tracking/iou-adjustment-for-import/view",
    allowedpermissions: [IOU_ADJUSTMENT_IMPORT_VIEW_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/carton-booking",
    name: "/carton-booking",
    component: <CartonBooking />,
    layout: "/carton-booking",
    allowedpermissions: [
      BOOKING_CARTON_VIEW_PERMISSION,
      BOOKING_CARTON_CREATE_PERMISSION,
      BOOKING_CARTON_EDIT_PERMISSION,
      BOOKING_CARTON_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "carton-booking/create",
    name: "carton-booking/create",
    component: <CreateCartonBooking />,
    layout: "/carton-booking/create",
    allowedpermissions: [BOOKING_CARTON_CREATE_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "carton-booking/edit/:id",
    name: "carton-booking/edit",
    component: <EditCartonBooking viewMode={false} mode="update" />,
    layout: "/carton-booking/edit",
    allowedpermissions: [BOOKING_CARTON_EDIT_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "carton-booking/view/:id",
    name: "carton-booking/view",
    component: <EditCartonBooking viewMode={true} mode="view" />,
    layout: "/carton-booking/view",
    allowedpermissions: [BOOKING_CARTON_VIEW_PERMISSION],
    analytics: {
      event_type: "iou-documents-upload",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/sample-requisition",
    name: "/merchandising/sample-requisition",
    component: <SampleRequisition />,
    layout: "/merchandising/sample-requisition",
    allowedpermissions: [
      SAMPLE_REQUISITION_VIEW_PERMISSION,
      SAMPLE_REQUISITION_CREATE_PERMISSION,
      SAMPLE_REQUISITION_EDIT_PERMISSION,
      SAMPLE_REQUISITION_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "sample-requisition",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/sample-requisition/create",
    name: "/merchandising/sample-requisition/create",
    component: <SampleRequisitionForm key="create" mode="create" />,
    layout: "/merchandising/sample-requisition/create",
    allowedpermissions: [SAMPLE_REQUISITION_CREATE_PERMISSION],
    analytics: {
      event_type: "sample-requisition",
      action_type: "create",
    },
  },
  {
    path: "/merchandising/sample-requisition/edit/:id",
    name: "/merchandising/sample-requisition/edit",
    component: <SampleRequisitionForm key="edit" mode="edit" />,
    layout: "/merchandising/sample-requisition/edit",
    allowedpermissions: [SAMPLE_REQUISITION_EDIT_PERMISSION],
    analytics: {
      event_type: "sample-requisition",
      action_type: "edit",
    },
  },
  {
    path: "/merchandising/sample-requisition/view/:id",
    name: "/merchandising/sample-requisition/view",
    component: <SampleRequisitionForm key="view" mode="view" />,
    layout: "/merchandising/sample-requisition/view",
    allowedpermissions: [SAMPLE_REQUISITION_VIEW_PERMISSION],
    analytics: {
      event_type: "sample-requisition",
      action_type: "view",
    },
  },
  {
    path: "/merchandising/sample-type",
    name: "/merchandising/sample-type",
    component: <SampleTypeConfig />,
    layout: "/merchandising/sample-type",
    allowedpermissions: [
      SAMPLE_TYPE_VIEW_PERMISSION,
      SAMPLE_TYPE_CREATE_PERMISSION,
      SAMPLE_TYPE_EDIT_PERMISSION,
      SAMPLE_TYPE_DELETE_PERMISSION,
    ],
    analytics: {
      event_type: "sample-type",
      action_type: "view",
    },
  },
  // Transportation Cost
  {
    path: "/transportation-cost/config/particular-rate",
    name: "/transportation-cost/config/particular-rate",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <TransportParticularRate />
      </Suspense>
    ),
    layout: "/transportation-cost/config/particular-rate",
    allowedpermissions: [
      TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
      TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
      TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
      TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
    ],
  },
  {
    path: "/transportation-cost/config/charge-type",
    name: "/transportation-cost/config/charge-type",
    component: (
      <Suspense fallback={<LoadingComponent />}>
        <TransportChargeType />
      </Suspense>
    ),
    layout: "/transportation-cost/config/charge-type",
    allowedpermissions: [
      TRANSPORTATION_COST_CONFIG_VIEW_PERMISSION,
      TRANSPORTATION_COST_CONFIG_CREATE_PERMISSION,
      TRANSPORTATION_COST_CONFIG_EDIT_PERMISSION,
      TRANSPORTATION_COST_CONFIG_DELETE_PERMISSION,
    ],
  },
  ...["export", "import", "local"].flatMap((costType) => {
    const basePath = `/transportation-cost/${costType}`;
    return [
      {
        path: basePath,
        name: basePath,
        component: (
          <Suspense fallback={<LoadingComponent />}>
            <TransportationCostList key={costType} costType={costType} />
          </Suspense>
        ),
        layout: basePath,
        allowedpermissions: [
          TRANSPORTATION_COST_ENTRY_VIEW_PERMISSION,
          TRANSPORTATION_COST_ENTRY_CREATE_PERMISSION,
          TRANSPORTATION_COST_ENTRY_EDIT_PERMISSION,
          TRANSPORTATION_COST_ENTRY_DELETE_PERMISSION,
          TRANSPORTATION_COST_ENTRY_PRINT_PERMISSION,
        ],
      },
      {
        path: `${basePath}/add`,
        name: `${basePath}/add`,
        component: (
          <Suspense fallback={<LoadingComponent />}>
            <AddTransportationCost key={costType} costType={costType} />
          </Suspense>
        ),
        layout: `${basePath}/add`,
        allowedpermissions: [TRANSPORTATION_COST_ENTRY_CREATE_PERMISSION],
      },
      {
        path: `${basePath}/edit/:transportationCostId`,
        name: `${basePath}/edit`,
        component: (
          <Suspense fallback={<LoadingComponent />}>
            <UpdateTransportationCost key={costType} costType={costType} />
          </Suspense>
        ),
        layout: `${basePath}/edit`,
        allowedpermissions: [TRANSPORTATION_COST_ENTRY_EDIT_PERMISSION],
      },
      {
        path: `${basePath}/view/:transportationCostId`,
        name: `${basePath}/view`,
        component: (
          <Suspense fallback={<LoadingComponent />}>
            <ViewTransportationCost key={costType} costType={costType} />
          </Suspense>
        ),
        layout: `${basePath}/view`,
        allowedpermissions: [TRANSPORTATION_COST_ENTRY_VIEW_PERMISSION],
      },
    ];
  }),
];

AuthRouter = AuthRouter.map((route) => ({
  ...route,
  id: uuidv4(),
}));

export default AuthRouter;
